//THIS FILE IS AUTO GENERATED
//DO NOT EDIT AND DELETE IT

    

      import AboutarSAUrl from "ASSETS_DIR/locales/ar-SA/About.json?url";

      import ArchiveDialogarSAUrl from "ASSETS_DIR/locales/ar-SA/ArchiveDialog.json?url";

      import ArticlearSAUrl from "ASSETS_DIR/locales/ar-SA/Article.json?url";

      import BackupCodesDialogarSAUrl from "ASSETS_DIR/locales/ar-SA/BackupCodesDialog.json?url";

      import ChangeEmailDialogarSAUrl from "ASSETS_DIR/locales/ar-SA/ChangeEmailDialog.json?url";

      import ChangePasswordDialogarSAUrl from "ASSETS_DIR/locales/ar-SA/ChangePasswordDialog.json?url";

      import ChangePhoneDialogarSAUrl from "ASSETS_DIR/locales/ar-SA/ChangePhoneDialog.json?url";

      import ChangePortalOwnerarSAUrl from "ASSETS_DIR/locales/ar-SA/ChangePortalOwner.json?url";

      import ChangeUserStatusDialogarSAUrl from "ASSETS_DIR/locales/ar-SA/ChangeUserStatusDialog.json?url";

      import ChangeUserTypeDialogarSAUrl from "ASSETS_DIR/locales/ar-SA/ChangeUserTypeDialog.json?url";

      import ConnectDialogarSAUrl from "ASSETS_DIR/locales/ar-SA/ConnectDialog.json?url";

      import ConvertDialogarSAUrl from "ASSETS_DIR/locales/ar-SA/ConvertDialog.json?url";

      import ConvertPasswordDialogarSAUrl from "ASSETS_DIR/locales/ar-SA/ConvertPasswordDialog.json?url";

      import CreateEditRoomDialogarSAUrl from "ASSETS_DIR/locales/ar-SA/CreateEditRoomDialog.json?url";

      import DataReassignmentDialogarSAUrl from "ASSETS_DIR/locales/ar-SA/DataReassignmentDialog.json?url";

      import DeleteDialogarSAUrl from "ASSETS_DIR/locales/ar-SA/DeleteDialog.json?url";

      import DeleteProfileEverDialogarSAUrl from "ASSETS_DIR/locales/ar-SA/DeleteProfileEverDialog.json?url";

      import DeleteSelfProfileDialogarSAUrl from "ASSETS_DIR/locales/ar-SA/DeleteSelfProfileDialog.json?url";

      import DeleteThirdPartyDialogarSAUrl from "ASSETS_DIR/locales/ar-SA/DeleteThirdPartyDialog.json?url";

      import DowngradePlanDialogarSAUrl from "ASSETS_DIR/locales/ar-SA/DowngradePlanDialog.json?url";

      import EmbeddingPanelarSAUrl from "ASSETS_DIR/locales/ar-SA/EmbeddingPanel.json?url";

      import EmptyTrashDialogarSAUrl from "ASSETS_DIR/locales/ar-SA/EmptyTrashDialog.json?url";

      import EmptyViewarSAUrl from "ASSETS_DIR/locales/ar-SA/EmptyView.json?url";

      import ErrorsarSAUrl from "ASSETS_DIR/locales/ar-SA/Errors.json?url";

      import FilesarSAUrl from "ASSETS_DIR/locales/ar-SA/Files.json?url";

      import FilesSettingsarSAUrl from "ASSETS_DIR/locales/ar-SA/FilesSettings.json?url";

      import FillPDFDialogarSAUrl from "ASSETS_DIR/locales/ar-SA/FillPDFDialog.json?url";

      import FormFillingTipsDialogarSAUrl from "ASSETS_DIR/locales/ar-SA/FormFillingTipsDialog.json?url";

      import FormGalleryarSAUrl from "ASSETS_DIR/locales/ar-SA/FormGallery.json?url";

      import HotkeysPanelarSAUrl from "ASSETS_DIR/locales/ar-SA/HotkeysPanel.json?url";

      import InfoPanelarSAUrl from "ASSETS_DIR/locales/ar-SA/InfoPanel.json?url";

      import InviteDialogarSAUrl from "ASSETS_DIR/locales/ar-SA/InviteDialog.json?url";

      import JavascriptSdkarSAUrl from "ASSETS_DIR/locales/ar-SA/JavascriptSdk.json?url";

      import LdaparSAUrl from "ASSETS_DIR/locales/ar-SA/Ldap.json?url";

      import MainBararSAUrl from "ASSETS_DIR/locales/ar-SA/MainBar.json?url";

      import NotificationsarSAUrl from "ASSETS_DIR/locales/ar-SA/Notifications.json?url";

      import OAutharSAUrl from "ASSETS_DIR/locales/ar-SA/OAuth.json?url";

      import PDFFormDialogarSAUrl from "ASSETS_DIR/locales/ar-SA/PDFFormDialog.json?url";

      import PaymentsarSAUrl from "ASSETS_DIR/locales/ar-SA/Payments.json?url";

      import PaymentsEnterprisearSAUrl from "ASSETS_DIR/locales/ar-SA/PaymentsEnterprise.json?url";

      import PeoplearSAUrl from "ASSETS_DIR/locales/ar-SA/People.json?url";

      import PeopleTranslationsarSAUrl from "ASSETS_DIR/locales/ar-SA/PeopleTranslations.json?url";

      import PortalUnavailablearSAUrl from "ASSETS_DIR/locales/ar-SA/PortalUnavailable.json?url";

      import PreparationPortalarSAUrl from "ASSETS_DIR/locales/ar-SA/PreparationPortal.json?url";

      import PrivacyPagearSAUrl from "ASSETS_DIR/locales/ar-SA/PrivacyPage.json?url";

      import ProfilearSAUrl from "ASSETS_DIR/locales/ar-SA/Profile.json?url";

      import ResetApplicationDialogarSAUrl from "ASSETS_DIR/locales/ar-SA/ResetApplicationDialog.json?url";

      import RoomLogoCoverarSAUrl from "ASSETS_DIR/locales/ar-SA/RoomLogoCover.json?url";

      import SMTPSettingsarSAUrl from "ASSETS_DIR/locales/ar-SA/SMTPSettings.json?url";

      import SalesDepartmentRequestDialogarSAUrl from "ASSETS_DIR/locales/ar-SA/SalesDepartmentRequestDialog.json?url";

      import SendInviteDialogarSAUrl from "ASSETS_DIR/locales/ar-SA/SendInviteDialog.json?url";

      import SettingsarSAUrl from "ASSETS_DIR/locales/ar-SA/Settings.json?url";

      import SharingPanelarSAUrl from "ASSETS_DIR/locales/ar-SA/SharingPanel.json?url";

      import SingleSignOnarSAUrl from "ASSETS_DIR/locales/ar-SA/SingleSignOn.json?url";

      import SmartBannerarSAUrl from "ASSETS_DIR/locales/ar-SA/SmartBanner.json?url";

      import SocialAuthWelcomeDialogarSAUrl from "ASSETS_DIR/locales/ar-SA/SocialAuthWelcomeDialog.json?url";

      import TranslationsarSAUrl from "ASSETS_DIR/locales/ar-SA/Translations.json?url";

      import UploadPanelarSAUrl from "ASSETS_DIR/locales/ar-SA/UploadPanel.json?url";

      import VersionHistoryarSAUrl from "ASSETS_DIR/locales/ar-SA/VersionHistory.json?url";

      import WebPluginsarSAUrl from "ASSETS_DIR/locales/ar-SA/WebPlugins.json?url";

      import WebhooksarSAUrl from "ASSETS_DIR/locales/ar-SA/Webhooks.json?url";

      import AboutazUrl from "ASSETS_DIR/locales/az/About.json?url";

      import ArchiveDialogazUrl from "ASSETS_DIR/locales/az/ArchiveDialog.json?url";

      import ArticleazUrl from "ASSETS_DIR/locales/az/Article.json?url";

      import BackupCodesDialogazUrl from "ASSETS_DIR/locales/az/BackupCodesDialog.json?url";

      import ChangeEmailDialogazUrl from "ASSETS_DIR/locales/az/ChangeEmailDialog.json?url";

      import ChangePasswordDialogazUrl from "ASSETS_DIR/locales/az/ChangePasswordDialog.json?url";

      import ChangePhoneDialogazUrl from "ASSETS_DIR/locales/az/ChangePhoneDialog.json?url";

      import ChangePortalOwnerazUrl from "ASSETS_DIR/locales/az/ChangePortalOwner.json?url";

      import ChangeUserStatusDialogazUrl from "ASSETS_DIR/locales/az/ChangeUserStatusDialog.json?url";

      import ChangeUserTypeDialogazUrl from "ASSETS_DIR/locales/az/ChangeUserTypeDialog.json?url";

      import ConnectDialogazUrl from "ASSETS_DIR/locales/az/ConnectDialog.json?url";

      import ConvertDialogazUrl from "ASSETS_DIR/locales/az/ConvertDialog.json?url";

      import ConvertPasswordDialogazUrl from "ASSETS_DIR/locales/az/ConvertPasswordDialog.json?url";

      import CreateEditRoomDialogazUrl from "ASSETS_DIR/locales/az/CreateEditRoomDialog.json?url";

      import DataReassignmentDialogazUrl from "ASSETS_DIR/locales/az/DataReassignmentDialog.json?url";

      import DeleteDialogazUrl from "ASSETS_DIR/locales/az/DeleteDialog.json?url";

      import DeleteProfileEverDialogazUrl from "ASSETS_DIR/locales/az/DeleteProfileEverDialog.json?url";

      import DeleteSelfProfileDialogazUrl from "ASSETS_DIR/locales/az/DeleteSelfProfileDialog.json?url";

      import DeleteThirdPartyDialogazUrl from "ASSETS_DIR/locales/az/DeleteThirdPartyDialog.json?url";

      import DowngradePlanDialogazUrl from "ASSETS_DIR/locales/az/DowngradePlanDialog.json?url";

      import EmbeddingPanelazUrl from "ASSETS_DIR/locales/az/EmbeddingPanel.json?url";

      import EmptyTrashDialogazUrl from "ASSETS_DIR/locales/az/EmptyTrashDialog.json?url";

      import EmptyViewazUrl from "ASSETS_DIR/locales/az/EmptyView.json?url";

      import ErrorsazUrl from "ASSETS_DIR/locales/az/Errors.json?url";

      import FilesazUrl from "ASSETS_DIR/locales/az/Files.json?url";

      import FilesSettingsazUrl from "ASSETS_DIR/locales/az/FilesSettings.json?url";

      import FillPDFDialogazUrl from "ASSETS_DIR/locales/az/FillPDFDialog.json?url";

      import FormFillingTipsDialogazUrl from "ASSETS_DIR/locales/az/FormFillingTipsDialog.json?url";

      import FormGalleryazUrl from "ASSETS_DIR/locales/az/FormGallery.json?url";

      import HotkeysPanelazUrl from "ASSETS_DIR/locales/az/HotkeysPanel.json?url";

      import InfoPanelazUrl from "ASSETS_DIR/locales/az/InfoPanel.json?url";

      import InviteDialogazUrl from "ASSETS_DIR/locales/az/InviteDialog.json?url";

      import JavascriptSdkazUrl from "ASSETS_DIR/locales/az/JavascriptSdk.json?url";

      import LdapazUrl from "ASSETS_DIR/locales/az/Ldap.json?url";

      import MainBarazUrl from "ASSETS_DIR/locales/az/MainBar.json?url";

      import NotificationsazUrl from "ASSETS_DIR/locales/az/Notifications.json?url";

      import OAuthazUrl from "ASSETS_DIR/locales/az/OAuth.json?url";

      import PDFFormDialogazUrl from "ASSETS_DIR/locales/az/PDFFormDialog.json?url";

      import PaymentsazUrl from "ASSETS_DIR/locales/az/Payments.json?url";

      import PaymentsEnterpriseazUrl from "ASSETS_DIR/locales/az/PaymentsEnterprise.json?url";

      import PeopleazUrl from "ASSETS_DIR/locales/az/People.json?url";

      import PeopleTranslationsazUrl from "ASSETS_DIR/locales/az/PeopleTranslations.json?url";

      import PortalUnavailableazUrl from "ASSETS_DIR/locales/az/PortalUnavailable.json?url";

      import PreparationPortalazUrl from "ASSETS_DIR/locales/az/PreparationPortal.json?url";

      import PrivacyPageazUrl from "ASSETS_DIR/locales/az/PrivacyPage.json?url";

      import ProfileazUrl from "ASSETS_DIR/locales/az/Profile.json?url";

      import ResetApplicationDialogazUrl from "ASSETS_DIR/locales/az/ResetApplicationDialog.json?url";

      import RoomLogoCoverazUrl from "ASSETS_DIR/locales/az/RoomLogoCover.json?url";

      import SMTPSettingsazUrl from "ASSETS_DIR/locales/az/SMTPSettings.json?url";

      import SalesDepartmentRequestDialogazUrl from "ASSETS_DIR/locales/az/SalesDepartmentRequestDialog.json?url";

      import SendInviteDialogazUrl from "ASSETS_DIR/locales/az/SendInviteDialog.json?url";

      import SettingsazUrl from "ASSETS_DIR/locales/az/Settings.json?url";

      import SharingPanelazUrl from "ASSETS_DIR/locales/az/SharingPanel.json?url";

      import SingleSignOnazUrl from "ASSETS_DIR/locales/az/SingleSignOn.json?url";

      import SmartBannerazUrl from "ASSETS_DIR/locales/az/SmartBanner.json?url";

      import SocialAuthWelcomeDialogazUrl from "ASSETS_DIR/locales/az/SocialAuthWelcomeDialog.json?url";

      import TranslationsazUrl from "ASSETS_DIR/locales/az/Translations.json?url";

      import UploadPanelazUrl from "ASSETS_DIR/locales/az/UploadPanel.json?url";

      import VersionHistoryazUrl from "ASSETS_DIR/locales/az/VersionHistory.json?url";

      import WebPluginsazUrl from "ASSETS_DIR/locales/az/WebPlugins.json?url";

      import WebhooksazUrl from "ASSETS_DIR/locales/az/Webhooks.json?url";

      import AboutbgUrl from "ASSETS_DIR/locales/bg/About.json?url";

      import ArchiveDialogbgUrl from "ASSETS_DIR/locales/bg/ArchiveDialog.json?url";

      import ArticlebgUrl from "ASSETS_DIR/locales/bg/Article.json?url";

      import BackupCodesDialogbgUrl from "ASSETS_DIR/locales/bg/BackupCodesDialog.json?url";

      import ChangeEmailDialogbgUrl from "ASSETS_DIR/locales/bg/ChangeEmailDialog.json?url";

      import ChangePasswordDialogbgUrl from "ASSETS_DIR/locales/bg/ChangePasswordDialog.json?url";

      import ChangePhoneDialogbgUrl from "ASSETS_DIR/locales/bg/ChangePhoneDialog.json?url";

      import ChangePortalOwnerbgUrl from "ASSETS_DIR/locales/bg/ChangePortalOwner.json?url";

      import ChangeUserStatusDialogbgUrl from "ASSETS_DIR/locales/bg/ChangeUserStatusDialog.json?url";

      import ChangeUserTypeDialogbgUrl from "ASSETS_DIR/locales/bg/ChangeUserTypeDialog.json?url";

      import ConnectDialogbgUrl from "ASSETS_DIR/locales/bg/ConnectDialog.json?url";

      import ConvertDialogbgUrl from "ASSETS_DIR/locales/bg/ConvertDialog.json?url";

      import ConvertPasswordDialogbgUrl from "ASSETS_DIR/locales/bg/ConvertPasswordDialog.json?url";

      import CreateEditRoomDialogbgUrl from "ASSETS_DIR/locales/bg/CreateEditRoomDialog.json?url";

      import DataReassignmentDialogbgUrl from "ASSETS_DIR/locales/bg/DataReassignmentDialog.json?url";

      import DeleteDialogbgUrl from "ASSETS_DIR/locales/bg/DeleteDialog.json?url";

      import DeleteProfileEverDialogbgUrl from "ASSETS_DIR/locales/bg/DeleteProfileEverDialog.json?url";

      import DeleteSelfProfileDialogbgUrl from "ASSETS_DIR/locales/bg/DeleteSelfProfileDialog.json?url";

      import DeleteThirdPartyDialogbgUrl from "ASSETS_DIR/locales/bg/DeleteThirdPartyDialog.json?url";

      import DowngradePlanDialogbgUrl from "ASSETS_DIR/locales/bg/DowngradePlanDialog.json?url";

      import EmbeddingPanelbgUrl from "ASSETS_DIR/locales/bg/EmbeddingPanel.json?url";

      import EmptyTrashDialogbgUrl from "ASSETS_DIR/locales/bg/EmptyTrashDialog.json?url";

      import EmptyViewbgUrl from "ASSETS_DIR/locales/bg/EmptyView.json?url";

      import ErrorsbgUrl from "ASSETS_DIR/locales/bg/Errors.json?url";

      import FilesbgUrl from "ASSETS_DIR/locales/bg/Files.json?url";

      import FilesSettingsbgUrl from "ASSETS_DIR/locales/bg/FilesSettings.json?url";

      import FillPDFDialogbgUrl from "ASSETS_DIR/locales/bg/FillPDFDialog.json?url";

      import FormFillingTipsDialogbgUrl from "ASSETS_DIR/locales/bg/FormFillingTipsDialog.json?url";

      import FormGallerybgUrl from "ASSETS_DIR/locales/bg/FormGallery.json?url";

      import HotkeysPanelbgUrl from "ASSETS_DIR/locales/bg/HotkeysPanel.json?url";

      import InfoPanelbgUrl from "ASSETS_DIR/locales/bg/InfoPanel.json?url";

      import InviteDialogbgUrl from "ASSETS_DIR/locales/bg/InviteDialog.json?url";

      import JavascriptSdkbgUrl from "ASSETS_DIR/locales/bg/JavascriptSdk.json?url";

      import LdapbgUrl from "ASSETS_DIR/locales/bg/Ldap.json?url";

      import MainBarbgUrl from "ASSETS_DIR/locales/bg/MainBar.json?url";

      import NotificationsbgUrl from "ASSETS_DIR/locales/bg/Notifications.json?url";

      import OAuthbgUrl from "ASSETS_DIR/locales/bg/OAuth.json?url";

      import PDFFormDialogbgUrl from "ASSETS_DIR/locales/bg/PDFFormDialog.json?url";

      import PaymentsbgUrl from "ASSETS_DIR/locales/bg/Payments.json?url";

      import PaymentsEnterprisebgUrl from "ASSETS_DIR/locales/bg/PaymentsEnterprise.json?url";

      import PeoplebgUrl from "ASSETS_DIR/locales/bg/People.json?url";

      import PeopleTranslationsbgUrl from "ASSETS_DIR/locales/bg/PeopleTranslations.json?url";

      import PortalUnavailablebgUrl from "ASSETS_DIR/locales/bg/PortalUnavailable.json?url";

      import PreparationPortalbgUrl from "ASSETS_DIR/locales/bg/PreparationPortal.json?url";

      import PrivacyPagebgUrl from "ASSETS_DIR/locales/bg/PrivacyPage.json?url";

      import ProfilebgUrl from "ASSETS_DIR/locales/bg/Profile.json?url";

      import ResetApplicationDialogbgUrl from "ASSETS_DIR/locales/bg/ResetApplicationDialog.json?url";

      import RoomLogoCoverbgUrl from "ASSETS_DIR/locales/bg/RoomLogoCover.json?url";

      import SMTPSettingsbgUrl from "ASSETS_DIR/locales/bg/SMTPSettings.json?url";

      import SalesDepartmentRequestDialogbgUrl from "ASSETS_DIR/locales/bg/SalesDepartmentRequestDialog.json?url";

      import SendInviteDialogbgUrl from "ASSETS_DIR/locales/bg/SendInviteDialog.json?url";

      import SettingsbgUrl from "ASSETS_DIR/locales/bg/Settings.json?url";

      import SharingPanelbgUrl from "ASSETS_DIR/locales/bg/SharingPanel.json?url";

      import SingleSignOnbgUrl from "ASSETS_DIR/locales/bg/SingleSignOn.json?url";

      import SmartBannerbgUrl from "ASSETS_DIR/locales/bg/SmartBanner.json?url";

      import SocialAuthWelcomeDialogbgUrl from "ASSETS_DIR/locales/bg/SocialAuthWelcomeDialog.json?url";

      import TranslationsbgUrl from "ASSETS_DIR/locales/bg/Translations.json?url";

      import UploadPanelbgUrl from "ASSETS_DIR/locales/bg/UploadPanel.json?url";

      import VersionHistorybgUrl from "ASSETS_DIR/locales/bg/VersionHistory.json?url";

      import WebPluginsbgUrl from "ASSETS_DIR/locales/bg/WebPlugins.json?url";

      import WebhooksbgUrl from "ASSETS_DIR/locales/bg/Webhooks.json?url";

      import AboutcsUrl from "ASSETS_DIR/locales/cs/About.json?url";

      import ArchiveDialogcsUrl from "ASSETS_DIR/locales/cs/ArchiveDialog.json?url";

      import ArticlecsUrl from "ASSETS_DIR/locales/cs/Article.json?url";

      import BackupCodesDialogcsUrl from "ASSETS_DIR/locales/cs/BackupCodesDialog.json?url";

      import ChangeEmailDialogcsUrl from "ASSETS_DIR/locales/cs/ChangeEmailDialog.json?url";

      import ChangePasswordDialogcsUrl from "ASSETS_DIR/locales/cs/ChangePasswordDialog.json?url";

      import ChangePhoneDialogcsUrl from "ASSETS_DIR/locales/cs/ChangePhoneDialog.json?url";

      import ChangePortalOwnercsUrl from "ASSETS_DIR/locales/cs/ChangePortalOwner.json?url";

      import ChangeUserStatusDialogcsUrl from "ASSETS_DIR/locales/cs/ChangeUserStatusDialog.json?url";

      import ChangeUserTypeDialogcsUrl from "ASSETS_DIR/locales/cs/ChangeUserTypeDialog.json?url";

      import ConnectDialogcsUrl from "ASSETS_DIR/locales/cs/ConnectDialog.json?url";

      import ConvertDialogcsUrl from "ASSETS_DIR/locales/cs/ConvertDialog.json?url";

      import ConvertPasswordDialogcsUrl from "ASSETS_DIR/locales/cs/ConvertPasswordDialog.json?url";

      import CreateEditRoomDialogcsUrl from "ASSETS_DIR/locales/cs/CreateEditRoomDialog.json?url";

      import DataReassignmentDialogcsUrl from "ASSETS_DIR/locales/cs/DataReassignmentDialog.json?url";

      import DeleteDialogcsUrl from "ASSETS_DIR/locales/cs/DeleteDialog.json?url";

      import DeleteProfileEverDialogcsUrl from "ASSETS_DIR/locales/cs/DeleteProfileEverDialog.json?url";

      import DeleteSelfProfileDialogcsUrl from "ASSETS_DIR/locales/cs/DeleteSelfProfileDialog.json?url";

      import DeleteThirdPartyDialogcsUrl from "ASSETS_DIR/locales/cs/DeleteThirdPartyDialog.json?url";

      import DowngradePlanDialogcsUrl from "ASSETS_DIR/locales/cs/DowngradePlanDialog.json?url";

      import EmbeddingPanelcsUrl from "ASSETS_DIR/locales/cs/EmbeddingPanel.json?url";

      import EmptyTrashDialogcsUrl from "ASSETS_DIR/locales/cs/EmptyTrashDialog.json?url";

      import EmptyViewcsUrl from "ASSETS_DIR/locales/cs/EmptyView.json?url";

      import ErrorscsUrl from "ASSETS_DIR/locales/cs/Errors.json?url";

      import FilescsUrl from "ASSETS_DIR/locales/cs/Files.json?url";

      import FilesSettingscsUrl from "ASSETS_DIR/locales/cs/FilesSettings.json?url";

      import FillPDFDialogcsUrl from "ASSETS_DIR/locales/cs/FillPDFDialog.json?url";

      import FormFillingTipsDialogcsUrl from "ASSETS_DIR/locales/cs/FormFillingTipsDialog.json?url";

      import FormGallerycsUrl from "ASSETS_DIR/locales/cs/FormGallery.json?url";

      import HotkeysPanelcsUrl from "ASSETS_DIR/locales/cs/HotkeysPanel.json?url";

      import InfoPanelcsUrl from "ASSETS_DIR/locales/cs/InfoPanel.json?url";

      import InviteDialogcsUrl from "ASSETS_DIR/locales/cs/InviteDialog.json?url";

      import JavascriptSdkcsUrl from "ASSETS_DIR/locales/cs/JavascriptSdk.json?url";

      import LdapcsUrl from "ASSETS_DIR/locales/cs/Ldap.json?url";

      import MainBarcsUrl from "ASSETS_DIR/locales/cs/MainBar.json?url";

      import NotificationscsUrl from "ASSETS_DIR/locales/cs/Notifications.json?url";

      import OAuthcsUrl from "ASSETS_DIR/locales/cs/OAuth.json?url";

      import PDFFormDialogcsUrl from "ASSETS_DIR/locales/cs/PDFFormDialog.json?url";

      import PaymentscsUrl from "ASSETS_DIR/locales/cs/Payments.json?url";

      import PaymentsEnterprisecsUrl from "ASSETS_DIR/locales/cs/PaymentsEnterprise.json?url";

      import PeoplecsUrl from "ASSETS_DIR/locales/cs/People.json?url";

      import PeopleTranslationscsUrl from "ASSETS_DIR/locales/cs/PeopleTranslations.json?url";

      import PortalUnavailablecsUrl from "ASSETS_DIR/locales/cs/PortalUnavailable.json?url";

      import PreparationPortalcsUrl from "ASSETS_DIR/locales/cs/PreparationPortal.json?url";

      import PrivacyPagecsUrl from "ASSETS_DIR/locales/cs/PrivacyPage.json?url";

      import ProfilecsUrl from "ASSETS_DIR/locales/cs/Profile.json?url";

      import ResetApplicationDialogcsUrl from "ASSETS_DIR/locales/cs/ResetApplicationDialog.json?url";

      import RoomLogoCovercsUrl from "ASSETS_DIR/locales/cs/RoomLogoCover.json?url";

      import SMTPSettingscsUrl from "ASSETS_DIR/locales/cs/SMTPSettings.json?url";

      import SalesDepartmentRequestDialogcsUrl from "ASSETS_DIR/locales/cs/SalesDepartmentRequestDialog.json?url";

      import SendInviteDialogcsUrl from "ASSETS_DIR/locales/cs/SendInviteDialog.json?url";

      import SettingscsUrl from "ASSETS_DIR/locales/cs/Settings.json?url";

      import SharingPanelcsUrl from "ASSETS_DIR/locales/cs/SharingPanel.json?url";

      import SingleSignOncsUrl from "ASSETS_DIR/locales/cs/SingleSignOn.json?url";

      import SmartBannercsUrl from "ASSETS_DIR/locales/cs/SmartBanner.json?url";

      import SocialAuthWelcomeDialogcsUrl from "ASSETS_DIR/locales/cs/SocialAuthWelcomeDialog.json?url";

      import TranslationscsUrl from "ASSETS_DIR/locales/cs/Translations.json?url";

      import UploadPanelcsUrl from "ASSETS_DIR/locales/cs/UploadPanel.json?url";

      import VersionHistorycsUrl from "ASSETS_DIR/locales/cs/VersionHistory.json?url";

      import WebPluginscsUrl from "ASSETS_DIR/locales/cs/WebPlugins.json?url";

      import WebhookscsUrl from "ASSETS_DIR/locales/cs/Webhooks.json?url";

      import AboutdeUrl from "ASSETS_DIR/locales/de/About.json?url";

      import ArchiveDialogdeUrl from "ASSETS_DIR/locales/de/ArchiveDialog.json?url";

      import ArticledeUrl from "ASSETS_DIR/locales/de/Article.json?url";

      import BackupCodesDialogdeUrl from "ASSETS_DIR/locales/de/BackupCodesDialog.json?url";

      import ChangeEmailDialogdeUrl from "ASSETS_DIR/locales/de/ChangeEmailDialog.json?url";

      import ChangePasswordDialogdeUrl from "ASSETS_DIR/locales/de/ChangePasswordDialog.json?url";

      import ChangePhoneDialogdeUrl from "ASSETS_DIR/locales/de/ChangePhoneDialog.json?url";

      import ChangePortalOwnerdeUrl from "ASSETS_DIR/locales/de/ChangePortalOwner.json?url";

      import ChangeUserStatusDialogdeUrl from "ASSETS_DIR/locales/de/ChangeUserStatusDialog.json?url";

      import ChangeUserTypeDialogdeUrl from "ASSETS_DIR/locales/de/ChangeUserTypeDialog.json?url";

      import ConnectDialogdeUrl from "ASSETS_DIR/locales/de/ConnectDialog.json?url";

      import ConvertDialogdeUrl from "ASSETS_DIR/locales/de/ConvertDialog.json?url";

      import ConvertPasswordDialogdeUrl from "ASSETS_DIR/locales/de/ConvertPasswordDialog.json?url";

      import CreateEditRoomDialogdeUrl from "ASSETS_DIR/locales/de/CreateEditRoomDialog.json?url";

      import DataReassignmentDialogdeUrl from "ASSETS_DIR/locales/de/DataReassignmentDialog.json?url";

      import DeleteDialogdeUrl from "ASSETS_DIR/locales/de/DeleteDialog.json?url";

      import DeleteProfileEverDialogdeUrl from "ASSETS_DIR/locales/de/DeleteProfileEverDialog.json?url";

      import DeleteSelfProfileDialogdeUrl from "ASSETS_DIR/locales/de/DeleteSelfProfileDialog.json?url";

      import DeleteThirdPartyDialogdeUrl from "ASSETS_DIR/locales/de/DeleteThirdPartyDialog.json?url";

      import DowngradePlanDialogdeUrl from "ASSETS_DIR/locales/de/DowngradePlanDialog.json?url";

      import EmbeddingPaneldeUrl from "ASSETS_DIR/locales/de/EmbeddingPanel.json?url";

      import EmptyTrashDialogdeUrl from "ASSETS_DIR/locales/de/EmptyTrashDialog.json?url";

      import EmptyViewdeUrl from "ASSETS_DIR/locales/de/EmptyView.json?url";

      import ErrorsdeUrl from "ASSETS_DIR/locales/de/Errors.json?url";

      import FilesdeUrl from "ASSETS_DIR/locales/de/Files.json?url";

      import FilesSettingsdeUrl from "ASSETS_DIR/locales/de/FilesSettings.json?url";

      import FillPDFDialogdeUrl from "ASSETS_DIR/locales/de/FillPDFDialog.json?url";

      import FormFillingTipsDialogdeUrl from "ASSETS_DIR/locales/de/FormFillingTipsDialog.json?url";

      import FormGallerydeUrl from "ASSETS_DIR/locales/de/FormGallery.json?url";

      import HotkeysPaneldeUrl from "ASSETS_DIR/locales/de/HotkeysPanel.json?url";

      import InfoPaneldeUrl from "ASSETS_DIR/locales/de/InfoPanel.json?url";

      import InviteDialogdeUrl from "ASSETS_DIR/locales/de/InviteDialog.json?url";

      import JavascriptSdkdeUrl from "ASSETS_DIR/locales/de/JavascriptSdk.json?url";

      import LdapdeUrl from "ASSETS_DIR/locales/de/Ldap.json?url";

      import MainBardeUrl from "ASSETS_DIR/locales/de/MainBar.json?url";

      import NotificationsdeUrl from "ASSETS_DIR/locales/de/Notifications.json?url";

      import OAuthdeUrl from "ASSETS_DIR/locales/de/OAuth.json?url";

      import PDFFormDialogdeUrl from "ASSETS_DIR/locales/de/PDFFormDialog.json?url";

      import PaymentsdeUrl from "ASSETS_DIR/locales/de/Payments.json?url";

      import PaymentsEnterprisedeUrl from "ASSETS_DIR/locales/de/PaymentsEnterprise.json?url";

      import PeopledeUrl from "ASSETS_DIR/locales/de/People.json?url";

      import PeopleTranslationsdeUrl from "ASSETS_DIR/locales/de/PeopleTranslations.json?url";

      import PortalUnavailabledeUrl from "ASSETS_DIR/locales/de/PortalUnavailable.json?url";

      import PreparationPortaldeUrl from "ASSETS_DIR/locales/de/PreparationPortal.json?url";

      import PrivacyPagedeUrl from "ASSETS_DIR/locales/de/PrivacyPage.json?url";

      import ProfiledeUrl from "ASSETS_DIR/locales/de/Profile.json?url";

      import ResetApplicationDialogdeUrl from "ASSETS_DIR/locales/de/ResetApplicationDialog.json?url";

      import RoomLogoCoverdeUrl from "ASSETS_DIR/locales/de/RoomLogoCover.json?url";

      import SMTPSettingsdeUrl from "ASSETS_DIR/locales/de/SMTPSettings.json?url";

      import SalesDepartmentRequestDialogdeUrl from "ASSETS_DIR/locales/de/SalesDepartmentRequestDialog.json?url";

      import SendInviteDialogdeUrl from "ASSETS_DIR/locales/de/SendInviteDialog.json?url";

      import SettingsdeUrl from "ASSETS_DIR/locales/de/Settings.json?url";

      import SharingPaneldeUrl from "ASSETS_DIR/locales/de/SharingPanel.json?url";

      import SingleSignOndeUrl from "ASSETS_DIR/locales/de/SingleSignOn.json?url";

      import SmartBannerdeUrl from "ASSETS_DIR/locales/de/SmartBanner.json?url";

      import SocialAuthWelcomeDialogdeUrl from "ASSETS_DIR/locales/de/SocialAuthWelcomeDialog.json?url";

      import TranslationsdeUrl from "ASSETS_DIR/locales/de/Translations.json?url";

      import UploadPaneldeUrl from "ASSETS_DIR/locales/de/UploadPanel.json?url";

      import VersionHistorydeUrl from "ASSETS_DIR/locales/de/VersionHistory.json?url";

      import WebPluginsdeUrl from "ASSETS_DIR/locales/de/WebPlugins.json?url";

      import WebhooksdeUrl from "ASSETS_DIR/locales/de/Webhooks.json?url";

      import AboutelGRUrl from "ASSETS_DIR/locales/el-GR/About.json?url";

      import ArchiveDialogelGRUrl from "ASSETS_DIR/locales/el-GR/ArchiveDialog.json?url";

      import ArticleelGRUrl from "ASSETS_DIR/locales/el-GR/Article.json?url";

      import BackupCodesDialogelGRUrl from "ASSETS_DIR/locales/el-GR/BackupCodesDialog.json?url";

      import ChangeEmailDialogelGRUrl from "ASSETS_DIR/locales/el-GR/ChangeEmailDialog.json?url";

      import ChangePasswordDialogelGRUrl from "ASSETS_DIR/locales/el-GR/ChangePasswordDialog.json?url";

      import ChangePhoneDialogelGRUrl from "ASSETS_DIR/locales/el-GR/ChangePhoneDialog.json?url";

      import ChangePortalOwnerelGRUrl from "ASSETS_DIR/locales/el-GR/ChangePortalOwner.json?url";

      import ChangeUserStatusDialogelGRUrl from "ASSETS_DIR/locales/el-GR/ChangeUserStatusDialog.json?url";

      import ChangeUserTypeDialogelGRUrl from "ASSETS_DIR/locales/el-GR/ChangeUserTypeDialog.json?url";

      import ConnectDialogelGRUrl from "ASSETS_DIR/locales/el-GR/ConnectDialog.json?url";

      import ConvertDialogelGRUrl from "ASSETS_DIR/locales/el-GR/ConvertDialog.json?url";

      import ConvertPasswordDialogelGRUrl from "ASSETS_DIR/locales/el-GR/ConvertPasswordDialog.json?url";

      import CreateEditRoomDialogelGRUrl from "ASSETS_DIR/locales/el-GR/CreateEditRoomDialog.json?url";

      import DataReassignmentDialogelGRUrl from "ASSETS_DIR/locales/el-GR/DataReassignmentDialog.json?url";

      import DeleteDialogelGRUrl from "ASSETS_DIR/locales/el-GR/DeleteDialog.json?url";

      import DeleteProfileEverDialogelGRUrl from "ASSETS_DIR/locales/el-GR/DeleteProfileEverDialog.json?url";

      import DeleteSelfProfileDialogelGRUrl from "ASSETS_DIR/locales/el-GR/DeleteSelfProfileDialog.json?url";

      import DeleteThirdPartyDialogelGRUrl from "ASSETS_DIR/locales/el-GR/DeleteThirdPartyDialog.json?url";

      import DowngradePlanDialogelGRUrl from "ASSETS_DIR/locales/el-GR/DowngradePlanDialog.json?url";

      import EmbeddingPanelelGRUrl from "ASSETS_DIR/locales/el-GR/EmbeddingPanel.json?url";

      import EmptyTrashDialogelGRUrl from "ASSETS_DIR/locales/el-GR/EmptyTrashDialog.json?url";

      import EmptyViewelGRUrl from "ASSETS_DIR/locales/el-GR/EmptyView.json?url";

      import ErrorselGRUrl from "ASSETS_DIR/locales/el-GR/Errors.json?url";

      import FileselGRUrl from "ASSETS_DIR/locales/el-GR/Files.json?url";

      import FilesSettingselGRUrl from "ASSETS_DIR/locales/el-GR/FilesSettings.json?url";

      import FillPDFDialogelGRUrl from "ASSETS_DIR/locales/el-GR/FillPDFDialog.json?url";

      import FormFillingTipsDialogelGRUrl from "ASSETS_DIR/locales/el-GR/FormFillingTipsDialog.json?url";

      import FormGalleryelGRUrl from "ASSETS_DIR/locales/el-GR/FormGallery.json?url";

      import HotkeysPanelelGRUrl from "ASSETS_DIR/locales/el-GR/HotkeysPanel.json?url";

      import InfoPanelelGRUrl from "ASSETS_DIR/locales/el-GR/InfoPanel.json?url";

      import InviteDialogelGRUrl from "ASSETS_DIR/locales/el-GR/InviteDialog.json?url";

      import JavascriptSdkelGRUrl from "ASSETS_DIR/locales/el-GR/JavascriptSdk.json?url";

      import LdapelGRUrl from "ASSETS_DIR/locales/el-GR/Ldap.json?url";

      import MainBarelGRUrl from "ASSETS_DIR/locales/el-GR/MainBar.json?url";

      import NotificationselGRUrl from "ASSETS_DIR/locales/el-GR/Notifications.json?url";

      import OAuthelGRUrl from "ASSETS_DIR/locales/el-GR/OAuth.json?url";

      import PDFFormDialogelGRUrl from "ASSETS_DIR/locales/el-GR/PDFFormDialog.json?url";

      import PaymentselGRUrl from "ASSETS_DIR/locales/el-GR/Payments.json?url";

      import PaymentsEnterpriseelGRUrl from "ASSETS_DIR/locales/el-GR/PaymentsEnterprise.json?url";

      import PeopleelGRUrl from "ASSETS_DIR/locales/el-GR/People.json?url";

      import PeopleTranslationselGRUrl from "ASSETS_DIR/locales/el-GR/PeopleTranslations.json?url";

      import PortalUnavailableelGRUrl from "ASSETS_DIR/locales/el-GR/PortalUnavailable.json?url";

      import PreparationPortalelGRUrl from "ASSETS_DIR/locales/el-GR/PreparationPortal.json?url";

      import PrivacyPageelGRUrl from "ASSETS_DIR/locales/el-GR/PrivacyPage.json?url";

      import ProfileelGRUrl from "ASSETS_DIR/locales/el-GR/Profile.json?url";

      import ResetApplicationDialogelGRUrl from "ASSETS_DIR/locales/el-GR/ResetApplicationDialog.json?url";

      import RoomLogoCoverelGRUrl from "ASSETS_DIR/locales/el-GR/RoomLogoCover.json?url";

      import SMTPSettingselGRUrl from "ASSETS_DIR/locales/el-GR/SMTPSettings.json?url";

      import SalesDepartmentRequestDialogelGRUrl from "ASSETS_DIR/locales/el-GR/SalesDepartmentRequestDialog.json?url";

      import SendInviteDialogelGRUrl from "ASSETS_DIR/locales/el-GR/SendInviteDialog.json?url";

      import SettingselGRUrl from "ASSETS_DIR/locales/el-GR/Settings.json?url";

      import SharingPanelelGRUrl from "ASSETS_DIR/locales/el-GR/SharingPanel.json?url";

      import SingleSignOnelGRUrl from "ASSETS_DIR/locales/el-GR/SingleSignOn.json?url";

      import SmartBannerelGRUrl from "ASSETS_DIR/locales/el-GR/SmartBanner.json?url";

      import SocialAuthWelcomeDialogelGRUrl from "ASSETS_DIR/locales/el-GR/SocialAuthWelcomeDialog.json?url";

      import TranslationselGRUrl from "ASSETS_DIR/locales/el-GR/Translations.json?url";

      import UploadPanelelGRUrl from "ASSETS_DIR/locales/el-GR/UploadPanel.json?url";

      import VersionHistoryelGRUrl from "ASSETS_DIR/locales/el-GR/VersionHistory.json?url";

      import WebPluginselGRUrl from "ASSETS_DIR/locales/el-GR/WebPlugins.json?url";

      import WebhookselGRUrl from "ASSETS_DIR/locales/el-GR/Webhooks.json?url";

      import AboutenUrl from "ASSETS_DIR/locales/en/About.json?url";

      import ArchiveDialogenUrl from "ASSETS_DIR/locales/en/ArchiveDialog.json?url";

      import ArticleenUrl from "ASSETS_DIR/locales/en/Article.json?url";

      import BackupCodesDialogenUrl from "ASSETS_DIR/locales/en/BackupCodesDialog.json?url";

      import ChangeEmailDialogenUrl from "ASSETS_DIR/locales/en/ChangeEmailDialog.json?url";

      import ChangePasswordDialogenUrl from "ASSETS_DIR/locales/en/ChangePasswordDialog.json?url";

      import ChangePhoneDialogenUrl from "ASSETS_DIR/locales/en/ChangePhoneDialog.json?url";

      import ChangePortalOwnerenUrl from "ASSETS_DIR/locales/en/ChangePortalOwner.json?url";

      import ChangeUserStatusDialogenUrl from "ASSETS_DIR/locales/en/ChangeUserStatusDialog.json?url";

      import ChangeUserTypeDialogenUrl from "ASSETS_DIR/locales/en/ChangeUserTypeDialog.json?url";

      import ConnectDialogenUrl from "ASSETS_DIR/locales/en/ConnectDialog.json?url";

      import ConvertDialogenUrl from "ASSETS_DIR/locales/en/ConvertDialog.json?url";

      import ConvertPasswordDialogenUrl from "ASSETS_DIR/locales/en/ConvertPasswordDialog.json?url";

      import CreateEditRoomDialogenUrl from "ASSETS_DIR/locales/en/CreateEditRoomDialog.json?url";

      import DataReassignmentDialogenUrl from "ASSETS_DIR/locales/en/DataReassignmentDialog.json?url";

      import DeleteDialogenUrl from "ASSETS_DIR/locales/en/DeleteDialog.json?url";

      import DeleteProfileEverDialogenUrl from "ASSETS_DIR/locales/en/DeleteProfileEverDialog.json?url";

      import DeleteSelfProfileDialogenUrl from "ASSETS_DIR/locales/en/DeleteSelfProfileDialog.json?url";

      import DeleteThirdPartyDialogenUrl from "ASSETS_DIR/locales/en/DeleteThirdPartyDialog.json?url";

      import DowngradePlanDialogenUrl from "ASSETS_DIR/locales/en/DowngradePlanDialog.json?url";

      import EmbeddingPanelenUrl from "ASSETS_DIR/locales/en/EmbeddingPanel.json?url";

      import EmptyTrashDialogenUrl from "ASSETS_DIR/locales/en/EmptyTrashDialog.json?url";

      import EmptyViewenUrl from "ASSETS_DIR/locales/en/EmptyView.json?url";

      import ErrorsenUrl from "ASSETS_DIR/locales/en/Errors.json?url";

      import FilesenUrl from "ASSETS_DIR/locales/en/Files.json?url";

      import FilesSettingsenUrl from "ASSETS_DIR/locales/en/FilesSettings.json?url";

      import FillPDFDialogenUrl from "ASSETS_DIR/locales/en/FillPDFDialog.json?url";

      import FormFillingTipsDialogenUrl from "ASSETS_DIR/locales/en/FormFillingTipsDialog.json?url";

      import FormGalleryenUrl from "ASSETS_DIR/locales/en/FormGallery.json?url";

      import HotkeysPanelenUrl from "ASSETS_DIR/locales/en/HotkeysPanel.json?url";

      import InfoPanelenUrl from "ASSETS_DIR/locales/en/InfoPanel.json?url";

      import InviteDialogenUrl from "ASSETS_DIR/locales/en/InviteDialog.json?url";

      import JavascriptSdkenUrl from "ASSETS_DIR/locales/en/JavascriptSdk.json?url";

      import LdapenUrl from "ASSETS_DIR/locales/en/Ldap.json?url";

      import MainBarenUrl from "ASSETS_DIR/locales/en/MainBar.json?url";

      import NotificationsenUrl from "ASSETS_DIR/locales/en/Notifications.json?url";

      import OAuthenUrl from "ASSETS_DIR/locales/en/OAuth.json?url";

      import PDFFormDialogenUrl from "ASSETS_DIR/locales/en/PDFFormDialog.json?url";

      import PaymentsenUrl from "ASSETS_DIR/locales/en/Payments.json?url";

      import PaymentsEnterpriseenUrl from "ASSETS_DIR/locales/en/PaymentsEnterprise.json?url";

      import PeopleenUrl from "ASSETS_DIR/locales/en/People.json?url";

      import PeopleTranslationsenUrl from "ASSETS_DIR/locales/en/PeopleTranslations.json?url";

      import PortalUnavailableenUrl from "ASSETS_DIR/locales/en/PortalUnavailable.json?url";

      import PreparationPortalenUrl from "ASSETS_DIR/locales/en/PreparationPortal.json?url";

      import PrivacyPageenUrl from "ASSETS_DIR/locales/en/PrivacyPage.json?url";

      import ProfileenUrl from "ASSETS_DIR/locales/en/Profile.json?url";

      import ResetApplicationDialogenUrl from "ASSETS_DIR/locales/en/ResetApplicationDialog.json?url";

      import RoomLogoCoverenUrl from "ASSETS_DIR/locales/en/RoomLogoCover.json?url";

      import SMTPSettingsenUrl from "ASSETS_DIR/locales/en/SMTPSettings.json?url";

      import SalesDepartmentRequestDialogenUrl from "ASSETS_DIR/locales/en/SalesDepartmentRequestDialog.json?url";

      import SendInviteDialogenUrl from "ASSETS_DIR/locales/en/SendInviteDialog.json?url";

      import SettingsenUrl from "ASSETS_DIR/locales/en/Settings.json?url";

      import SharingPanelenUrl from "ASSETS_DIR/locales/en/SharingPanel.json?url";

      import SingleSignOnenUrl from "ASSETS_DIR/locales/en/SingleSignOn.json?url";

      import SmartBannerenUrl from "ASSETS_DIR/locales/en/SmartBanner.json?url";

      import SocialAuthWelcomeDialogenUrl from "ASSETS_DIR/locales/en/SocialAuthWelcomeDialog.json?url";

      import TranslationsenUrl from "ASSETS_DIR/locales/en/Translations.json?url";

      import UploadPanelenUrl from "ASSETS_DIR/locales/en/UploadPanel.json?url";

      import VersionHistoryenUrl from "ASSETS_DIR/locales/en/VersionHistory.json?url";

      import WebPluginsenUrl from "ASSETS_DIR/locales/en/WebPlugins.json?url";

      import WebhooksenUrl from "ASSETS_DIR/locales/en/Webhooks.json?url";

      import AboutesUrl from "ASSETS_DIR/locales/es/About.json?url";

      import ArchiveDialogesUrl from "ASSETS_DIR/locales/es/ArchiveDialog.json?url";

      import ArticleesUrl from "ASSETS_DIR/locales/es/Article.json?url";

      import BackupCodesDialogesUrl from "ASSETS_DIR/locales/es/BackupCodesDialog.json?url";

      import ChangeEmailDialogesUrl from "ASSETS_DIR/locales/es/ChangeEmailDialog.json?url";

      import ChangePasswordDialogesUrl from "ASSETS_DIR/locales/es/ChangePasswordDialog.json?url";

      import ChangePhoneDialogesUrl from "ASSETS_DIR/locales/es/ChangePhoneDialog.json?url";

      import ChangePortalOwneresUrl from "ASSETS_DIR/locales/es/ChangePortalOwner.json?url";

      import ChangeUserStatusDialogesUrl from "ASSETS_DIR/locales/es/ChangeUserStatusDialog.json?url";

      import ChangeUserTypeDialogesUrl from "ASSETS_DIR/locales/es/ChangeUserTypeDialog.json?url";

      import ConnectDialogesUrl from "ASSETS_DIR/locales/es/ConnectDialog.json?url";

      import ConvertDialogesUrl from "ASSETS_DIR/locales/es/ConvertDialog.json?url";

      import ConvertPasswordDialogesUrl from "ASSETS_DIR/locales/es/ConvertPasswordDialog.json?url";

      import CreateEditRoomDialogesUrl from "ASSETS_DIR/locales/es/CreateEditRoomDialog.json?url";

      import DataReassignmentDialogesUrl from "ASSETS_DIR/locales/es/DataReassignmentDialog.json?url";

      import DeleteDialogesUrl from "ASSETS_DIR/locales/es/DeleteDialog.json?url";

      import DeleteProfileEverDialogesUrl from "ASSETS_DIR/locales/es/DeleteProfileEverDialog.json?url";

      import DeleteSelfProfileDialogesUrl from "ASSETS_DIR/locales/es/DeleteSelfProfileDialog.json?url";

      import DeleteThirdPartyDialogesUrl from "ASSETS_DIR/locales/es/DeleteThirdPartyDialog.json?url";

      import DowngradePlanDialogesUrl from "ASSETS_DIR/locales/es/DowngradePlanDialog.json?url";

      import EmbeddingPanelesUrl from "ASSETS_DIR/locales/es/EmbeddingPanel.json?url";

      import EmptyTrashDialogesUrl from "ASSETS_DIR/locales/es/EmptyTrashDialog.json?url";

      import EmptyViewesUrl from "ASSETS_DIR/locales/es/EmptyView.json?url";

      import ErrorsesUrl from "ASSETS_DIR/locales/es/Errors.json?url";

      import FilesesUrl from "ASSETS_DIR/locales/es/Files.json?url";

      import FilesSettingsesUrl from "ASSETS_DIR/locales/es/FilesSettings.json?url";

      import FillPDFDialogesUrl from "ASSETS_DIR/locales/es/FillPDFDialog.json?url";

      import FormFillingTipsDialogesUrl from "ASSETS_DIR/locales/es/FormFillingTipsDialog.json?url";

      import FormGalleryesUrl from "ASSETS_DIR/locales/es/FormGallery.json?url";

      import HotkeysPanelesUrl from "ASSETS_DIR/locales/es/HotkeysPanel.json?url";

      import InfoPanelesUrl from "ASSETS_DIR/locales/es/InfoPanel.json?url";

      import InviteDialogesUrl from "ASSETS_DIR/locales/es/InviteDialog.json?url";

      import JavascriptSdkesUrl from "ASSETS_DIR/locales/es/JavascriptSdk.json?url";

      import LdapesUrl from "ASSETS_DIR/locales/es/Ldap.json?url";

      import MainBaresUrl from "ASSETS_DIR/locales/es/MainBar.json?url";

      import NotificationsesUrl from "ASSETS_DIR/locales/es/Notifications.json?url";

      import OAuthesUrl from "ASSETS_DIR/locales/es/OAuth.json?url";

      import PDFFormDialogesUrl from "ASSETS_DIR/locales/es/PDFFormDialog.json?url";

      import PaymentsesUrl from "ASSETS_DIR/locales/es/Payments.json?url";

      import PaymentsEnterpriseesUrl from "ASSETS_DIR/locales/es/PaymentsEnterprise.json?url";

      import PeopleesUrl from "ASSETS_DIR/locales/es/People.json?url";

      import PeopleTranslationsesUrl from "ASSETS_DIR/locales/es/PeopleTranslations.json?url";

      import PortalUnavailableesUrl from "ASSETS_DIR/locales/es/PortalUnavailable.json?url";

      import PreparationPortalesUrl from "ASSETS_DIR/locales/es/PreparationPortal.json?url";

      import PrivacyPageesUrl from "ASSETS_DIR/locales/es/PrivacyPage.json?url";

      import ProfileesUrl from "ASSETS_DIR/locales/es/Profile.json?url";

      import ResetApplicationDialogesUrl from "ASSETS_DIR/locales/es/ResetApplicationDialog.json?url";

      import RoomLogoCoveresUrl from "ASSETS_DIR/locales/es/RoomLogoCover.json?url";

      import SMTPSettingsesUrl from "ASSETS_DIR/locales/es/SMTPSettings.json?url";

      import SalesDepartmentRequestDialogesUrl from "ASSETS_DIR/locales/es/SalesDepartmentRequestDialog.json?url";

      import SendInviteDialogesUrl from "ASSETS_DIR/locales/es/SendInviteDialog.json?url";

      import SettingsesUrl from "ASSETS_DIR/locales/es/Settings.json?url";

      import SharingPanelesUrl from "ASSETS_DIR/locales/es/SharingPanel.json?url";

      import SingleSignOnesUrl from "ASSETS_DIR/locales/es/SingleSignOn.json?url";

      import SmartBanneresUrl from "ASSETS_DIR/locales/es/SmartBanner.json?url";

      import SocialAuthWelcomeDialogesUrl from "ASSETS_DIR/locales/es/SocialAuthWelcomeDialog.json?url";

      import TranslationsesUrl from "ASSETS_DIR/locales/es/Translations.json?url";

      import UploadPanelesUrl from "ASSETS_DIR/locales/es/UploadPanel.json?url";

      import VersionHistoryesUrl from "ASSETS_DIR/locales/es/VersionHistory.json?url";

      import WebPluginsesUrl from "ASSETS_DIR/locales/es/WebPlugins.json?url";

      import WebhooksesUrl from "ASSETS_DIR/locales/es/Webhooks.json?url";

      import AboutfiUrl from "ASSETS_DIR/locales/fi/About.json?url";

      import ArchiveDialogfiUrl from "ASSETS_DIR/locales/fi/ArchiveDialog.json?url";

      import ArticlefiUrl from "ASSETS_DIR/locales/fi/Article.json?url";

      import BackupCodesDialogfiUrl from "ASSETS_DIR/locales/fi/BackupCodesDialog.json?url";

      import ChangeEmailDialogfiUrl from "ASSETS_DIR/locales/fi/ChangeEmailDialog.json?url";

      import ChangePasswordDialogfiUrl from "ASSETS_DIR/locales/fi/ChangePasswordDialog.json?url";

      import ChangePhoneDialogfiUrl from "ASSETS_DIR/locales/fi/ChangePhoneDialog.json?url";

      import ChangePortalOwnerfiUrl from "ASSETS_DIR/locales/fi/ChangePortalOwner.json?url";

      import ChangeUserStatusDialogfiUrl from "ASSETS_DIR/locales/fi/ChangeUserStatusDialog.json?url";

      import ChangeUserTypeDialogfiUrl from "ASSETS_DIR/locales/fi/ChangeUserTypeDialog.json?url";

      import ConnectDialogfiUrl from "ASSETS_DIR/locales/fi/ConnectDialog.json?url";

      import ConvertDialogfiUrl from "ASSETS_DIR/locales/fi/ConvertDialog.json?url";

      import ConvertPasswordDialogfiUrl from "ASSETS_DIR/locales/fi/ConvertPasswordDialog.json?url";

      import CreateEditRoomDialogfiUrl from "ASSETS_DIR/locales/fi/CreateEditRoomDialog.json?url";

      import DataReassignmentDialogfiUrl from "ASSETS_DIR/locales/fi/DataReassignmentDialog.json?url";

      import DeleteDialogfiUrl from "ASSETS_DIR/locales/fi/DeleteDialog.json?url";

      import DeleteProfileEverDialogfiUrl from "ASSETS_DIR/locales/fi/DeleteProfileEverDialog.json?url";

      import DeleteSelfProfileDialogfiUrl from "ASSETS_DIR/locales/fi/DeleteSelfProfileDialog.json?url";

      import DeleteThirdPartyDialogfiUrl from "ASSETS_DIR/locales/fi/DeleteThirdPartyDialog.json?url";

      import DowngradePlanDialogfiUrl from "ASSETS_DIR/locales/fi/DowngradePlanDialog.json?url";

      import EmbeddingPanelfiUrl from "ASSETS_DIR/locales/fi/EmbeddingPanel.json?url";

      import EmptyTrashDialogfiUrl from "ASSETS_DIR/locales/fi/EmptyTrashDialog.json?url";

      import EmptyViewfiUrl from "ASSETS_DIR/locales/fi/EmptyView.json?url";

      import ErrorsfiUrl from "ASSETS_DIR/locales/fi/Errors.json?url";

      import FilesfiUrl from "ASSETS_DIR/locales/fi/Files.json?url";

      import FilesSettingsfiUrl from "ASSETS_DIR/locales/fi/FilesSettings.json?url";

      import FillPDFDialogfiUrl from "ASSETS_DIR/locales/fi/FillPDFDialog.json?url";

      import FormFillingTipsDialogfiUrl from "ASSETS_DIR/locales/fi/FormFillingTipsDialog.json?url";

      import FormGalleryfiUrl from "ASSETS_DIR/locales/fi/FormGallery.json?url";

      import HotkeysPanelfiUrl from "ASSETS_DIR/locales/fi/HotkeysPanel.json?url";

      import InfoPanelfiUrl from "ASSETS_DIR/locales/fi/InfoPanel.json?url";

      import InviteDialogfiUrl from "ASSETS_DIR/locales/fi/InviteDialog.json?url";

      import JavascriptSdkfiUrl from "ASSETS_DIR/locales/fi/JavascriptSdk.json?url";

      import LdapfiUrl from "ASSETS_DIR/locales/fi/Ldap.json?url";

      import MainBarfiUrl from "ASSETS_DIR/locales/fi/MainBar.json?url";

      import NotificationsfiUrl from "ASSETS_DIR/locales/fi/Notifications.json?url";

      import OAuthfiUrl from "ASSETS_DIR/locales/fi/OAuth.json?url";

      import PDFFormDialogfiUrl from "ASSETS_DIR/locales/fi/PDFFormDialog.json?url";

      import PaymentsfiUrl from "ASSETS_DIR/locales/fi/Payments.json?url";

      import PaymentsEnterprisefiUrl from "ASSETS_DIR/locales/fi/PaymentsEnterprise.json?url";

      import PeoplefiUrl from "ASSETS_DIR/locales/fi/People.json?url";

      import PeopleTranslationsfiUrl from "ASSETS_DIR/locales/fi/PeopleTranslations.json?url";

      import PortalUnavailablefiUrl from "ASSETS_DIR/locales/fi/PortalUnavailable.json?url";

      import PreparationPortalfiUrl from "ASSETS_DIR/locales/fi/PreparationPortal.json?url";

      import PrivacyPagefiUrl from "ASSETS_DIR/locales/fi/PrivacyPage.json?url";

      import ProfilefiUrl from "ASSETS_DIR/locales/fi/Profile.json?url";

      import ResetApplicationDialogfiUrl from "ASSETS_DIR/locales/fi/ResetApplicationDialog.json?url";

      import RoomLogoCoverfiUrl from "ASSETS_DIR/locales/fi/RoomLogoCover.json?url";

      import SMTPSettingsfiUrl from "ASSETS_DIR/locales/fi/SMTPSettings.json?url";

      import SalesDepartmentRequestDialogfiUrl from "ASSETS_DIR/locales/fi/SalesDepartmentRequestDialog.json?url";

      import SendInviteDialogfiUrl from "ASSETS_DIR/locales/fi/SendInviteDialog.json?url";

      import SettingsfiUrl from "ASSETS_DIR/locales/fi/Settings.json?url";

      import SharingPanelfiUrl from "ASSETS_DIR/locales/fi/SharingPanel.json?url";

      import SingleSignOnfiUrl from "ASSETS_DIR/locales/fi/SingleSignOn.json?url";

      import SmartBannerfiUrl from "ASSETS_DIR/locales/fi/SmartBanner.json?url";

      import SocialAuthWelcomeDialogfiUrl from "ASSETS_DIR/locales/fi/SocialAuthWelcomeDialog.json?url";

      import TranslationsfiUrl from "ASSETS_DIR/locales/fi/Translations.json?url";

      import UploadPanelfiUrl from "ASSETS_DIR/locales/fi/UploadPanel.json?url";

      import VersionHistoryfiUrl from "ASSETS_DIR/locales/fi/VersionHistory.json?url";

      import WebPluginsfiUrl from "ASSETS_DIR/locales/fi/WebPlugins.json?url";

      import WebhooksfiUrl from "ASSETS_DIR/locales/fi/Webhooks.json?url";

      import AboutfrUrl from "ASSETS_DIR/locales/fr/About.json?url";

      import ArchiveDialogfrUrl from "ASSETS_DIR/locales/fr/ArchiveDialog.json?url";

      import ArticlefrUrl from "ASSETS_DIR/locales/fr/Article.json?url";

      import BackupCodesDialogfrUrl from "ASSETS_DIR/locales/fr/BackupCodesDialog.json?url";

      import ChangeEmailDialogfrUrl from "ASSETS_DIR/locales/fr/ChangeEmailDialog.json?url";

      import ChangePasswordDialogfrUrl from "ASSETS_DIR/locales/fr/ChangePasswordDialog.json?url";

      import ChangePhoneDialogfrUrl from "ASSETS_DIR/locales/fr/ChangePhoneDialog.json?url";

      import ChangePortalOwnerfrUrl from "ASSETS_DIR/locales/fr/ChangePortalOwner.json?url";

      import ChangeUserStatusDialogfrUrl from "ASSETS_DIR/locales/fr/ChangeUserStatusDialog.json?url";

      import ChangeUserTypeDialogfrUrl from "ASSETS_DIR/locales/fr/ChangeUserTypeDialog.json?url";

      import ConnectDialogfrUrl from "ASSETS_DIR/locales/fr/ConnectDialog.json?url";

      import ConvertDialogfrUrl from "ASSETS_DIR/locales/fr/ConvertDialog.json?url";

      import ConvertPasswordDialogfrUrl from "ASSETS_DIR/locales/fr/ConvertPasswordDialog.json?url";

      import CreateEditRoomDialogfrUrl from "ASSETS_DIR/locales/fr/CreateEditRoomDialog.json?url";

      import DataReassignmentDialogfrUrl from "ASSETS_DIR/locales/fr/DataReassignmentDialog.json?url";

      import DeleteDialogfrUrl from "ASSETS_DIR/locales/fr/DeleteDialog.json?url";

      import DeleteProfileEverDialogfrUrl from "ASSETS_DIR/locales/fr/DeleteProfileEverDialog.json?url";

      import DeleteSelfProfileDialogfrUrl from "ASSETS_DIR/locales/fr/DeleteSelfProfileDialog.json?url";

      import DeleteThirdPartyDialogfrUrl from "ASSETS_DIR/locales/fr/DeleteThirdPartyDialog.json?url";

      import DowngradePlanDialogfrUrl from "ASSETS_DIR/locales/fr/DowngradePlanDialog.json?url";

      import EmbeddingPanelfrUrl from "ASSETS_DIR/locales/fr/EmbeddingPanel.json?url";

      import EmptyTrashDialogfrUrl from "ASSETS_DIR/locales/fr/EmptyTrashDialog.json?url";

      import EmptyViewfrUrl from "ASSETS_DIR/locales/fr/EmptyView.json?url";

      import ErrorsfrUrl from "ASSETS_DIR/locales/fr/Errors.json?url";

      import FilesfrUrl from "ASSETS_DIR/locales/fr/Files.json?url";

      import FilesSettingsfrUrl from "ASSETS_DIR/locales/fr/FilesSettings.json?url";

      import FillPDFDialogfrUrl from "ASSETS_DIR/locales/fr/FillPDFDialog.json?url";

      import FormFillingTipsDialogfrUrl from "ASSETS_DIR/locales/fr/FormFillingTipsDialog.json?url";

      import FormGalleryfrUrl from "ASSETS_DIR/locales/fr/FormGallery.json?url";

      import HotkeysPanelfrUrl from "ASSETS_DIR/locales/fr/HotkeysPanel.json?url";

      import InfoPanelfrUrl from "ASSETS_DIR/locales/fr/InfoPanel.json?url";

      import InviteDialogfrUrl from "ASSETS_DIR/locales/fr/InviteDialog.json?url";

      import JavascriptSdkfrUrl from "ASSETS_DIR/locales/fr/JavascriptSdk.json?url";

      import LdapfrUrl from "ASSETS_DIR/locales/fr/Ldap.json?url";

      import MainBarfrUrl from "ASSETS_DIR/locales/fr/MainBar.json?url";

      import NotificationsfrUrl from "ASSETS_DIR/locales/fr/Notifications.json?url";

      import OAuthfrUrl from "ASSETS_DIR/locales/fr/OAuth.json?url";

      import PDFFormDialogfrUrl from "ASSETS_DIR/locales/fr/PDFFormDialog.json?url";

      import PaymentsfrUrl from "ASSETS_DIR/locales/fr/Payments.json?url";

      import PaymentsEnterprisefrUrl from "ASSETS_DIR/locales/fr/PaymentsEnterprise.json?url";

      import PeoplefrUrl from "ASSETS_DIR/locales/fr/People.json?url";

      import PeopleTranslationsfrUrl from "ASSETS_DIR/locales/fr/PeopleTranslations.json?url";

      import PortalUnavailablefrUrl from "ASSETS_DIR/locales/fr/PortalUnavailable.json?url";

      import PreparationPortalfrUrl from "ASSETS_DIR/locales/fr/PreparationPortal.json?url";

      import PrivacyPagefrUrl from "ASSETS_DIR/locales/fr/PrivacyPage.json?url";

      import ProfilefrUrl from "ASSETS_DIR/locales/fr/Profile.json?url";

      import ResetApplicationDialogfrUrl from "ASSETS_DIR/locales/fr/ResetApplicationDialog.json?url";

      import RoomLogoCoverfrUrl from "ASSETS_DIR/locales/fr/RoomLogoCover.json?url";

      import SMTPSettingsfrUrl from "ASSETS_DIR/locales/fr/SMTPSettings.json?url";

      import SalesDepartmentRequestDialogfrUrl from "ASSETS_DIR/locales/fr/SalesDepartmentRequestDialog.json?url";

      import SendInviteDialogfrUrl from "ASSETS_DIR/locales/fr/SendInviteDialog.json?url";

      import SettingsfrUrl from "ASSETS_DIR/locales/fr/Settings.json?url";

      import SharingPanelfrUrl from "ASSETS_DIR/locales/fr/SharingPanel.json?url";

      import SingleSignOnfrUrl from "ASSETS_DIR/locales/fr/SingleSignOn.json?url";

      import SmartBannerfrUrl from "ASSETS_DIR/locales/fr/SmartBanner.json?url";

      import SocialAuthWelcomeDialogfrUrl from "ASSETS_DIR/locales/fr/SocialAuthWelcomeDialog.json?url";

      import TranslationsfrUrl from "ASSETS_DIR/locales/fr/Translations.json?url";

      import UploadPanelfrUrl from "ASSETS_DIR/locales/fr/UploadPanel.json?url";

      import VersionHistoryfrUrl from "ASSETS_DIR/locales/fr/VersionHistory.json?url";

      import WebPluginsfrUrl from "ASSETS_DIR/locales/fr/WebPlugins.json?url";

      import WebhooksfrUrl from "ASSETS_DIR/locales/fr/Webhooks.json?url";

      import AbouthyAMUrl from "ASSETS_DIR/locales/hy-AM/About.json?url";

      import ArchiveDialoghyAMUrl from "ASSETS_DIR/locales/hy-AM/ArchiveDialog.json?url";

      import ArticlehyAMUrl from "ASSETS_DIR/locales/hy-AM/Article.json?url";

      import BackupCodesDialoghyAMUrl from "ASSETS_DIR/locales/hy-AM/BackupCodesDialog.json?url";

      import ChangeEmailDialoghyAMUrl from "ASSETS_DIR/locales/hy-AM/ChangeEmailDialog.json?url";

      import ChangePasswordDialoghyAMUrl from "ASSETS_DIR/locales/hy-AM/ChangePasswordDialog.json?url";

      import ChangePhoneDialoghyAMUrl from "ASSETS_DIR/locales/hy-AM/ChangePhoneDialog.json?url";

      import ChangePortalOwnerhyAMUrl from "ASSETS_DIR/locales/hy-AM/ChangePortalOwner.json?url";

      import ChangeUserStatusDialoghyAMUrl from "ASSETS_DIR/locales/hy-AM/ChangeUserStatusDialog.json?url";

      import ChangeUserTypeDialoghyAMUrl from "ASSETS_DIR/locales/hy-AM/ChangeUserTypeDialog.json?url";

      import ConnectDialoghyAMUrl from "ASSETS_DIR/locales/hy-AM/ConnectDialog.json?url";

      import ConvertDialoghyAMUrl from "ASSETS_DIR/locales/hy-AM/ConvertDialog.json?url";

      import ConvertPasswordDialoghyAMUrl from "ASSETS_DIR/locales/hy-AM/ConvertPasswordDialog.json?url";

      import CreateEditRoomDialoghyAMUrl from "ASSETS_DIR/locales/hy-AM/CreateEditRoomDialog.json?url";

      import DataReassignmentDialoghyAMUrl from "ASSETS_DIR/locales/hy-AM/DataReassignmentDialog.json?url";

      import DeleteDialoghyAMUrl from "ASSETS_DIR/locales/hy-AM/DeleteDialog.json?url";

      import DeleteProfileEverDialoghyAMUrl from "ASSETS_DIR/locales/hy-AM/DeleteProfileEverDialog.json?url";

      import DeleteSelfProfileDialoghyAMUrl from "ASSETS_DIR/locales/hy-AM/DeleteSelfProfileDialog.json?url";

      import DeleteThirdPartyDialoghyAMUrl from "ASSETS_DIR/locales/hy-AM/DeleteThirdPartyDialog.json?url";

      import DowngradePlanDialoghyAMUrl from "ASSETS_DIR/locales/hy-AM/DowngradePlanDialog.json?url";

      import EmbeddingPanelhyAMUrl from "ASSETS_DIR/locales/hy-AM/EmbeddingPanel.json?url";

      import EmptyTrashDialoghyAMUrl from "ASSETS_DIR/locales/hy-AM/EmptyTrashDialog.json?url";

      import EmptyViewhyAMUrl from "ASSETS_DIR/locales/hy-AM/EmptyView.json?url";

      import ErrorshyAMUrl from "ASSETS_DIR/locales/hy-AM/Errors.json?url";

      import FileshyAMUrl from "ASSETS_DIR/locales/hy-AM/Files.json?url";

      import FilesSettingshyAMUrl from "ASSETS_DIR/locales/hy-AM/FilesSettings.json?url";

      import FillPDFDialoghyAMUrl from "ASSETS_DIR/locales/hy-AM/FillPDFDialog.json?url";

      import FormFillingTipsDialoghyAMUrl from "ASSETS_DIR/locales/hy-AM/FormFillingTipsDialog.json?url";

      import FormGalleryhyAMUrl from "ASSETS_DIR/locales/hy-AM/FormGallery.json?url";

      import HotkeysPanelhyAMUrl from "ASSETS_DIR/locales/hy-AM/HotkeysPanel.json?url";

      import InfoPanelhyAMUrl from "ASSETS_DIR/locales/hy-AM/InfoPanel.json?url";

      import InviteDialoghyAMUrl from "ASSETS_DIR/locales/hy-AM/InviteDialog.json?url";

      import JavascriptSdkhyAMUrl from "ASSETS_DIR/locales/hy-AM/JavascriptSdk.json?url";

      import LdaphyAMUrl from "ASSETS_DIR/locales/hy-AM/Ldap.json?url";

      import MainBarhyAMUrl from "ASSETS_DIR/locales/hy-AM/MainBar.json?url";

      import NotificationshyAMUrl from "ASSETS_DIR/locales/hy-AM/Notifications.json?url";

      import OAuthhyAMUrl from "ASSETS_DIR/locales/hy-AM/OAuth.json?url";

      import PDFFormDialoghyAMUrl from "ASSETS_DIR/locales/hy-AM/PDFFormDialog.json?url";

      import PaymentshyAMUrl from "ASSETS_DIR/locales/hy-AM/Payments.json?url";

      import PaymentsEnterprisehyAMUrl from "ASSETS_DIR/locales/hy-AM/PaymentsEnterprise.json?url";

      import PeoplehyAMUrl from "ASSETS_DIR/locales/hy-AM/People.json?url";

      import PeopleTranslationshyAMUrl from "ASSETS_DIR/locales/hy-AM/PeopleTranslations.json?url";

      import PortalUnavailablehyAMUrl from "ASSETS_DIR/locales/hy-AM/PortalUnavailable.json?url";

      import PreparationPortalhyAMUrl from "ASSETS_DIR/locales/hy-AM/PreparationPortal.json?url";

      import PrivacyPagehyAMUrl from "ASSETS_DIR/locales/hy-AM/PrivacyPage.json?url";

      import ProfilehyAMUrl from "ASSETS_DIR/locales/hy-AM/Profile.json?url";

      import ResetApplicationDialoghyAMUrl from "ASSETS_DIR/locales/hy-AM/ResetApplicationDialog.json?url";

      import RoomLogoCoverhyAMUrl from "ASSETS_DIR/locales/hy-AM/RoomLogoCover.json?url";

      import SMTPSettingshyAMUrl from "ASSETS_DIR/locales/hy-AM/SMTPSettings.json?url";

      import SalesDepartmentRequestDialoghyAMUrl from "ASSETS_DIR/locales/hy-AM/SalesDepartmentRequestDialog.json?url";

      import SendInviteDialoghyAMUrl from "ASSETS_DIR/locales/hy-AM/SendInviteDialog.json?url";

      import SettingshyAMUrl from "ASSETS_DIR/locales/hy-AM/Settings.json?url";

      import SharingPanelhyAMUrl from "ASSETS_DIR/locales/hy-AM/SharingPanel.json?url";

      import SingleSignOnhyAMUrl from "ASSETS_DIR/locales/hy-AM/SingleSignOn.json?url";

      import SmartBannerhyAMUrl from "ASSETS_DIR/locales/hy-AM/SmartBanner.json?url";

      import SocialAuthWelcomeDialoghyAMUrl from "ASSETS_DIR/locales/hy-AM/SocialAuthWelcomeDialog.json?url";

      import TranslationshyAMUrl from "ASSETS_DIR/locales/hy-AM/Translations.json?url";

      import UploadPanelhyAMUrl from "ASSETS_DIR/locales/hy-AM/UploadPanel.json?url";

      import VersionHistoryhyAMUrl from "ASSETS_DIR/locales/hy-AM/VersionHistory.json?url";

      import WebPluginshyAMUrl from "ASSETS_DIR/locales/hy-AM/WebPlugins.json?url";

      import WebhookshyAMUrl from "ASSETS_DIR/locales/hy-AM/Webhooks.json?url";

      import AboutitUrl from "ASSETS_DIR/locales/it/About.json?url";

      import ArchiveDialogitUrl from "ASSETS_DIR/locales/it/ArchiveDialog.json?url";

      import ArticleitUrl from "ASSETS_DIR/locales/it/Article.json?url";

      import BackupCodesDialogitUrl from "ASSETS_DIR/locales/it/BackupCodesDialog.json?url";

      import ChangeEmailDialogitUrl from "ASSETS_DIR/locales/it/ChangeEmailDialog.json?url";

      import ChangePasswordDialogitUrl from "ASSETS_DIR/locales/it/ChangePasswordDialog.json?url";

      import ChangePhoneDialogitUrl from "ASSETS_DIR/locales/it/ChangePhoneDialog.json?url";

      import ChangePortalOwneritUrl from "ASSETS_DIR/locales/it/ChangePortalOwner.json?url";

      import ChangeUserStatusDialogitUrl from "ASSETS_DIR/locales/it/ChangeUserStatusDialog.json?url";

      import ChangeUserTypeDialogitUrl from "ASSETS_DIR/locales/it/ChangeUserTypeDialog.json?url";

      import ConnectDialogitUrl from "ASSETS_DIR/locales/it/ConnectDialog.json?url";

      import ConvertDialogitUrl from "ASSETS_DIR/locales/it/ConvertDialog.json?url";

      import ConvertPasswordDialogitUrl from "ASSETS_DIR/locales/it/ConvertPasswordDialog.json?url";

      import CreateEditRoomDialogitUrl from "ASSETS_DIR/locales/it/CreateEditRoomDialog.json?url";

      import DataReassignmentDialogitUrl from "ASSETS_DIR/locales/it/DataReassignmentDialog.json?url";

      import DeleteDialogitUrl from "ASSETS_DIR/locales/it/DeleteDialog.json?url";

      import DeleteProfileEverDialogitUrl from "ASSETS_DIR/locales/it/DeleteProfileEverDialog.json?url";

      import DeleteSelfProfileDialogitUrl from "ASSETS_DIR/locales/it/DeleteSelfProfileDialog.json?url";

      import DeleteThirdPartyDialogitUrl from "ASSETS_DIR/locales/it/DeleteThirdPartyDialog.json?url";

      import DowngradePlanDialogitUrl from "ASSETS_DIR/locales/it/DowngradePlanDialog.json?url";

      import EmbeddingPanelitUrl from "ASSETS_DIR/locales/it/EmbeddingPanel.json?url";

      import EmptyTrashDialogitUrl from "ASSETS_DIR/locales/it/EmptyTrashDialog.json?url";

      import EmptyViewitUrl from "ASSETS_DIR/locales/it/EmptyView.json?url";

      import ErrorsitUrl from "ASSETS_DIR/locales/it/Errors.json?url";

      import FilesitUrl from "ASSETS_DIR/locales/it/Files.json?url";

      import FilesSettingsitUrl from "ASSETS_DIR/locales/it/FilesSettings.json?url";

      import FillPDFDialogitUrl from "ASSETS_DIR/locales/it/FillPDFDialog.json?url";

      import FormFillingTipsDialogitUrl from "ASSETS_DIR/locales/it/FormFillingTipsDialog.json?url";

      import FormGalleryitUrl from "ASSETS_DIR/locales/it/FormGallery.json?url";

      import HotkeysPanelitUrl from "ASSETS_DIR/locales/it/HotkeysPanel.json?url";

      import InfoPanelitUrl from "ASSETS_DIR/locales/it/InfoPanel.json?url";

      import InviteDialogitUrl from "ASSETS_DIR/locales/it/InviteDialog.json?url";

      import JavascriptSdkitUrl from "ASSETS_DIR/locales/it/JavascriptSdk.json?url";

      import LdapitUrl from "ASSETS_DIR/locales/it/Ldap.json?url";

      import MainBaritUrl from "ASSETS_DIR/locales/it/MainBar.json?url";

      import NotificationsitUrl from "ASSETS_DIR/locales/it/Notifications.json?url";

      import OAuthitUrl from "ASSETS_DIR/locales/it/OAuth.json?url";

      import PDFFormDialogitUrl from "ASSETS_DIR/locales/it/PDFFormDialog.json?url";

      import PaymentsitUrl from "ASSETS_DIR/locales/it/Payments.json?url";

      import PaymentsEnterpriseitUrl from "ASSETS_DIR/locales/it/PaymentsEnterprise.json?url";

      import PeopleitUrl from "ASSETS_DIR/locales/it/People.json?url";

      import PeopleTranslationsitUrl from "ASSETS_DIR/locales/it/PeopleTranslations.json?url";

      import PortalUnavailableitUrl from "ASSETS_DIR/locales/it/PortalUnavailable.json?url";

      import PreparationPortalitUrl from "ASSETS_DIR/locales/it/PreparationPortal.json?url";

      import PrivacyPageitUrl from "ASSETS_DIR/locales/it/PrivacyPage.json?url";

      import ProfileitUrl from "ASSETS_DIR/locales/it/Profile.json?url";

      import ResetApplicationDialogitUrl from "ASSETS_DIR/locales/it/ResetApplicationDialog.json?url";

      import RoomLogoCoveritUrl from "ASSETS_DIR/locales/it/RoomLogoCover.json?url";

      import SMTPSettingsitUrl from "ASSETS_DIR/locales/it/SMTPSettings.json?url";

      import SalesDepartmentRequestDialogitUrl from "ASSETS_DIR/locales/it/SalesDepartmentRequestDialog.json?url";

      import SendInviteDialogitUrl from "ASSETS_DIR/locales/it/SendInviteDialog.json?url";

      import SettingsitUrl from "ASSETS_DIR/locales/it/Settings.json?url";

      import SharingPanelitUrl from "ASSETS_DIR/locales/it/SharingPanel.json?url";

      import SingleSignOnitUrl from "ASSETS_DIR/locales/it/SingleSignOn.json?url";

      import SmartBanneritUrl from "ASSETS_DIR/locales/it/SmartBanner.json?url";

      import SocialAuthWelcomeDialogitUrl from "ASSETS_DIR/locales/it/SocialAuthWelcomeDialog.json?url";

      import TranslationsitUrl from "ASSETS_DIR/locales/it/Translations.json?url";

      import UploadPanelitUrl from "ASSETS_DIR/locales/it/UploadPanel.json?url";

      import VersionHistoryitUrl from "ASSETS_DIR/locales/it/VersionHistory.json?url";

      import WebPluginsitUrl from "ASSETS_DIR/locales/it/WebPlugins.json?url";

      import WebhooksitUrl from "ASSETS_DIR/locales/it/Webhooks.json?url";

      import AboutjaJPUrl from "ASSETS_DIR/locales/ja-JP/About.json?url";

      import ArchiveDialogjaJPUrl from "ASSETS_DIR/locales/ja-JP/ArchiveDialog.json?url";

      import ArticlejaJPUrl from "ASSETS_DIR/locales/ja-JP/Article.json?url";

      import BackupCodesDialogjaJPUrl from "ASSETS_DIR/locales/ja-JP/BackupCodesDialog.json?url";

      import ChangeEmailDialogjaJPUrl from "ASSETS_DIR/locales/ja-JP/ChangeEmailDialog.json?url";

      import ChangePasswordDialogjaJPUrl from "ASSETS_DIR/locales/ja-JP/ChangePasswordDialog.json?url";

      import ChangePhoneDialogjaJPUrl from "ASSETS_DIR/locales/ja-JP/ChangePhoneDialog.json?url";

      import ChangePortalOwnerjaJPUrl from "ASSETS_DIR/locales/ja-JP/ChangePortalOwner.json?url";

      import ChangeUserStatusDialogjaJPUrl from "ASSETS_DIR/locales/ja-JP/ChangeUserStatusDialog.json?url";

      import ChangeUserTypeDialogjaJPUrl from "ASSETS_DIR/locales/ja-JP/ChangeUserTypeDialog.json?url";

      import ConnectDialogjaJPUrl from "ASSETS_DIR/locales/ja-JP/ConnectDialog.json?url";

      import ConvertDialogjaJPUrl from "ASSETS_DIR/locales/ja-JP/ConvertDialog.json?url";

      import ConvertPasswordDialogjaJPUrl from "ASSETS_DIR/locales/ja-JP/ConvertPasswordDialog.json?url";

      import CreateEditRoomDialogjaJPUrl from "ASSETS_DIR/locales/ja-JP/CreateEditRoomDialog.json?url";

      import DataReassignmentDialogjaJPUrl from "ASSETS_DIR/locales/ja-JP/DataReassignmentDialog.json?url";

      import DeleteDialogjaJPUrl from "ASSETS_DIR/locales/ja-JP/DeleteDialog.json?url";

      import DeleteProfileEverDialogjaJPUrl from "ASSETS_DIR/locales/ja-JP/DeleteProfileEverDialog.json?url";

      import DeleteSelfProfileDialogjaJPUrl from "ASSETS_DIR/locales/ja-JP/DeleteSelfProfileDialog.json?url";

      import DeleteThirdPartyDialogjaJPUrl from "ASSETS_DIR/locales/ja-JP/DeleteThirdPartyDialog.json?url";

      import DowngradePlanDialogjaJPUrl from "ASSETS_DIR/locales/ja-JP/DowngradePlanDialog.json?url";

      import EmbeddingPaneljaJPUrl from "ASSETS_DIR/locales/ja-JP/EmbeddingPanel.json?url";

      import EmptyTrashDialogjaJPUrl from "ASSETS_DIR/locales/ja-JP/EmptyTrashDialog.json?url";

      import EmptyViewjaJPUrl from "ASSETS_DIR/locales/ja-JP/EmptyView.json?url";

      import ErrorsjaJPUrl from "ASSETS_DIR/locales/ja-JP/Errors.json?url";

      import FilesjaJPUrl from "ASSETS_DIR/locales/ja-JP/Files.json?url";

      import FilesSettingsjaJPUrl from "ASSETS_DIR/locales/ja-JP/FilesSettings.json?url";

      import FillPDFDialogjaJPUrl from "ASSETS_DIR/locales/ja-JP/FillPDFDialog.json?url";

      import FormFillingTipsDialogjaJPUrl from "ASSETS_DIR/locales/ja-JP/FormFillingTipsDialog.json?url";

      import FormGalleryjaJPUrl from "ASSETS_DIR/locales/ja-JP/FormGallery.json?url";

      import HotkeysPaneljaJPUrl from "ASSETS_DIR/locales/ja-JP/HotkeysPanel.json?url";

      import InfoPaneljaJPUrl from "ASSETS_DIR/locales/ja-JP/InfoPanel.json?url";

      import InviteDialogjaJPUrl from "ASSETS_DIR/locales/ja-JP/InviteDialog.json?url";

      import JavascriptSdkjaJPUrl from "ASSETS_DIR/locales/ja-JP/JavascriptSdk.json?url";

      import LdapjaJPUrl from "ASSETS_DIR/locales/ja-JP/Ldap.json?url";

      import MainBarjaJPUrl from "ASSETS_DIR/locales/ja-JP/MainBar.json?url";

      import NotificationsjaJPUrl from "ASSETS_DIR/locales/ja-JP/Notifications.json?url";

      import OAuthjaJPUrl from "ASSETS_DIR/locales/ja-JP/OAuth.json?url";

      import PDFFormDialogjaJPUrl from "ASSETS_DIR/locales/ja-JP/PDFFormDialog.json?url";

      import PaymentsjaJPUrl from "ASSETS_DIR/locales/ja-JP/Payments.json?url";

      import PaymentsEnterprisejaJPUrl from "ASSETS_DIR/locales/ja-JP/PaymentsEnterprise.json?url";

      import PeoplejaJPUrl from "ASSETS_DIR/locales/ja-JP/People.json?url";

      import PeopleTranslationsjaJPUrl from "ASSETS_DIR/locales/ja-JP/PeopleTranslations.json?url";

      import PortalUnavailablejaJPUrl from "ASSETS_DIR/locales/ja-JP/PortalUnavailable.json?url";

      import PreparationPortaljaJPUrl from "ASSETS_DIR/locales/ja-JP/PreparationPortal.json?url";

      import PrivacyPagejaJPUrl from "ASSETS_DIR/locales/ja-JP/PrivacyPage.json?url";

      import ProfilejaJPUrl from "ASSETS_DIR/locales/ja-JP/Profile.json?url";

      import ResetApplicationDialogjaJPUrl from "ASSETS_DIR/locales/ja-JP/ResetApplicationDialog.json?url";

      import RoomLogoCoverjaJPUrl from "ASSETS_DIR/locales/ja-JP/RoomLogoCover.json?url";

      import SMTPSettingsjaJPUrl from "ASSETS_DIR/locales/ja-JP/SMTPSettings.json?url";

      import SalesDepartmentRequestDialogjaJPUrl from "ASSETS_DIR/locales/ja-JP/SalesDepartmentRequestDialog.json?url";

      import SendInviteDialogjaJPUrl from "ASSETS_DIR/locales/ja-JP/SendInviteDialog.json?url";

      import SettingsjaJPUrl from "ASSETS_DIR/locales/ja-JP/Settings.json?url";

      import SharingPaneljaJPUrl from "ASSETS_DIR/locales/ja-JP/SharingPanel.json?url";

      import SingleSignOnjaJPUrl from "ASSETS_DIR/locales/ja-JP/SingleSignOn.json?url";

      import SmartBannerjaJPUrl from "ASSETS_DIR/locales/ja-JP/SmartBanner.json?url";

      import SocialAuthWelcomeDialogjaJPUrl from "ASSETS_DIR/locales/ja-JP/SocialAuthWelcomeDialog.json?url";

      import TranslationsjaJPUrl from "ASSETS_DIR/locales/ja-JP/Translations.json?url";

      import UploadPaneljaJPUrl from "ASSETS_DIR/locales/ja-JP/UploadPanel.json?url";

      import VersionHistoryjaJPUrl from "ASSETS_DIR/locales/ja-JP/VersionHistory.json?url";

      import WebPluginsjaJPUrl from "ASSETS_DIR/locales/ja-JP/WebPlugins.json?url";

      import WebhooksjaJPUrl from "ASSETS_DIR/locales/ja-JP/Webhooks.json?url";

      import AboutkoKRUrl from "ASSETS_DIR/locales/ko-KR/About.json?url";

      import ArchiveDialogkoKRUrl from "ASSETS_DIR/locales/ko-KR/ArchiveDialog.json?url";

      import ArticlekoKRUrl from "ASSETS_DIR/locales/ko-KR/Article.json?url";

      import BackupCodesDialogkoKRUrl from "ASSETS_DIR/locales/ko-KR/BackupCodesDialog.json?url";

      import ChangeEmailDialogkoKRUrl from "ASSETS_DIR/locales/ko-KR/ChangeEmailDialog.json?url";

      import ChangePasswordDialogkoKRUrl from "ASSETS_DIR/locales/ko-KR/ChangePasswordDialog.json?url";

      import ChangePhoneDialogkoKRUrl from "ASSETS_DIR/locales/ko-KR/ChangePhoneDialog.json?url";

      import ChangePortalOwnerkoKRUrl from "ASSETS_DIR/locales/ko-KR/ChangePortalOwner.json?url";

      import ChangeUserStatusDialogkoKRUrl from "ASSETS_DIR/locales/ko-KR/ChangeUserStatusDialog.json?url";

      import ChangeUserTypeDialogkoKRUrl from "ASSETS_DIR/locales/ko-KR/ChangeUserTypeDialog.json?url";

      import ConnectDialogkoKRUrl from "ASSETS_DIR/locales/ko-KR/ConnectDialog.json?url";

      import ConvertDialogkoKRUrl from "ASSETS_DIR/locales/ko-KR/ConvertDialog.json?url";

      import ConvertPasswordDialogkoKRUrl from "ASSETS_DIR/locales/ko-KR/ConvertPasswordDialog.json?url";

      import CreateEditRoomDialogkoKRUrl from "ASSETS_DIR/locales/ko-KR/CreateEditRoomDialog.json?url";

      import DataReassignmentDialogkoKRUrl from "ASSETS_DIR/locales/ko-KR/DataReassignmentDialog.json?url";

      import DeleteDialogkoKRUrl from "ASSETS_DIR/locales/ko-KR/DeleteDialog.json?url";

      import DeleteProfileEverDialogkoKRUrl from "ASSETS_DIR/locales/ko-KR/DeleteProfileEverDialog.json?url";

      import DeleteSelfProfileDialogkoKRUrl from "ASSETS_DIR/locales/ko-KR/DeleteSelfProfileDialog.json?url";

      import DeleteThirdPartyDialogkoKRUrl from "ASSETS_DIR/locales/ko-KR/DeleteThirdPartyDialog.json?url";

      import DowngradePlanDialogkoKRUrl from "ASSETS_DIR/locales/ko-KR/DowngradePlanDialog.json?url";

      import EmbeddingPanelkoKRUrl from "ASSETS_DIR/locales/ko-KR/EmbeddingPanel.json?url";

      import EmptyTrashDialogkoKRUrl from "ASSETS_DIR/locales/ko-KR/EmptyTrashDialog.json?url";

      import EmptyViewkoKRUrl from "ASSETS_DIR/locales/ko-KR/EmptyView.json?url";

      import ErrorskoKRUrl from "ASSETS_DIR/locales/ko-KR/Errors.json?url";

      import FileskoKRUrl from "ASSETS_DIR/locales/ko-KR/Files.json?url";

      import FilesSettingskoKRUrl from "ASSETS_DIR/locales/ko-KR/FilesSettings.json?url";

      import FillPDFDialogkoKRUrl from "ASSETS_DIR/locales/ko-KR/FillPDFDialog.json?url";

      import FormFillingTipsDialogkoKRUrl from "ASSETS_DIR/locales/ko-KR/FormFillingTipsDialog.json?url";

      import FormGallerykoKRUrl from "ASSETS_DIR/locales/ko-KR/FormGallery.json?url";

      import HotkeysPanelkoKRUrl from "ASSETS_DIR/locales/ko-KR/HotkeysPanel.json?url";

      import InfoPanelkoKRUrl from "ASSETS_DIR/locales/ko-KR/InfoPanel.json?url";

      import InviteDialogkoKRUrl from "ASSETS_DIR/locales/ko-KR/InviteDialog.json?url";

      import JavascriptSdkkoKRUrl from "ASSETS_DIR/locales/ko-KR/JavascriptSdk.json?url";

      import LdapkoKRUrl from "ASSETS_DIR/locales/ko-KR/Ldap.json?url";

      import MainBarkoKRUrl from "ASSETS_DIR/locales/ko-KR/MainBar.json?url";

      import NotificationskoKRUrl from "ASSETS_DIR/locales/ko-KR/Notifications.json?url";

      import OAuthkoKRUrl from "ASSETS_DIR/locales/ko-KR/OAuth.json?url";

      import PDFFormDialogkoKRUrl from "ASSETS_DIR/locales/ko-KR/PDFFormDialog.json?url";

      import PaymentskoKRUrl from "ASSETS_DIR/locales/ko-KR/Payments.json?url";

      import PaymentsEnterprisekoKRUrl from "ASSETS_DIR/locales/ko-KR/PaymentsEnterprise.json?url";

      import PeoplekoKRUrl from "ASSETS_DIR/locales/ko-KR/People.json?url";

      import PeopleTranslationskoKRUrl from "ASSETS_DIR/locales/ko-KR/PeopleTranslations.json?url";

      import PortalUnavailablekoKRUrl from "ASSETS_DIR/locales/ko-KR/PortalUnavailable.json?url";

      import PreparationPortalkoKRUrl from "ASSETS_DIR/locales/ko-KR/PreparationPortal.json?url";

      import PrivacyPagekoKRUrl from "ASSETS_DIR/locales/ko-KR/PrivacyPage.json?url";

      import ProfilekoKRUrl from "ASSETS_DIR/locales/ko-KR/Profile.json?url";

      import ResetApplicationDialogkoKRUrl from "ASSETS_DIR/locales/ko-KR/ResetApplicationDialog.json?url";

      import RoomLogoCoverkoKRUrl from "ASSETS_DIR/locales/ko-KR/RoomLogoCover.json?url";

      import SMTPSettingskoKRUrl from "ASSETS_DIR/locales/ko-KR/SMTPSettings.json?url";

      import SalesDepartmentRequestDialogkoKRUrl from "ASSETS_DIR/locales/ko-KR/SalesDepartmentRequestDialog.json?url";

      import SendInviteDialogkoKRUrl from "ASSETS_DIR/locales/ko-KR/SendInviteDialog.json?url";

      import SettingskoKRUrl from "ASSETS_DIR/locales/ko-KR/Settings.json?url";

      import SharingPanelkoKRUrl from "ASSETS_DIR/locales/ko-KR/SharingPanel.json?url";

      import SingleSignOnkoKRUrl from "ASSETS_DIR/locales/ko-KR/SingleSignOn.json?url";

      import SmartBannerkoKRUrl from "ASSETS_DIR/locales/ko-KR/SmartBanner.json?url";

      import SocialAuthWelcomeDialogkoKRUrl from "ASSETS_DIR/locales/ko-KR/SocialAuthWelcomeDialog.json?url";

      import TranslationskoKRUrl from "ASSETS_DIR/locales/ko-KR/Translations.json?url";

      import UploadPanelkoKRUrl from "ASSETS_DIR/locales/ko-KR/UploadPanel.json?url";

      import VersionHistorykoKRUrl from "ASSETS_DIR/locales/ko-KR/VersionHistory.json?url";

      import WebPluginskoKRUrl from "ASSETS_DIR/locales/ko-KR/WebPlugins.json?url";

      import WebhookskoKRUrl from "ASSETS_DIR/locales/ko-KR/Webhooks.json?url";

      import AboutloLAUrl from "ASSETS_DIR/locales/lo-LA/About.json?url";

      import ArchiveDialogloLAUrl from "ASSETS_DIR/locales/lo-LA/ArchiveDialog.json?url";

      import ArticleloLAUrl from "ASSETS_DIR/locales/lo-LA/Article.json?url";

      import BackupCodesDialogloLAUrl from "ASSETS_DIR/locales/lo-LA/BackupCodesDialog.json?url";

      import ChangeEmailDialogloLAUrl from "ASSETS_DIR/locales/lo-LA/ChangeEmailDialog.json?url";

      import ChangePasswordDialogloLAUrl from "ASSETS_DIR/locales/lo-LA/ChangePasswordDialog.json?url";

      import ChangePhoneDialogloLAUrl from "ASSETS_DIR/locales/lo-LA/ChangePhoneDialog.json?url";

      import ChangePortalOwnerloLAUrl from "ASSETS_DIR/locales/lo-LA/ChangePortalOwner.json?url";

      import ChangeUserStatusDialogloLAUrl from "ASSETS_DIR/locales/lo-LA/ChangeUserStatusDialog.json?url";

      import ChangeUserTypeDialogloLAUrl from "ASSETS_DIR/locales/lo-LA/ChangeUserTypeDialog.json?url";

      import ConnectDialogloLAUrl from "ASSETS_DIR/locales/lo-LA/ConnectDialog.json?url";

      import ConvertDialogloLAUrl from "ASSETS_DIR/locales/lo-LA/ConvertDialog.json?url";

      import ConvertPasswordDialogloLAUrl from "ASSETS_DIR/locales/lo-LA/ConvertPasswordDialog.json?url";

      import CreateEditRoomDialogloLAUrl from "ASSETS_DIR/locales/lo-LA/CreateEditRoomDialog.json?url";

      import DataReassignmentDialogloLAUrl from "ASSETS_DIR/locales/lo-LA/DataReassignmentDialog.json?url";

      import DeleteDialogloLAUrl from "ASSETS_DIR/locales/lo-LA/DeleteDialog.json?url";

      import DeleteProfileEverDialogloLAUrl from "ASSETS_DIR/locales/lo-LA/DeleteProfileEverDialog.json?url";

      import DeleteSelfProfileDialogloLAUrl from "ASSETS_DIR/locales/lo-LA/DeleteSelfProfileDialog.json?url";

      import DeleteThirdPartyDialogloLAUrl from "ASSETS_DIR/locales/lo-LA/DeleteThirdPartyDialog.json?url";

      import DowngradePlanDialogloLAUrl from "ASSETS_DIR/locales/lo-LA/DowngradePlanDialog.json?url";

      import EmbeddingPanelloLAUrl from "ASSETS_DIR/locales/lo-LA/EmbeddingPanel.json?url";

      import EmptyTrashDialogloLAUrl from "ASSETS_DIR/locales/lo-LA/EmptyTrashDialog.json?url";

      import EmptyViewloLAUrl from "ASSETS_DIR/locales/lo-LA/EmptyView.json?url";

      import ErrorsloLAUrl from "ASSETS_DIR/locales/lo-LA/Errors.json?url";

      import FilesloLAUrl from "ASSETS_DIR/locales/lo-LA/Files.json?url";

      import FilesSettingsloLAUrl from "ASSETS_DIR/locales/lo-LA/FilesSettings.json?url";

      import FillPDFDialogloLAUrl from "ASSETS_DIR/locales/lo-LA/FillPDFDialog.json?url";

      import FormFillingTipsDialogloLAUrl from "ASSETS_DIR/locales/lo-LA/FormFillingTipsDialog.json?url";

      import FormGalleryloLAUrl from "ASSETS_DIR/locales/lo-LA/FormGallery.json?url";

      import HotkeysPanelloLAUrl from "ASSETS_DIR/locales/lo-LA/HotkeysPanel.json?url";

      import InfoPanelloLAUrl from "ASSETS_DIR/locales/lo-LA/InfoPanel.json?url";

      import InviteDialogloLAUrl from "ASSETS_DIR/locales/lo-LA/InviteDialog.json?url";

      import JavascriptSdkloLAUrl from "ASSETS_DIR/locales/lo-LA/JavascriptSdk.json?url";

      import LdaploLAUrl from "ASSETS_DIR/locales/lo-LA/Ldap.json?url";

      import MainBarloLAUrl from "ASSETS_DIR/locales/lo-LA/MainBar.json?url";

      import NotificationsloLAUrl from "ASSETS_DIR/locales/lo-LA/Notifications.json?url";

      import OAuthloLAUrl from "ASSETS_DIR/locales/lo-LA/OAuth.json?url";

      import PDFFormDialogloLAUrl from "ASSETS_DIR/locales/lo-LA/PDFFormDialog.json?url";

      import PaymentsloLAUrl from "ASSETS_DIR/locales/lo-LA/Payments.json?url";

      import PaymentsEnterpriseloLAUrl from "ASSETS_DIR/locales/lo-LA/PaymentsEnterprise.json?url";

      import PeopleloLAUrl from "ASSETS_DIR/locales/lo-LA/People.json?url";

      import PeopleTranslationsloLAUrl from "ASSETS_DIR/locales/lo-LA/PeopleTranslations.json?url";

      import PortalUnavailableloLAUrl from "ASSETS_DIR/locales/lo-LA/PortalUnavailable.json?url";

      import PreparationPortalloLAUrl from "ASSETS_DIR/locales/lo-LA/PreparationPortal.json?url";

      import PrivacyPageloLAUrl from "ASSETS_DIR/locales/lo-LA/PrivacyPage.json?url";

      import ProfileloLAUrl from "ASSETS_DIR/locales/lo-LA/Profile.json?url";

      import ResetApplicationDialogloLAUrl from "ASSETS_DIR/locales/lo-LA/ResetApplicationDialog.json?url";

      import RoomLogoCoverloLAUrl from "ASSETS_DIR/locales/lo-LA/RoomLogoCover.json?url";

      import SMTPSettingsloLAUrl from "ASSETS_DIR/locales/lo-LA/SMTPSettings.json?url";

      import SalesDepartmentRequestDialogloLAUrl from "ASSETS_DIR/locales/lo-LA/SalesDepartmentRequestDialog.json?url";

      import SendInviteDialogloLAUrl from "ASSETS_DIR/locales/lo-LA/SendInviteDialog.json?url";

      import SettingsloLAUrl from "ASSETS_DIR/locales/lo-LA/Settings.json?url";

      import SharingPanelloLAUrl from "ASSETS_DIR/locales/lo-LA/SharingPanel.json?url";

      import SingleSignOnloLAUrl from "ASSETS_DIR/locales/lo-LA/SingleSignOn.json?url";

      import SmartBannerloLAUrl from "ASSETS_DIR/locales/lo-LA/SmartBanner.json?url";

      import SocialAuthWelcomeDialogloLAUrl from "ASSETS_DIR/locales/lo-LA/SocialAuthWelcomeDialog.json?url";

      import TranslationsloLAUrl from "ASSETS_DIR/locales/lo-LA/Translations.json?url";

      import UploadPanelloLAUrl from "ASSETS_DIR/locales/lo-LA/UploadPanel.json?url";

      import VersionHistoryloLAUrl from "ASSETS_DIR/locales/lo-LA/VersionHistory.json?url";

      import WebPluginsloLAUrl from "ASSETS_DIR/locales/lo-LA/WebPlugins.json?url";

      import WebhooksloLAUrl from "ASSETS_DIR/locales/lo-LA/Webhooks.json?url";

      import AboutlvUrl from "ASSETS_DIR/locales/lv/About.json?url";

      import ArchiveDialoglvUrl from "ASSETS_DIR/locales/lv/ArchiveDialog.json?url";

      import ArticlelvUrl from "ASSETS_DIR/locales/lv/Article.json?url";

      import BackupCodesDialoglvUrl from "ASSETS_DIR/locales/lv/BackupCodesDialog.json?url";

      import ChangeEmailDialoglvUrl from "ASSETS_DIR/locales/lv/ChangeEmailDialog.json?url";

      import ChangePasswordDialoglvUrl from "ASSETS_DIR/locales/lv/ChangePasswordDialog.json?url";

      import ChangePhoneDialoglvUrl from "ASSETS_DIR/locales/lv/ChangePhoneDialog.json?url";

      import ChangePortalOwnerlvUrl from "ASSETS_DIR/locales/lv/ChangePortalOwner.json?url";

      import ChangeUserStatusDialoglvUrl from "ASSETS_DIR/locales/lv/ChangeUserStatusDialog.json?url";

      import ChangeUserTypeDialoglvUrl from "ASSETS_DIR/locales/lv/ChangeUserTypeDialog.json?url";

      import ConnectDialoglvUrl from "ASSETS_DIR/locales/lv/ConnectDialog.json?url";

      import ConvertDialoglvUrl from "ASSETS_DIR/locales/lv/ConvertDialog.json?url";

      import ConvertPasswordDialoglvUrl from "ASSETS_DIR/locales/lv/ConvertPasswordDialog.json?url";

      import CreateEditRoomDialoglvUrl from "ASSETS_DIR/locales/lv/CreateEditRoomDialog.json?url";

      import DataReassignmentDialoglvUrl from "ASSETS_DIR/locales/lv/DataReassignmentDialog.json?url";

      import DeleteDialoglvUrl from "ASSETS_DIR/locales/lv/DeleteDialog.json?url";

      import DeleteProfileEverDialoglvUrl from "ASSETS_DIR/locales/lv/DeleteProfileEverDialog.json?url";

      import DeleteSelfProfileDialoglvUrl from "ASSETS_DIR/locales/lv/DeleteSelfProfileDialog.json?url";

      import DeleteThirdPartyDialoglvUrl from "ASSETS_DIR/locales/lv/DeleteThirdPartyDialog.json?url";

      import DowngradePlanDialoglvUrl from "ASSETS_DIR/locales/lv/DowngradePlanDialog.json?url";

      import EmbeddingPanellvUrl from "ASSETS_DIR/locales/lv/EmbeddingPanel.json?url";

      import EmptyTrashDialoglvUrl from "ASSETS_DIR/locales/lv/EmptyTrashDialog.json?url";

      import EmptyViewlvUrl from "ASSETS_DIR/locales/lv/EmptyView.json?url";

      import ErrorslvUrl from "ASSETS_DIR/locales/lv/Errors.json?url";

      import FileslvUrl from "ASSETS_DIR/locales/lv/Files.json?url";

      import FilesSettingslvUrl from "ASSETS_DIR/locales/lv/FilesSettings.json?url";

      import FillPDFDialoglvUrl from "ASSETS_DIR/locales/lv/FillPDFDialog.json?url";

      import FormFillingTipsDialoglvUrl from "ASSETS_DIR/locales/lv/FormFillingTipsDialog.json?url";

      import FormGallerylvUrl from "ASSETS_DIR/locales/lv/FormGallery.json?url";

      import HotkeysPanellvUrl from "ASSETS_DIR/locales/lv/HotkeysPanel.json?url";

      import InfoPanellvUrl from "ASSETS_DIR/locales/lv/InfoPanel.json?url";

      import InviteDialoglvUrl from "ASSETS_DIR/locales/lv/InviteDialog.json?url";

      import JavascriptSdklvUrl from "ASSETS_DIR/locales/lv/JavascriptSdk.json?url";

      import LdaplvUrl from "ASSETS_DIR/locales/lv/Ldap.json?url";

      import MainBarlvUrl from "ASSETS_DIR/locales/lv/MainBar.json?url";

      import NotificationslvUrl from "ASSETS_DIR/locales/lv/Notifications.json?url";

      import OAuthlvUrl from "ASSETS_DIR/locales/lv/OAuth.json?url";

      import PDFFormDialoglvUrl from "ASSETS_DIR/locales/lv/PDFFormDialog.json?url";

      import PaymentslvUrl from "ASSETS_DIR/locales/lv/Payments.json?url";

      import PaymentsEnterpriselvUrl from "ASSETS_DIR/locales/lv/PaymentsEnterprise.json?url";

      import PeoplelvUrl from "ASSETS_DIR/locales/lv/People.json?url";

      import PeopleTranslationslvUrl from "ASSETS_DIR/locales/lv/PeopleTranslations.json?url";

      import PortalUnavailablelvUrl from "ASSETS_DIR/locales/lv/PortalUnavailable.json?url";

      import PreparationPortallvUrl from "ASSETS_DIR/locales/lv/PreparationPortal.json?url";

      import PrivacyPagelvUrl from "ASSETS_DIR/locales/lv/PrivacyPage.json?url";

      import ProfilelvUrl from "ASSETS_DIR/locales/lv/Profile.json?url";

      import ResetApplicationDialoglvUrl from "ASSETS_DIR/locales/lv/ResetApplicationDialog.json?url";

      import RoomLogoCoverlvUrl from "ASSETS_DIR/locales/lv/RoomLogoCover.json?url";

      import SMTPSettingslvUrl from "ASSETS_DIR/locales/lv/SMTPSettings.json?url";

      import SalesDepartmentRequestDialoglvUrl from "ASSETS_DIR/locales/lv/SalesDepartmentRequestDialog.json?url";

      import SendInviteDialoglvUrl from "ASSETS_DIR/locales/lv/SendInviteDialog.json?url";

      import SettingslvUrl from "ASSETS_DIR/locales/lv/Settings.json?url";

      import SharingPanellvUrl from "ASSETS_DIR/locales/lv/SharingPanel.json?url";

      import SingleSignOnlvUrl from "ASSETS_DIR/locales/lv/SingleSignOn.json?url";

      import SmartBannerlvUrl from "ASSETS_DIR/locales/lv/SmartBanner.json?url";

      import SocialAuthWelcomeDialoglvUrl from "ASSETS_DIR/locales/lv/SocialAuthWelcomeDialog.json?url";

      import TranslationslvUrl from "ASSETS_DIR/locales/lv/Translations.json?url";

      import UploadPanellvUrl from "ASSETS_DIR/locales/lv/UploadPanel.json?url";

      import VersionHistorylvUrl from "ASSETS_DIR/locales/lv/VersionHistory.json?url";

      import WebPluginslvUrl from "ASSETS_DIR/locales/lv/WebPlugins.json?url";

      import WebhookslvUrl from "ASSETS_DIR/locales/lv/Webhooks.json?url";

      import AboutnlUrl from "ASSETS_DIR/locales/nl/About.json?url";

      import ArchiveDialognlUrl from "ASSETS_DIR/locales/nl/ArchiveDialog.json?url";

      import ArticlenlUrl from "ASSETS_DIR/locales/nl/Article.json?url";

      import BackupCodesDialognlUrl from "ASSETS_DIR/locales/nl/BackupCodesDialog.json?url";

      import ChangeEmailDialognlUrl from "ASSETS_DIR/locales/nl/ChangeEmailDialog.json?url";

      import ChangePasswordDialognlUrl from "ASSETS_DIR/locales/nl/ChangePasswordDialog.json?url";

      import ChangePhoneDialognlUrl from "ASSETS_DIR/locales/nl/ChangePhoneDialog.json?url";

      import ChangePortalOwnernlUrl from "ASSETS_DIR/locales/nl/ChangePortalOwner.json?url";

      import ChangeUserStatusDialognlUrl from "ASSETS_DIR/locales/nl/ChangeUserStatusDialog.json?url";

      import ChangeUserTypeDialognlUrl from "ASSETS_DIR/locales/nl/ChangeUserTypeDialog.json?url";

      import ConnectDialognlUrl from "ASSETS_DIR/locales/nl/ConnectDialog.json?url";

      import ConvertDialognlUrl from "ASSETS_DIR/locales/nl/ConvertDialog.json?url";

      import ConvertPasswordDialognlUrl from "ASSETS_DIR/locales/nl/ConvertPasswordDialog.json?url";

      import CreateEditRoomDialognlUrl from "ASSETS_DIR/locales/nl/CreateEditRoomDialog.json?url";

      import DataReassignmentDialognlUrl from "ASSETS_DIR/locales/nl/DataReassignmentDialog.json?url";

      import DeleteDialognlUrl from "ASSETS_DIR/locales/nl/DeleteDialog.json?url";

      import DeleteProfileEverDialognlUrl from "ASSETS_DIR/locales/nl/DeleteProfileEverDialog.json?url";

      import DeleteSelfProfileDialognlUrl from "ASSETS_DIR/locales/nl/DeleteSelfProfileDialog.json?url";

      import DeleteThirdPartyDialognlUrl from "ASSETS_DIR/locales/nl/DeleteThirdPartyDialog.json?url";

      import DowngradePlanDialognlUrl from "ASSETS_DIR/locales/nl/DowngradePlanDialog.json?url";

      import EmbeddingPanelnlUrl from "ASSETS_DIR/locales/nl/EmbeddingPanel.json?url";

      import EmptyTrashDialognlUrl from "ASSETS_DIR/locales/nl/EmptyTrashDialog.json?url";

      import EmptyViewnlUrl from "ASSETS_DIR/locales/nl/EmptyView.json?url";

      import ErrorsnlUrl from "ASSETS_DIR/locales/nl/Errors.json?url";

      import FilesnlUrl from "ASSETS_DIR/locales/nl/Files.json?url";

      import FilesSettingsnlUrl from "ASSETS_DIR/locales/nl/FilesSettings.json?url";

      import FillPDFDialognlUrl from "ASSETS_DIR/locales/nl/FillPDFDialog.json?url";

      import FormFillingTipsDialognlUrl from "ASSETS_DIR/locales/nl/FormFillingTipsDialog.json?url";

      import FormGallerynlUrl from "ASSETS_DIR/locales/nl/FormGallery.json?url";

      import HotkeysPanelnlUrl from "ASSETS_DIR/locales/nl/HotkeysPanel.json?url";

      import InfoPanelnlUrl from "ASSETS_DIR/locales/nl/InfoPanel.json?url";

      import InviteDialognlUrl from "ASSETS_DIR/locales/nl/InviteDialog.json?url";

      import JavascriptSdknlUrl from "ASSETS_DIR/locales/nl/JavascriptSdk.json?url";

      import LdapnlUrl from "ASSETS_DIR/locales/nl/Ldap.json?url";

      import MainBarnlUrl from "ASSETS_DIR/locales/nl/MainBar.json?url";

      import NotificationsnlUrl from "ASSETS_DIR/locales/nl/Notifications.json?url";

      import OAuthnlUrl from "ASSETS_DIR/locales/nl/OAuth.json?url";

      import PDFFormDialognlUrl from "ASSETS_DIR/locales/nl/PDFFormDialog.json?url";

      import PaymentsnlUrl from "ASSETS_DIR/locales/nl/Payments.json?url";

      import PaymentsEnterprisenlUrl from "ASSETS_DIR/locales/nl/PaymentsEnterprise.json?url";

      import PeoplenlUrl from "ASSETS_DIR/locales/nl/People.json?url";

      import PeopleTranslationsnlUrl from "ASSETS_DIR/locales/nl/PeopleTranslations.json?url";

      import PortalUnavailablenlUrl from "ASSETS_DIR/locales/nl/PortalUnavailable.json?url";

      import PreparationPortalnlUrl from "ASSETS_DIR/locales/nl/PreparationPortal.json?url";

      import PrivacyPagenlUrl from "ASSETS_DIR/locales/nl/PrivacyPage.json?url";

      import ProfilenlUrl from "ASSETS_DIR/locales/nl/Profile.json?url";

      import ResetApplicationDialognlUrl from "ASSETS_DIR/locales/nl/ResetApplicationDialog.json?url";

      import RoomLogoCovernlUrl from "ASSETS_DIR/locales/nl/RoomLogoCover.json?url";

      import SMTPSettingsnlUrl from "ASSETS_DIR/locales/nl/SMTPSettings.json?url";

      import SalesDepartmentRequestDialognlUrl from "ASSETS_DIR/locales/nl/SalesDepartmentRequestDialog.json?url";

      import SendInviteDialognlUrl from "ASSETS_DIR/locales/nl/SendInviteDialog.json?url";

      import SettingsnlUrl from "ASSETS_DIR/locales/nl/Settings.json?url";

      import SharingPanelnlUrl from "ASSETS_DIR/locales/nl/SharingPanel.json?url";

      import SingleSignOnnlUrl from "ASSETS_DIR/locales/nl/SingleSignOn.json?url";

      import SmartBannernlUrl from "ASSETS_DIR/locales/nl/SmartBanner.json?url";

      import SocialAuthWelcomeDialognlUrl from "ASSETS_DIR/locales/nl/SocialAuthWelcomeDialog.json?url";

      import TranslationsnlUrl from "ASSETS_DIR/locales/nl/Translations.json?url";

      import UploadPanelnlUrl from "ASSETS_DIR/locales/nl/UploadPanel.json?url";

      import VersionHistorynlUrl from "ASSETS_DIR/locales/nl/VersionHistory.json?url";

      import WebPluginsnlUrl from "ASSETS_DIR/locales/nl/WebPlugins.json?url";

      import WebhooksnlUrl from "ASSETS_DIR/locales/nl/Webhooks.json?url";

      import AboutplUrl from "ASSETS_DIR/locales/pl/About.json?url";

      import ArchiveDialogplUrl from "ASSETS_DIR/locales/pl/ArchiveDialog.json?url";

      import ArticleplUrl from "ASSETS_DIR/locales/pl/Article.json?url";

      import BackupCodesDialogplUrl from "ASSETS_DIR/locales/pl/BackupCodesDialog.json?url";

      import ChangeEmailDialogplUrl from "ASSETS_DIR/locales/pl/ChangeEmailDialog.json?url";

      import ChangePasswordDialogplUrl from "ASSETS_DIR/locales/pl/ChangePasswordDialog.json?url";

      import ChangePhoneDialogplUrl from "ASSETS_DIR/locales/pl/ChangePhoneDialog.json?url";

      import ChangePortalOwnerplUrl from "ASSETS_DIR/locales/pl/ChangePortalOwner.json?url";

      import ChangeUserStatusDialogplUrl from "ASSETS_DIR/locales/pl/ChangeUserStatusDialog.json?url";

      import ChangeUserTypeDialogplUrl from "ASSETS_DIR/locales/pl/ChangeUserTypeDialog.json?url";

      import ConnectDialogplUrl from "ASSETS_DIR/locales/pl/ConnectDialog.json?url";

      import ConvertDialogplUrl from "ASSETS_DIR/locales/pl/ConvertDialog.json?url";

      import ConvertPasswordDialogplUrl from "ASSETS_DIR/locales/pl/ConvertPasswordDialog.json?url";

      import CreateEditRoomDialogplUrl from "ASSETS_DIR/locales/pl/CreateEditRoomDialog.json?url";

      import DataReassignmentDialogplUrl from "ASSETS_DIR/locales/pl/DataReassignmentDialog.json?url";

      import DeleteDialogplUrl from "ASSETS_DIR/locales/pl/DeleteDialog.json?url";

      import DeleteProfileEverDialogplUrl from "ASSETS_DIR/locales/pl/DeleteProfileEverDialog.json?url";

      import DeleteSelfProfileDialogplUrl from "ASSETS_DIR/locales/pl/DeleteSelfProfileDialog.json?url";

      import DeleteThirdPartyDialogplUrl from "ASSETS_DIR/locales/pl/DeleteThirdPartyDialog.json?url";

      import DowngradePlanDialogplUrl from "ASSETS_DIR/locales/pl/DowngradePlanDialog.json?url";

      import EmbeddingPanelplUrl from "ASSETS_DIR/locales/pl/EmbeddingPanel.json?url";

      import EmptyTrashDialogplUrl from "ASSETS_DIR/locales/pl/EmptyTrashDialog.json?url";

      import EmptyViewplUrl from "ASSETS_DIR/locales/pl/EmptyView.json?url";

      import ErrorsplUrl from "ASSETS_DIR/locales/pl/Errors.json?url";

      import FilesplUrl from "ASSETS_DIR/locales/pl/Files.json?url";

      import FilesSettingsplUrl from "ASSETS_DIR/locales/pl/FilesSettings.json?url";

      import FillPDFDialogplUrl from "ASSETS_DIR/locales/pl/FillPDFDialog.json?url";

      import FormFillingTipsDialogplUrl from "ASSETS_DIR/locales/pl/FormFillingTipsDialog.json?url";

      import FormGalleryplUrl from "ASSETS_DIR/locales/pl/FormGallery.json?url";

      import HotkeysPanelplUrl from "ASSETS_DIR/locales/pl/HotkeysPanel.json?url";

      import InfoPanelplUrl from "ASSETS_DIR/locales/pl/InfoPanel.json?url";

      import InviteDialogplUrl from "ASSETS_DIR/locales/pl/InviteDialog.json?url";

      import JavascriptSdkplUrl from "ASSETS_DIR/locales/pl/JavascriptSdk.json?url";

      import LdapplUrl from "ASSETS_DIR/locales/pl/Ldap.json?url";

      import MainBarplUrl from "ASSETS_DIR/locales/pl/MainBar.json?url";

      import NotificationsplUrl from "ASSETS_DIR/locales/pl/Notifications.json?url";

      import OAuthplUrl from "ASSETS_DIR/locales/pl/OAuth.json?url";

      import PDFFormDialogplUrl from "ASSETS_DIR/locales/pl/PDFFormDialog.json?url";

      import PaymentsplUrl from "ASSETS_DIR/locales/pl/Payments.json?url";

      import PaymentsEnterpriseplUrl from "ASSETS_DIR/locales/pl/PaymentsEnterprise.json?url";

      import PeopleplUrl from "ASSETS_DIR/locales/pl/People.json?url";

      import PeopleTranslationsplUrl from "ASSETS_DIR/locales/pl/PeopleTranslations.json?url";

      import PortalUnavailableplUrl from "ASSETS_DIR/locales/pl/PortalUnavailable.json?url";

      import PreparationPortalplUrl from "ASSETS_DIR/locales/pl/PreparationPortal.json?url";

      import PrivacyPageplUrl from "ASSETS_DIR/locales/pl/PrivacyPage.json?url";

      import ProfileplUrl from "ASSETS_DIR/locales/pl/Profile.json?url";

      import ResetApplicationDialogplUrl from "ASSETS_DIR/locales/pl/ResetApplicationDialog.json?url";

      import RoomLogoCoverplUrl from "ASSETS_DIR/locales/pl/RoomLogoCover.json?url";

      import SMTPSettingsplUrl from "ASSETS_DIR/locales/pl/SMTPSettings.json?url";

      import SalesDepartmentRequestDialogplUrl from "ASSETS_DIR/locales/pl/SalesDepartmentRequestDialog.json?url";

      import SendInviteDialogplUrl from "ASSETS_DIR/locales/pl/SendInviteDialog.json?url";

      import SettingsplUrl from "ASSETS_DIR/locales/pl/Settings.json?url";

      import SharingPanelplUrl from "ASSETS_DIR/locales/pl/SharingPanel.json?url";

      import SingleSignOnplUrl from "ASSETS_DIR/locales/pl/SingleSignOn.json?url";

      import SmartBannerplUrl from "ASSETS_DIR/locales/pl/SmartBanner.json?url";

      import SocialAuthWelcomeDialogplUrl from "ASSETS_DIR/locales/pl/SocialAuthWelcomeDialog.json?url";

      import TranslationsplUrl from "ASSETS_DIR/locales/pl/Translations.json?url";

      import UploadPanelplUrl from "ASSETS_DIR/locales/pl/UploadPanel.json?url";

      import VersionHistoryplUrl from "ASSETS_DIR/locales/pl/VersionHistory.json?url";

      import WebPluginsplUrl from "ASSETS_DIR/locales/pl/WebPlugins.json?url";

      import WebhooksplUrl from "ASSETS_DIR/locales/pl/Webhooks.json?url";

      import AboutptUrl from "ASSETS_DIR/locales/pt/About.json?url";

      import ArchiveDialogptUrl from "ASSETS_DIR/locales/pt/ArchiveDialog.json?url";

      import ArticleptUrl from "ASSETS_DIR/locales/pt/Article.json?url";

      import BackupCodesDialogptUrl from "ASSETS_DIR/locales/pt/BackupCodesDialog.json?url";

      import ChangeEmailDialogptUrl from "ASSETS_DIR/locales/pt/ChangeEmailDialog.json?url";

      import ChangePasswordDialogptUrl from "ASSETS_DIR/locales/pt/ChangePasswordDialog.json?url";

      import ChangePhoneDialogptUrl from "ASSETS_DIR/locales/pt/ChangePhoneDialog.json?url";

      import ChangePortalOwnerptUrl from "ASSETS_DIR/locales/pt/ChangePortalOwner.json?url";

      import ChangeUserStatusDialogptUrl from "ASSETS_DIR/locales/pt/ChangeUserStatusDialog.json?url";

      import ChangeUserTypeDialogptUrl from "ASSETS_DIR/locales/pt/ChangeUserTypeDialog.json?url";

      import ConnectDialogptUrl from "ASSETS_DIR/locales/pt/ConnectDialog.json?url";

      import ConvertDialogptUrl from "ASSETS_DIR/locales/pt/ConvertDialog.json?url";

      import ConvertPasswordDialogptUrl from "ASSETS_DIR/locales/pt/ConvertPasswordDialog.json?url";

      import CreateEditRoomDialogptUrl from "ASSETS_DIR/locales/pt/CreateEditRoomDialog.json?url";

      import DataReassignmentDialogptUrl from "ASSETS_DIR/locales/pt/DataReassignmentDialog.json?url";

      import DeleteDialogptUrl from "ASSETS_DIR/locales/pt/DeleteDialog.json?url";

      import DeleteProfileEverDialogptUrl from "ASSETS_DIR/locales/pt/DeleteProfileEverDialog.json?url";

      import DeleteSelfProfileDialogptUrl from "ASSETS_DIR/locales/pt/DeleteSelfProfileDialog.json?url";

      import DeleteThirdPartyDialogptUrl from "ASSETS_DIR/locales/pt/DeleteThirdPartyDialog.json?url";

      import DowngradePlanDialogptUrl from "ASSETS_DIR/locales/pt/DowngradePlanDialog.json?url";

      import EmbeddingPanelptUrl from "ASSETS_DIR/locales/pt/EmbeddingPanel.json?url";

      import EmptyTrashDialogptUrl from "ASSETS_DIR/locales/pt/EmptyTrashDialog.json?url";

      import EmptyViewptUrl from "ASSETS_DIR/locales/pt/EmptyView.json?url";

      import ErrorsptUrl from "ASSETS_DIR/locales/pt/Errors.json?url";

      import FilesptUrl from "ASSETS_DIR/locales/pt/Files.json?url";

      import FilesSettingsptUrl from "ASSETS_DIR/locales/pt/FilesSettings.json?url";

      import FillPDFDialogptUrl from "ASSETS_DIR/locales/pt/FillPDFDialog.json?url";

      import FormFillingTipsDialogptUrl from "ASSETS_DIR/locales/pt/FormFillingTipsDialog.json?url";

      import FormGalleryptUrl from "ASSETS_DIR/locales/pt/FormGallery.json?url";

      import HotkeysPanelptUrl from "ASSETS_DIR/locales/pt/HotkeysPanel.json?url";

      import InfoPanelptUrl from "ASSETS_DIR/locales/pt/InfoPanel.json?url";

      import InviteDialogptUrl from "ASSETS_DIR/locales/pt/InviteDialog.json?url";

      import JavascriptSdkptUrl from "ASSETS_DIR/locales/pt/JavascriptSdk.json?url";

      import LdapptUrl from "ASSETS_DIR/locales/pt/Ldap.json?url";

      import MainBarptUrl from "ASSETS_DIR/locales/pt/MainBar.json?url";

      import NotificationsptUrl from "ASSETS_DIR/locales/pt/Notifications.json?url";

      import OAuthptUrl from "ASSETS_DIR/locales/pt/OAuth.json?url";

      import PDFFormDialogptUrl from "ASSETS_DIR/locales/pt/PDFFormDialog.json?url";

      import PaymentsptUrl from "ASSETS_DIR/locales/pt/Payments.json?url";

      import PaymentsEnterpriseptUrl from "ASSETS_DIR/locales/pt/PaymentsEnterprise.json?url";

      import PeopleptUrl from "ASSETS_DIR/locales/pt/People.json?url";

      import PeopleTranslationsptUrl from "ASSETS_DIR/locales/pt/PeopleTranslations.json?url";

      import PortalUnavailableptUrl from "ASSETS_DIR/locales/pt/PortalUnavailable.json?url";

      import PreparationPortalptUrl from "ASSETS_DIR/locales/pt/PreparationPortal.json?url";

      import PrivacyPageptUrl from "ASSETS_DIR/locales/pt/PrivacyPage.json?url";

      import ProfileptUrl from "ASSETS_DIR/locales/pt/Profile.json?url";

      import ResetApplicationDialogptUrl from "ASSETS_DIR/locales/pt/ResetApplicationDialog.json?url";

      import RoomLogoCoverptUrl from "ASSETS_DIR/locales/pt/RoomLogoCover.json?url";

      import SMTPSettingsptUrl from "ASSETS_DIR/locales/pt/SMTPSettings.json?url";

      import SalesDepartmentRequestDialogptUrl from "ASSETS_DIR/locales/pt/SalesDepartmentRequestDialog.json?url";

      import SendInviteDialogptUrl from "ASSETS_DIR/locales/pt/SendInviteDialog.json?url";

      import SettingsptUrl from "ASSETS_DIR/locales/pt/Settings.json?url";

      import SharingPanelptUrl from "ASSETS_DIR/locales/pt/SharingPanel.json?url";

      import SingleSignOnptUrl from "ASSETS_DIR/locales/pt/SingleSignOn.json?url";

      import SmartBannerptUrl from "ASSETS_DIR/locales/pt/SmartBanner.json?url";

      import SocialAuthWelcomeDialogptUrl from "ASSETS_DIR/locales/pt/SocialAuthWelcomeDialog.json?url";

      import TranslationsptUrl from "ASSETS_DIR/locales/pt/Translations.json?url";

      import UploadPanelptUrl from "ASSETS_DIR/locales/pt/UploadPanel.json?url";

      import VersionHistoryptUrl from "ASSETS_DIR/locales/pt/VersionHistory.json?url";

      import WebPluginsptUrl from "ASSETS_DIR/locales/pt/WebPlugins.json?url";

      import WebhooksptUrl from "ASSETS_DIR/locales/pt/Webhooks.json?url";

      import AboutptBRUrl from "ASSETS_DIR/locales/pt-BR/About.json?url";

      import ArchiveDialogptBRUrl from "ASSETS_DIR/locales/pt-BR/ArchiveDialog.json?url";

      import ArticleptBRUrl from "ASSETS_DIR/locales/pt-BR/Article.json?url";

      import BackupCodesDialogptBRUrl from "ASSETS_DIR/locales/pt-BR/BackupCodesDialog.json?url";

      import ChangeEmailDialogptBRUrl from "ASSETS_DIR/locales/pt-BR/ChangeEmailDialog.json?url";

      import ChangePasswordDialogptBRUrl from "ASSETS_DIR/locales/pt-BR/ChangePasswordDialog.json?url";

      import ChangePhoneDialogptBRUrl from "ASSETS_DIR/locales/pt-BR/ChangePhoneDialog.json?url";

      import ChangePortalOwnerptBRUrl from "ASSETS_DIR/locales/pt-BR/ChangePortalOwner.json?url";

      import ChangeUserStatusDialogptBRUrl from "ASSETS_DIR/locales/pt-BR/ChangeUserStatusDialog.json?url";

      import ChangeUserTypeDialogptBRUrl from "ASSETS_DIR/locales/pt-BR/ChangeUserTypeDialog.json?url";

      import ConnectDialogptBRUrl from "ASSETS_DIR/locales/pt-BR/ConnectDialog.json?url";

      import ConvertDialogptBRUrl from "ASSETS_DIR/locales/pt-BR/ConvertDialog.json?url";

      import ConvertPasswordDialogptBRUrl from "ASSETS_DIR/locales/pt-BR/ConvertPasswordDialog.json?url";

      import CreateEditRoomDialogptBRUrl from "ASSETS_DIR/locales/pt-BR/CreateEditRoomDialog.json?url";

      import DataReassignmentDialogptBRUrl from "ASSETS_DIR/locales/pt-BR/DataReassignmentDialog.json?url";

      import DeleteDialogptBRUrl from "ASSETS_DIR/locales/pt-BR/DeleteDialog.json?url";

      import DeleteProfileEverDialogptBRUrl from "ASSETS_DIR/locales/pt-BR/DeleteProfileEverDialog.json?url";

      import DeleteSelfProfileDialogptBRUrl from "ASSETS_DIR/locales/pt-BR/DeleteSelfProfileDialog.json?url";

      import DeleteThirdPartyDialogptBRUrl from "ASSETS_DIR/locales/pt-BR/DeleteThirdPartyDialog.json?url";

      import DowngradePlanDialogptBRUrl from "ASSETS_DIR/locales/pt-BR/DowngradePlanDialog.json?url";

      import EmbeddingPanelptBRUrl from "ASSETS_DIR/locales/pt-BR/EmbeddingPanel.json?url";

      import EmptyTrashDialogptBRUrl from "ASSETS_DIR/locales/pt-BR/EmptyTrashDialog.json?url";

      import EmptyViewptBRUrl from "ASSETS_DIR/locales/pt-BR/EmptyView.json?url";

      import ErrorsptBRUrl from "ASSETS_DIR/locales/pt-BR/Errors.json?url";

      import FilesptBRUrl from "ASSETS_DIR/locales/pt-BR/Files.json?url";

      import FilesSettingsptBRUrl from "ASSETS_DIR/locales/pt-BR/FilesSettings.json?url";

      import FillPDFDialogptBRUrl from "ASSETS_DIR/locales/pt-BR/FillPDFDialog.json?url";

      import FormFillingTipsDialogptBRUrl from "ASSETS_DIR/locales/pt-BR/FormFillingTipsDialog.json?url";

      import FormGalleryptBRUrl from "ASSETS_DIR/locales/pt-BR/FormGallery.json?url";

      import HotkeysPanelptBRUrl from "ASSETS_DIR/locales/pt-BR/HotkeysPanel.json?url";

      import InfoPanelptBRUrl from "ASSETS_DIR/locales/pt-BR/InfoPanel.json?url";

      import InviteDialogptBRUrl from "ASSETS_DIR/locales/pt-BR/InviteDialog.json?url";

      import JavascriptSdkptBRUrl from "ASSETS_DIR/locales/pt-BR/JavascriptSdk.json?url";

      import LdapptBRUrl from "ASSETS_DIR/locales/pt-BR/Ldap.json?url";

      import MainBarptBRUrl from "ASSETS_DIR/locales/pt-BR/MainBar.json?url";

      import NotificationsptBRUrl from "ASSETS_DIR/locales/pt-BR/Notifications.json?url";

      import OAuthptBRUrl from "ASSETS_DIR/locales/pt-BR/OAuth.json?url";

      import PDFFormDialogptBRUrl from "ASSETS_DIR/locales/pt-BR/PDFFormDialog.json?url";

      import PaymentsptBRUrl from "ASSETS_DIR/locales/pt-BR/Payments.json?url";

      import PaymentsEnterpriseptBRUrl from "ASSETS_DIR/locales/pt-BR/PaymentsEnterprise.json?url";

      import PeopleptBRUrl from "ASSETS_DIR/locales/pt-BR/People.json?url";

      import PeopleTranslationsptBRUrl from "ASSETS_DIR/locales/pt-BR/PeopleTranslations.json?url";

      import PortalUnavailableptBRUrl from "ASSETS_DIR/locales/pt-BR/PortalUnavailable.json?url";

      import PreparationPortalptBRUrl from "ASSETS_DIR/locales/pt-BR/PreparationPortal.json?url";

      import PrivacyPageptBRUrl from "ASSETS_DIR/locales/pt-BR/PrivacyPage.json?url";

      import ProfileptBRUrl from "ASSETS_DIR/locales/pt-BR/Profile.json?url";

      import ResetApplicationDialogptBRUrl from "ASSETS_DIR/locales/pt-BR/ResetApplicationDialog.json?url";

      import RoomLogoCoverptBRUrl from "ASSETS_DIR/locales/pt-BR/RoomLogoCover.json?url";

      import SMTPSettingsptBRUrl from "ASSETS_DIR/locales/pt-BR/SMTPSettings.json?url";

      import SalesDepartmentRequestDialogptBRUrl from "ASSETS_DIR/locales/pt-BR/SalesDepartmentRequestDialog.json?url";

      import SendInviteDialogptBRUrl from "ASSETS_DIR/locales/pt-BR/SendInviteDialog.json?url";

      import SettingsptBRUrl from "ASSETS_DIR/locales/pt-BR/Settings.json?url";

      import SharingPanelptBRUrl from "ASSETS_DIR/locales/pt-BR/SharingPanel.json?url";

      import SingleSignOnptBRUrl from "ASSETS_DIR/locales/pt-BR/SingleSignOn.json?url";

      import SmartBannerptBRUrl from "ASSETS_DIR/locales/pt-BR/SmartBanner.json?url";

      import SocialAuthWelcomeDialogptBRUrl from "ASSETS_DIR/locales/pt-BR/SocialAuthWelcomeDialog.json?url";

      import TranslationsptBRUrl from "ASSETS_DIR/locales/pt-BR/Translations.json?url";

      import UploadPanelptBRUrl from "ASSETS_DIR/locales/pt-BR/UploadPanel.json?url";

      import VersionHistoryptBRUrl from "ASSETS_DIR/locales/pt-BR/VersionHistory.json?url";

      import WebPluginsptBRUrl from "ASSETS_DIR/locales/pt-BR/WebPlugins.json?url";

      import WebhooksptBRUrl from "ASSETS_DIR/locales/pt-BR/Webhooks.json?url";

      import AboutroUrl from "ASSETS_DIR/locales/ro/About.json?url";

      import ArchiveDialogroUrl from "ASSETS_DIR/locales/ro/ArchiveDialog.json?url";

      import ArticleroUrl from "ASSETS_DIR/locales/ro/Article.json?url";

      import BackupCodesDialogroUrl from "ASSETS_DIR/locales/ro/BackupCodesDialog.json?url";

      import ChangeEmailDialogroUrl from "ASSETS_DIR/locales/ro/ChangeEmailDialog.json?url";

      import ChangePasswordDialogroUrl from "ASSETS_DIR/locales/ro/ChangePasswordDialog.json?url";

      import ChangePhoneDialogroUrl from "ASSETS_DIR/locales/ro/ChangePhoneDialog.json?url";

      import ChangePortalOwnerroUrl from "ASSETS_DIR/locales/ro/ChangePortalOwner.json?url";

      import ChangeUserStatusDialogroUrl from "ASSETS_DIR/locales/ro/ChangeUserStatusDialog.json?url";

      import ChangeUserTypeDialogroUrl from "ASSETS_DIR/locales/ro/ChangeUserTypeDialog.json?url";

      import ConnectDialogroUrl from "ASSETS_DIR/locales/ro/ConnectDialog.json?url";

      import ConvertDialogroUrl from "ASSETS_DIR/locales/ro/ConvertDialog.json?url";

      import ConvertPasswordDialogroUrl from "ASSETS_DIR/locales/ro/ConvertPasswordDialog.json?url";

      import CreateEditRoomDialogroUrl from "ASSETS_DIR/locales/ro/CreateEditRoomDialog.json?url";

      import DataReassignmentDialogroUrl from "ASSETS_DIR/locales/ro/DataReassignmentDialog.json?url";

      import DeleteDialogroUrl from "ASSETS_DIR/locales/ro/DeleteDialog.json?url";

      import DeleteProfileEverDialogroUrl from "ASSETS_DIR/locales/ro/DeleteProfileEverDialog.json?url";

      import DeleteSelfProfileDialogroUrl from "ASSETS_DIR/locales/ro/DeleteSelfProfileDialog.json?url";

      import DeleteThirdPartyDialogroUrl from "ASSETS_DIR/locales/ro/DeleteThirdPartyDialog.json?url";

      import DowngradePlanDialogroUrl from "ASSETS_DIR/locales/ro/DowngradePlanDialog.json?url";

      import EmbeddingPanelroUrl from "ASSETS_DIR/locales/ro/EmbeddingPanel.json?url";

      import EmptyTrashDialogroUrl from "ASSETS_DIR/locales/ro/EmptyTrashDialog.json?url";

      import EmptyViewroUrl from "ASSETS_DIR/locales/ro/EmptyView.json?url";

      import ErrorsroUrl from "ASSETS_DIR/locales/ro/Errors.json?url";

      import FilesroUrl from "ASSETS_DIR/locales/ro/Files.json?url";

      import FilesSettingsroUrl from "ASSETS_DIR/locales/ro/FilesSettings.json?url";

      import FillPDFDialogroUrl from "ASSETS_DIR/locales/ro/FillPDFDialog.json?url";

      import FormFillingTipsDialogroUrl from "ASSETS_DIR/locales/ro/FormFillingTipsDialog.json?url";

      import FormGalleryroUrl from "ASSETS_DIR/locales/ro/FormGallery.json?url";

      import HotkeysPanelroUrl from "ASSETS_DIR/locales/ro/HotkeysPanel.json?url";

      import InfoPanelroUrl from "ASSETS_DIR/locales/ro/InfoPanel.json?url";

      import InviteDialogroUrl from "ASSETS_DIR/locales/ro/InviteDialog.json?url";

      import JavascriptSdkroUrl from "ASSETS_DIR/locales/ro/JavascriptSdk.json?url";

      import LdaproUrl from "ASSETS_DIR/locales/ro/Ldap.json?url";

      import MainBarroUrl from "ASSETS_DIR/locales/ro/MainBar.json?url";

      import NotificationsroUrl from "ASSETS_DIR/locales/ro/Notifications.json?url";

      import OAuthroUrl from "ASSETS_DIR/locales/ro/OAuth.json?url";

      import PDFFormDialogroUrl from "ASSETS_DIR/locales/ro/PDFFormDialog.json?url";

      import PaymentsroUrl from "ASSETS_DIR/locales/ro/Payments.json?url";

      import PaymentsEnterpriseroUrl from "ASSETS_DIR/locales/ro/PaymentsEnterprise.json?url";

      import PeopleroUrl from "ASSETS_DIR/locales/ro/People.json?url";

      import PeopleTranslationsroUrl from "ASSETS_DIR/locales/ro/PeopleTranslations.json?url";

      import PortalUnavailableroUrl from "ASSETS_DIR/locales/ro/PortalUnavailable.json?url";

      import PreparationPortalroUrl from "ASSETS_DIR/locales/ro/PreparationPortal.json?url";

      import PrivacyPageroUrl from "ASSETS_DIR/locales/ro/PrivacyPage.json?url";

      import ProfileroUrl from "ASSETS_DIR/locales/ro/Profile.json?url";

      import ResetApplicationDialogroUrl from "ASSETS_DIR/locales/ro/ResetApplicationDialog.json?url";

      import RoomLogoCoverroUrl from "ASSETS_DIR/locales/ro/RoomLogoCover.json?url";

      import SMTPSettingsroUrl from "ASSETS_DIR/locales/ro/SMTPSettings.json?url";

      import SalesDepartmentRequestDialogroUrl from "ASSETS_DIR/locales/ro/SalesDepartmentRequestDialog.json?url";

      import SendInviteDialogroUrl from "ASSETS_DIR/locales/ro/SendInviteDialog.json?url";

      import SettingsroUrl from "ASSETS_DIR/locales/ro/Settings.json?url";

      import SharingPanelroUrl from "ASSETS_DIR/locales/ro/SharingPanel.json?url";

      import SingleSignOnroUrl from "ASSETS_DIR/locales/ro/SingleSignOn.json?url";

      import SmartBannerroUrl from "ASSETS_DIR/locales/ro/SmartBanner.json?url";

      import SocialAuthWelcomeDialogroUrl from "ASSETS_DIR/locales/ro/SocialAuthWelcomeDialog.json?url";

      import TranslationsroUrl from "ASSETS_DIR/locales/ro/Translations.json?url";

      import UploadPanelroUrl from "ASSETS_DIR/locales/ro/UploadPanel.json?url";

      import VersionHistoryroUrl from "ASSETS_DIR/locales/ro/VersionHistory.json?url";

      import WebPluginsroUrl from "ASSETS_DIR/locales/ro/WebPlugins.json?url";

      import WebhooksroUrl from "ASSETS_DIR/locales/ro/Webhooks.json?url";

      import AboutruUrl from "ASSETS_DIR/locales/ru/About.json?url";

      import ArchiveDialogruUrl from "ASSETS_DIR/locales/ru/ArchiveDialog.json?url";

      import ArticleruUrl from "ASSETS_DIR/locales/ru/Article.json?url";

      import BackupCodesDialogruUrl from "ASSETS_DIR/locales/ru/BackupCodesDialog.json?url";

      import ChangeEmailDialogruUrl from "ASSETS_DIR/locales/ru/ChangeEmailDialog.json?url";

      import ChangePasswordDialogruUrl from "ASSETS_DIR/locales/ru/ChangePasswordDialog.json?url";

      import ChangePhoneDialogruUrl from "ASSETS_DIR/locales/ru/ChangePhoneDialog.json?url";

      import ChangePortalOwnerruUrl from "ASSETS_DIR/locales/ru/ChangePortalOwner.json?url";

      import ChangeUserStatusDialogruUrl from "ASSETS_DIR/locales/ru/ChangeUserStatusDialog.json?url";

      import ChangeUserTypeDialogruUrl from "ASSETS_DIR/locales/ru/ChangeUserTypeDialog.json?url";

      import ConnectDialogruUrl from "ASSETS_DIR/locales/ru/ConnectDialog.json?url";

      import ConvertDialogruUrl from "ASSETS_DIR/locales/ru/ConvertDialog.json?url";

      import ConvertPasswordDialogruUrl from "ASSETS_DIR/locales/ru/ConvertPasswordDialog.json?url";

      import CreateEditRoomDialogruUrl from "ASSETS_DIR/locales/ru/CreateEditRoomDialog.json?url";

      import DataReassignmentDialogruUrl from "ASSETS_DIR/locales/ru/DataReassignmentDialog.json?url";

      import DeleteDialogruUrl from "ASSETS_DIR/locales/ru/DeleteDialog.json?url";

      import DeleteProfileEverDialogruUrl from "ASSETS_DIR/locales/ru/DeleteProfileEverDialog.json?url";

      import DeleteSelfProfileDialogruUrl from "ASSETS_DIR/locales/ru/DeleteSelfProfileDialog.json?url";

      import DeleteThirdPartyDialogruUrl from "ASSETS_DIR/locales/ru/DeleteThirdPartyDialog.json?url";

      import DowngradePlanDialogruUrl from "ASSETS_DIR/locales/ru/DowngradePlanDialog.json?url";

      import EmbeddingPanelruUrl from "ASSETS_DIR/locales/ru/EmbeddingPanel.json?url";

      import EmptyTrashDialogruUrl from "ASSETS_DIR/locales/ru/EmptyTrashDialog.json?url";

      import EmptyViewruUrl from "ASSETS_DIR/locales/ru/EmptyView.json?url";

      import ErrorsruUrl from "ASSETS_DIR/locales/ru/Errors.json?url";

      import FilesruUrl from "ASSETS_DIR/locales/ru/Files.json?url";

      import FilesSettingsruUrl from "ASSETS_DIR/locales/ru/FilesSettings.json?url";

      import FillPDFDialogruUrl from "ASSETS_DIR/locales/ru/FillPDFDialog.json?url";

      import FormFillingTipsDialogruUrl from "ASSETS_DIR/locales/ru/FormFillingTipsDialog.json?url";

      import FormGalleryruUrl from "ASSETS_DIR/locales/ru/FormGallery.json?url";

      import HotkeysPanelruUrl from "ASSETS_DIR/locales/ru/HotkeysPanel.json?url";

      import InfoPanelruUrl from "ASSETS_DIR/locales/ru/InfoPanel.json?url";

      import InviteDialogruUrl from "ASSETS_DIR/locales/ru/InviteDialog.json?url";

      import JavascriptSdkruUrl from "ASSETS_DIR/locales/ru/JavascriptSdk.json?url";

      import LdapruUrl from "ASSETS_DIR/locales/ru/Ldap.json?url";

      import MainBarruUrl from "ASSETS_DIR/locales/ru/MainBar.json?url";

      import NotificationsruUrl from "ASSETS_DIR/locales/ru/Notifications.json?url";

      import OAuthruUrl from "ASSETS_DIR/locales/ru/OAuth.json?url";

      import PDFFormDialogruUrl from "ASSETS_DIR/locales/ru/PDFFormDialog.json?url";

      import PaymentsruUrl from "ASSETS_DIR/locales/ru/Payments.json?url";

      import PaymentsEnterpriseruUrl from "ASSETS_DIR/locales/ru/PaymentsEnterprise.json?url";

      import PeopleruUrl from "ASSETS_DIR/locales/ru/People.json?url";

      import PeopleTranslationsruUrl from "ASSETS_DIR/locales/ru/PeopleTranslations.json?url";

      import PortalUnavailableruUrl from "ASSETS_DIR/locales/ru/PortalUnavailable.json?url";

      import PreparationPortalruUrl from "ASSETS_DIR/locales/ru/PreparationPortal.json?url";

      import PrivacyPageruUrl from "ASSETS_DIR/locales/ru/PrivacyPage.json?url";

      import ProfileruUrl from "ASSETS_DIR/locales/ru/Profile.json?url";

      import ResetApplicationDialogruUrl from "ASSETS_DIR/locales/ru/ResetApplicationDialog.json?url";

      import RoomLogoCoverruUrl from "ASSETS_DIR/locales/ru/RoomLogoCover.json?url";

      import SMTPSettingsruUrl from "ASSETS_DIR/locales/ru/SMTPSettings.json?url";

      import SalesDepartmentRequestDialogruUrl from "ASSETS_DIR/locales/ru/SalesDepartmentRequestDialog.json?url";

      import SendInviteDialogruUrl from "ASSETS_DIR/locales/ru/SendInviteDialog.json?url";

      import SettingsruUrl from "ASSETS_DIR/locales/ru/Settings.json?url";

      import SharingPanelruUrl from "ASSETS_DIR/locales/ru/SharingPanel.json?url";

      import SingleSignOnruUrl from "ASSETS_DIR/locales/ru/SingleSignOn.json?url";

      import SmartBannerruUrl from "ASSETS_DIR/locales/ru/SmartBanner.json?url";

      import SocialAuthWelcomeDialogruUrl from "ASSETS_DIR/locales/ru/SocialAuthWelcomeDialog.json?url";

      import TranslationsruUrl from "ASSETS_DIR/locales/ru/Translations.json?url";

      import UploadPanelruUrl from "ASSETS_DIR/locales/ru/UploadPanel.json?url";

      import VersionHistoryruUrl from "ASSETS_DIR/locales/ru/VersionHistory.json?url";

      import WebPluginsruUrl from "ASSETS_DIR/locales/ru/WebPlugins.json?url";

      import WebhooksruUrl from "ASSETS_DIR/locales/ru/Webhooks.json?url";

      import AboutsiUrl from "ASSETS_DIR/locales/si/About.json?url";

      import ArchiveDialogsiUrl from "ASSETS_DIR/locales/si/ArchiveDialog.json?url";

      import ArticlesiUrl from "ASSETS_DIR/locales/si/Article.json?url";

      import BackupCodesDialogsiUrl from "ASSETS_DIR/locales/si/BackupCodesDialog.json?url";

      import ChangeEmailDialogsiUrl from "ASSETS_DIR/locales/si/ChangeEmailDialog.json?url";

      import ChangePasswordDialogsiUrl from "ASSETS_DIR/locales/si/ChangePasswordDialog.json?url";

      import ChangePhoneDialogsiUrl from "ASSETS_DIR/locales/si/ChangePhoneDialog.json?url";

      import ChangePortalOwnersiUrl from "ASSETS_DIR/locales/si/ChangePortalOwner.json?url";

      import ChangeUserStatusDialogsiUrl from "ASSETS_DIR/locales/si/ChangeUserStatusDialog.json?url";

      import ChangeUserTypeDialogsiUrl from "ASSETS_DIR/locales/si/ChangeUserTypeDialog.json?url";

      import ConnectDialogsiUrl from "ASSETS_DIR/locales/si/ConnectDialog.json?url";

      import ConvertDialogsiUrl from "ASSETS_DIR/locales/si/ConvertDialog.json?url";

      import ConvertPasswordDialogsiUrl from "ASSETS_DIR/locales/si/ConvertPasswordDialog.json?url";

      import CreateEditRoomDialogsiUrl from "ASSETS_DIR/locales/si/CreateEditRoomDialog.json?url";

      import DataReassignmentDialogsiUrl from "ASSETS_DIR/locales/si/DataReassignmentDialog.json?url";

      import DeleteDialogsiUrl from "ASSETS_DIR/locales/si/DeleteDialog.json?url";

      import DeleteProfileEverDialogsiUrl from "ASSETS_DIR/locales/si/DeleteProfileEverDialog.json?url";

      import DeleteSelfProfileDialogsiUrl from "ASSETS_DIR/locales/si/DeleteSelfProfileDialog.json?url";

      import DeleteThirdPartyDialogsiUrl from "ASSETS_DIR/locales/si/DeleteThirdPartyDialog.json?url";

      import DowngradePlanDialogsiUrl from "ASSETS_DIR/locales/si/DowngradePlanDialog.json?url";

      import EmbeddingPanelsiUrl from "ASSETS_DIR/locales/si/EmbeddingPanel.json?url";

      import EmptyTrashDialogsiUrl from "ASSETS_DIR/locales/si/EmptyTrashDialog.json?url";

      import EmptyViewsiUrl from "ASSETS_DIR/locales/si/EmptyView.json?url";

      import ErrorssiUrl from "ASSETS_DIR/locales/si/Errors.json?url";

      import FilessiUrl from "ASSETS_DIR/locales/si/Files.json?url";

      import FilesSettingssiUrl from "ASSETS_DIR/locales/si/FilesSettings.json?url";

      import FillPDFDialogsiUrl from "ASSETS_DIR/locales/si/FillPDFDialog.json?url";

      import FormFillingTipsDialogsiUrl from "ASSETS_DIR/locales/si/FormFillingTipsDialog.json?url";

      import FormGallerysiUrl from "ASSETS_DIR/locales/si/FormGallery.json?url";

      import HotkeysPanelsiUrl from "ASSETS_DIR/locales/si/HotkeysPanel.json?url";

      import InfoPanelsiUrl from "ASSETS_DIR/locales/si/InfoPanel.json?url";

      import InviteDialogsiUrl from "ASSETS_DIR/locales/si/InviteDialog.json?url";

      import JavascriptSdksiUrl from "ASSETS_DIR/locales/si/JavascriptSdk.json?url";

      import LdapsiUrl from "ASSETS_DIR/locales/si/Ldap.json?url";

      import MainBarsiUrl from "ASSETS_DIR/locales/si/MainBar.json?url";

      import NotificationssiUrl from "ASSETS_DIR/locales/si/Notifications.json?url";

      import OAuthsiUrl from "ASSETS_DIR/locales/si/OAuth.json?url";

      import PDFFormDialogsiUrl from "ASSETS_DIR/locales/si/PDFFormDialog.json?url";

      import PaymentssiUrl from "ASSETS_DIR/locales/si/Payments.json?url";

      import PaymentsEnterprisesiUrl from "ASSETS_DIR/locales/si/PaymentsEnterprise.json?url";

      import PeoplesiUrl from "ASSETS_DIR/locales/si/People.json?url";

      import PeopleTranslationssiUrl from "ASSETS_DIR/locales/si/PeopleTranslations.json?url";

      import PortalUnavailablesiUrl from "ASSETS_DIR/locales/si/PortalUnavailable.json?url";

      import PreparationPortalsiUrl from "ASSETS_DIR/locales/si/PreparationPortal.json?url";

      import PrivacyPagesiUrl from "ASSETS_DIR/locales/si/PrivacyPage.json?url";

      import ProfilesiUrl from "ASSETS_DIR/locales/si/Profile.json?url";

      import ResetApplicationDialogsiUrl from "ASSETS_DIR/locales/si/ResetApplicationDialog.json?url";

      import RoomLogoCoversiUrl from "ASSETS_DIR/locales/si/RoomLogoCover.json?url";

      import SMTPSettingssiUrl from "ASSETS_DIR/locales/si/SMTPSettings.json?url";

      import SalesDepartmentRequestDialogsiUrl from "ASSETS_DIR/locales/si/SalesDepartmentRequestDialog.json?url";

      import SendInviteDialogsiUrl from "ASSETS_DIR/locales/si/SendInviteDialog.json?url";

      import SettingssiUrl from "ASSETS_DIR/locales/si/Settings.json?url";

      import SharingPanelsiUrl from "ASSETS_DIR/locales/si/SharingPanel.json?url";

      import SingleSignOnsiUrl from "ASSETS_DIR/locales/si/SingleSignOn.json?url";

      import SmartBannersiUrl from "ASSETS_DIR/locales/si/SmartBanner.json?url";

      import SocialAuthWelcomeDialogsiUrl from "ASSETS_DIR/locales/si/SocialAuthWelcomeDialog.json?url";

      import TranslationssiUrl from "ASSETS_DIR/locales/si/Translations.json?url";

      import UploadPanelsiUrl from "ASSETS_DIR/locales/si/UploadPanel.json?url";

      import VersionHistorysiUrl from "ASSETS_DIR/locales/si/VersionHistory.json?url";

      import WebPluginssiUrl from "ASSETS_DIR/locales/si/WebPlugins.json?url";

      import WebhookssiUrl from "ASSETS_DIR/locales/si/Webhooks.json?url";

      import AboutskUrl from "ASSETS_DIR/locales/sk/About.json?url";

      import ArchiveDialogskUrl from "ASSETS_DIR/locales/sk/ArchiveDialog.json?url";

      import ArticleskUrl from "ASSETS_DIR/locales/sk/Article.json?url";

      import BackupCodesDialogskUrl from "ASSETS_DIR/locales/sk/BackupCodesDialog.json?url";

      import ChangeEmailDialogskUrl from "ASSETS_DIR/locales/sk/ChangeEmailDialog.json?url";

      import ChangePasswordDialogskUrl from "ASSETS_DIR/locales/sk/ChangePasswordDialog.json?url";

      import ChangePhoneDialogskUrl from "ASSETS_DIR/locales/sk/ChangePhoneDialog.json?url";

      import ChangePortalOwnerskUrl from "ASSETS_DIR/locales/sk/ChangePortalOwner.json?url";

      import ChangeUserStatusDialogskUrl from "ASSETS_DIR/locales/sk/ChangeUserStatusDialog.json?url";

      import ChangeUserTypeDialogskUrl from "ASSETS_DIR/locales/sk/ChangeUserTypeDialog.json?url";

      import ConnectDialogskUrl from "ASSETS_DIR/locales/sk/ConnectDialog.json?url";

      import ConvertDialogskUrl from "ASSETS_DIR/locales/sk/ConvertDialog.json?url";

      import ConvertPasswordDialogskUrl from "ASSETS_DIR/locales/sk/ConvertPasswordDialog.json?url";

      import CreateEditRoomDialogskUrl from "ASSETS_DIR/locales/sk/CreateEditRoomDialog.json?url";

      import DataReassignmentDialogskUrl from "ASSETS_DIR/locales/sk/DataReassignmentDialog.json?url";

      import DeleteDialogskUrl from "ASSETS_DIR/locales/sk/DeleteDialog.json?url";

      import DeleteProfileEverDialogskUrl from "ASSETS_DIR/locales/sk/DeleteProfileEverDialog.json?url";

      import DeleteSelfProfileDialogskUrl from "ASSETS_DIR/locales/sk/DeleteSelfProfileDialog.json?url";

      import DeleteThirdPartyDialogskUrl from "ASSETS_DIR/locales/sk/DeleteThirdPartyDialog.json?url";

      import DowngradePlanDialogskUrl from "ASSETS_DIR/locales/sk/DowngradePlanDialog.json?url";

      import EmbeddingPanelskUrl from "ASSETS_DIR/locales/sk/EmbeddingPanel.json?url";

      import EmptyTrashDialogskUrl from "ASSETS_DIR/locales/sk/EmptyTrashDialog.json?url";

      import EmptyViewskUrl from "ASSETS_DIR/locales/sk/EmptyView.json?url";

      import ErrorsskUrl from "ASSETS_DIR/locales/sk/Errors.json?url";

      import FilesskUrl from "ASSETS_DIR/locales/sk/Files.json?url";

      import FilesSettingsskUrl from "ASSETS_DIR/locales/sk/FilesSettings.json?url";

      import FillPDFDialogskUrl from "ASSETS_DIR/locales/sk/FillPDFDialog.json?url";

      import FormFillingTipsDialogskUrl from "ASSETS_DIR/locales/sk/FormFillingTipsDialog.json?url";

      import FormGalleryskUrl from "ASSETS_DIR/locales/sk/FormGallery.json?url";

      import HotkeysPanelskUrl from "ASSETS_DIR/locales/sk/HotkeysPanel.json?url";

      import InfoPanelskUrl from "ASSETS_DIR/locales/sk/InfoPanel.json?url";

      import InviteDialogskUrl from "ASSETS_DIR/locales/sk/InviteDialog.json?url";

      import JavascriptSdkskUrl from "ASSETS_DIR/locales/sk/JavascriptSdk.json?url";

      import LdapskUrl from "ASSETS_DIR/locales/sk/Ldap.json?url";

      import MainBarskUrl from "ASSETS_DIR/locales/sk/MainBar.json?url";

      import NotificationsskUrl from "ASSETS_DIR/locales/sk/Notifications.json?url";

      import OAuthskUrl from "ASSETS_DIR/locales/sk/OAuth.json?url";

      import PDFFormDialogskUrl from "ASSETS_DIR/locales/sk/PDFFormDialog.json?url";

      import PaymentsskUrl from "ASSETS_DIR/locales/sk/Payments.json?url";

      import PaymentsEnterpriseskUrl from "ASSETS_DIR/locales/sk/PaymentsEnterprise.json?url";

      import PeopleskUrl from "ASSETS_DIR/locales/sk/People.json?url";

      import PeopleTranslationsskUrl from "ASSETS_DIR/locales/sk/PeopleTranslations.json?url";

      import PortalUnavailableskUrl from "ASSETS_DIR/locales/sk/PortalUnavailable.json?url";

      import PreparationPortalskUrl from "ASSETS_DIR/locales/sk/PreparationPortal.json?url";

      import PrivacyPageskUrl from "ASSETS_DIR/locales/sk/PrivacyPage.json?url";

      import ProfileskUrl from "ASSETS_DIR/locales/sk/Profile.json?url";

      import ResetApplicationDialogskUrl from "ASSETS_DIR/locales/sk/ResetApplicationDialog.json?url";

      import RoomLogoCoverskUrl from "ASSETS_DIR/locales/sk/RoomLogoCover.json?url";

      import SMTPSettingsskUrl from "ASSETS_DIR/locales/sk/SMTPSettings.json?url";

      import SalesDepartmentRequestDialogskUrl from "ASSETS_DIR/locales/sk/SalesDepartmentRequestDialog.json?url";

      import SendInviteDialogskUrl from "ASSETS_DIR/locales/sk/SendInviteDialog.json?url";

      import SettingsskUrl from "ASSETS_DIR/locales/sk/Settings.json?url";

      import SharingPanelskUrl from "ASSETS_DIR/locales/sk/SharingPanel.json?url";

      import SingleSignOnskUrl from "ASSETS_DIR/locales/sk/SingleSignOn.json?url";

      import SmartBannerskUrl from "ASSETS_DIR/locales/sk/SmartBanner.json?url";

      import SocialAuthWelcomeDialogskUrl from "ASSETS_DIR/locales/sk/SocialAuthWelcomeDialog.json?url";

      import TranslationsskUrl from "ASSETS_DIR/locales/sk/Translations.json?url";

      import UploadPanelskUrl from "ASSETS_DIR/locales/sk/UploadPanel.json?url";

      import VersionHistoryskUrl from "ASSETS_DIR/locales/sk/VersionHistory.json?url";

      import WebPluginsskUrl from "ASSETS_DIR/locales/sk/WebPlugins.json?url";

      import WebhooksskUrl from "ASSETS_DIR/locales/sk/Webhooks.json?url";

      import AboutslUrl from "ASSETS_DIR/locales/sl/About.json?url";

      import ArchiveDialogslUrl from "ASSETS_DIR/locales/sl/ArchiveDialog.json?url";

      import ArticleslUrl from "ASSETS_DIR/locales/sl/Article.json?url";

      import BackupCodesDialogslUrl from "ASSETS_DIR/locales/sl/BackupCodesDialog.json?url";

      import ChangeEmailDialogslUrl from "ASSETS_DIR/locales/sl/ChangeEmailDialog.json?url";

      import ChangePasswordDialogslUrl from "ASSETS_DIR/locales/sl/ChangePasswordDialog.json?url";

      import ChangePhoneDialogslUrl from "ASSETS_DIR/locales/sl/ChangePhoneDialog.json?url";

      import ChangePortalOwnerslUrl from "ASSETS_DIR/locales/sl/ChangePortalOwner.json?url";

      import ChangeUserStatusDialogslUrl from "ASSETS_DIR/locales/sl/ChangeUserStatusDialog.json?url";

      import ChangeUserTypeDialogslUrl from "ASSETS_DIR/locales/sl/ChangeUserTypeDialog.json?url";

      import ConnectDialogslUrl from "ASSETS_DIR/locales/sl/ConnectDialog.json?url";

      import ConvertDialogslUrl from "ASSETS_DIR/locales/sl/ConvertDialog.json?url";

      import ConvertPasswordDialogslUrl from "ASSETS_DIR/locales/sl/ConvertPasswordDialog.json?url";

      import CreateEditRoomDialogslUrl from "ASSETS_DIR/locales/sl/CreateEditRoomDialog.json?url";

      import DataReassignmentDialogslUrl from "ASSETS_DIR/locales/sl/DataReassignmentDialog.json?url";

      import DeleteDialogslUrl from "ASSETS_DIR/locales/sl/DeleteDialog.json?url";

      import DeleteProfileEverDialogslUrl from "ASSETS_DIR/locales/sl/DeleteProfileEverDialog.json?url";

      import DeleteSelfProfileDialogslUrl from "ASSETS_DIR/locales/sl/DeleteSelfProfileDialog.json?url";

      import DeleteThirdPartyDialogslUrl from "ASSETS_DIR/locales/sl/DeleteThirdPartyDialog.json?url";

      import DowngradePlanDialogslUrl from "ASSETS_DIR/locales/sl/DowngradePlanDialog.json?url";

      import EmbeddingPanelslUrl from "ASSETS_DIR/locales/sl/EmbeddingPanel.json?url";

      import EmptyTrashDialogslUrl from "ASSETS_DIR/locales/sl/EmptyTrashDialog.json?url";

      import EmptyViewslUrl from "ASSETS_DIR/locales/sl/EmptyView.json?url";

      import ErrorsslUrl from "ASSETS_DIR/locales/sl/Errors.json?url";

      import FilesslUrl from "ASSETS_DIR/locales/sl/Files.json?url";

      import FilesSettingsslUrl from "ASSETS_DIR/locales/sl/FilesSettings.json?url";

      import FillPDFDialogslUrl from "ASSETS_DIR/locales/sl/FillPDFDialog.json?url";

      import FormFillingTipsDialogslUrl from "ASSETS_DIR/locales/sl/FormFillingTipsDialog.json?url";

      import FormGalleryslUrl from "ASSETS_DIR/locales/sl/FormGallery.json?url";

      import HotkeysPanelslUrl from "ASSETS_DIR/locales/sl/HotkeysPanel.json?url";

      import InfoPanelslUrl from "ASSETS_DIR/locales/sl/InfoPanel.json?url";

      import InviteDialogslUrl from "ASSETS_DIR/locales/sl/InviteDialog.json?url";

      import JavascriptSdkslUrl from "ASSETS_DIR/locales/sl/JavascriptSdk.json?url";

      import LdapslUrl from "ASSETS_DIR/locales/sl/Ldap.json?url";

      import MainBarslUrl from "ASSETS_DIR/locales/sl/MainBar.json?url";

      import NotificationsslUrl from "ASSETS_DIR/locales/sl/Notifications.json?url";

      import OAuthslUrl from "ASSETS_DIR/locales/sl/OAuth.json?url";

      import PDFFormDialogslUrl from "ASSETS_DIR/locales/sl/PDFFormDialog.json?url";

      import PaymentsslUrl from "ASSETS_DIR/locales/sl/Payments.json?url";

      import PaymentsEnterpriseslUrl from "ASSETS_DIR/locales/sl/PaymentsEnterprise.json?url";

      import PeopleslUrl from "ASSETS_DIR/locales/sl/People.json?url";

      import PeopleTranslationsslUrl from "ASSETS_DIR/locales/sl/PeopleTranslations.json?url";

      import PortalUnavailableslUrl from "ASSETS_DIR/locales/sl/PortalUnavailable.json?url";

      import PreparationPortalslUrl from "ASSETS_DIR/locales/sl/PreparationPortal.json?url";

      import PrivacyPageslUrl from "ASSETS_DIR/locales/sl/PrivacyPage.json?url";

      import ProfileslUrl from "ASSETS_DIR/locales/sl/Profile.json?url";

      import ResetApplicationDialogslUrl from "ASSETS_DIR/locales/sl/ResetApplicationDialog.json?url";

      import RoomLogoCoverslUrl from "ASSETS_DIR/locales/sl/RoomLogoCover.json?url";

      import SMTPSettingsslUrl from "ASSETS_DIR/locales/sl/SMTPSettings.json?url";

      import SalesDepartmentRequestDialogslUrl from "ASSETS_DIR/locales/sl/SalesDepartmentRequestDialog.json?url";

      import SendInviteDialogslUrl from "ASSETS_DIR/locales/sl/SendInviteDialog.json?url";

      import SettingsslUrl from "ASSETS_DIR/locales/sl/Settings.json?url";

      import SharingPanelslUrl from "ASSETS_DIR/locales/sl/SharingPanel.json?url";

      import SingleSignOnslUrl from "ASSETS_DIR/locales/sl/SingleSignOn.json?url";

      import SmartBannerslUrl from "ASSETS_DIR/locales/sl/SmartBanner.json?url";

      import SocialAuthWelcomeDialogslUrl from "ASSETS_DIR/locales/sl/SocialAuthWelcomeDialog.json?url";

      import TranslationsslUrl from "ASSETS_DIR/locales/sl/Translations.json?url";

      import UploadPanelslUrl from "ASSETS_DIR/locales/sl/UploadPanel.json?url";

      import VersionHistoryslUrl from "ASSETS_DIR/locales/sl/VersionHistory.json?url";

      import WebPluginsslUrl from "ASSETS_DIR/locales/sl/WebPlugins.json?url";

      import WebhooksslUrl from "ASSETS_DIR/locales/sl/Webhooks.json?url";

      import AboutsrCyrlRSUrl from "ASSETS_DIR/locales/sr-Cyrl-RS/About.json?url";

      import ArchiveDialogsrCyrlRSUrl from "ASSETS_DIR/locales/sr-Cyrl-RS/ArchiveDialog.json?url";

      import ArticlesrCyrlRSUrl from "ASSETS_DIR/locales/sr-Cyrl-RS/Article.json?url";

      import BackupCodesDialogsrCyrlRSUrl from "ASSETS_DIR/locales/sr-Cyrl-RS/BackupCodesDialog.json?url";

      import ChangeEmailDialogsrCyrlRSUrl from "ASSETS_DIR/locales/sr-Cyrl-RS/ChangeEmailDialog.json?url";

      import ChangePasswordDialogsrCyrlRSUrl from "ASSETS_DIR/locales/sr-Cyrl-RS/ChangePasswordDialog.json?url";

      import ChangePhoneDialogsrCyrlRSUrl from "ASSETS_DIR/locales/sr-Cyrl-RS/ChangePhoneDialog.json?url";

      import ChangePortalOwnersrCyrlRSUrl from "ASSETS_DIR/locales/sr-Cyrl-RS/ChangePortalOwner.json?url";

      import ChangeUserStatusDialogsrCyrlRSUrl from "ASSETS_DIR/locales/sr-Cyrl-RS/ChangeUserStatusDialog.json?url";

      import ChangeUserTypeDialogsrCyrlRSUrl from "ASSETS_DIR/locales/sr-Cyrl-RS/ChangeUserTypeDialog.json?url";

      import ConnectDialogsrCyrlRSUrl from "ASSETS_DIR/locales/sr-Cyrl-RS/ConnectDialog.json?url";

      import ConvertDialogsrCyrlRSUrl from "ASSETS_DIR/locales/sr-Cyrl-RS/ConvertDialog.json?url";

      import ConvertPasswordDialogsrCyrlRSUrl from "ASSETS_DIR/locales/sr-Cyrl-RS/ConvertPasswordDialog.json?url";

      import CreateEditRoomDialogsrCyrlRSUrl from "ASSETS_DIR/locales/sr-Cyrl-RS/CreateEditRoomDialog.json?url";

      import DataReassignmentDialogsrCyrlRSUrl from "ASSETS_DIR/locales/sr-Cyrl-RS/DataReassignmentDialog.json?url";

      import DeleteDialogsrCyrlRSUrl from "ASSETS_DIR/locales/sr-Cyrl-RS/DeleteDialog.json?url";

      import DeleteProfileEverDialogsrCyrlRSUrl from "ASSETS_DIR/locales/sr-Cyrl-RS/DeleteProfileEverDialog.json?url";

      import DeleteSelfProfileDialogsrCyrlRSUrl from "ASSETS_DIR/locales/sr-Cyrl-RS/DeleteSelfProfileDialog.json?url";

      import DeleteThirdPartyDialogsrCyrlRSUrl from "ASSETS_DIR/locales/sr-Cyrl-RS/DeleteThirdPartyDialog.json?url";

      import DowngradePlanDialogsrCyrlRSUrl from "ASSETS_DIR/locales/sr-Cyrl-RS/DowngradePlanDialog.json?url";

      import EmbeddingPanelsrCyrlRSUrl from "ASSETS_DIR/locales/sr-Cyrl-RS/EmbeddingPanel.json?url";

      import EmptyTrashDialogsrCyrlRSUrl from "ASSETS_DIR/locales/sr-Cyrl-RS/EmptyTrashDialog.json?url";

      import EmptyViewsrCyrlRSUrl from "ASSETS_DIR/locales/sr-Cyrl-RS/EmptyView.json?url";

      import ErrorssrCyrlRSUrl from "ASSETS_DIR/locales/sr-Cyrl-RS/Errors.json?url";

      import FilessrCyrlRSUrl from "ASSETS_DIR/locales/sr-Cyrl-RS/Files.json?url";

      import FilesSettingssrCyrlRSUrl from "ASSETS_DIR/locales/sr-Cyrl-RS/FilesSettings.json?url";

      import FillPDFDialogsrCyrlRSUrl from "ASSETS_DIR/locales/sr-Cyrl-RS/FillPDFDialog.json?url";

      import FormFillingTipsDialogsrCyrlRSUrl from "ASSETS_DIR/locales/sr-Cyrl-RS/FormFillingTipsDialog.json?url";

      import FormGallerysrCyrlRSUrl from "ASSETS_DIR/locales/sr-Cyrl-RS/FormGallery.json?url";

      import HotkeysPanelsrCyrlRSUrl from "ASSETS_DIR/locales/sr-Cyrl-RS/HotkeysPanel.json?url";

      import InfoPanelsrCyrlRSUrl from "ASSETS_DIR/locales/sr-Cyrl-RS/InfoPanel.json?url";

      import InviteDialogsrCyrlRSUrl from "ASSETS_DIR/locales/sr-Cyrl-RS/InviteDialog.json?url";

      import JavascriptSdksrCyrlRSUrl from "ASSETS_DIR/locales/sr-Cyrl-RS/JavascriptSdk.json?url";

      import LdapsrCyrlRSUrl from "ASSETS_DIR/locales/sr-Cyrl-RS/Ldap.json?url";

      import MainBarsrCyrlRSUrl from "ASSETS_DIR/locales/sr-Cyrl-RS/MainBar.json?url";

      import NotificationssrCyrlRSUrl from "ASSETS_DIR/locales/sr-Cyrl-RS/Notifications.json?url";

      import OAuthsrCyrlRSUrl from "ASSETS_DIR/locales/sr-Cyrl-RS/OAuth.json?url";

      import PDFFormDialogsrCyrlRSUrl from "ASSETS_DIR/locales/sr-Cyrl-RS/PDFFormDialog.json?url";

      import PaymentssrCyrlRSUrl from "ASSETS_DIR/locales/sr-Cyrl-RS/Payments.json?url";

      import PaymentsEnterprisesrCyrlRSUrl from "ASSETS_DIR/locales/sr-Cyrl-RS/PaymentsEnterprise.json?url";

      import PeoplesrCyrlRSUrl from "ASSETS_DIR/locales/sr-Cyrl-RS/People.json?url";

      import PeopleTranslationssrCyrlRSUrl from "ASSETS_DIR/locales/sr-Cyrl-RS/PeopleTranslations.json?url";

      import PortalUnavailablesrCyrlRSUrl from "ASSETS_DIR/locales/sr-Cyrl-RS/PortalUnavailable.json?url";

      import PreparationPortalsrCyrlRSUrl from "ASSETS_DIR/locales/sr-Cyrl-RS/PreparationPortal.json?url";

      import PrivacyPagesrCyrlRSUrl from "ASSETS_DIR/locales/sr-Cyrl-RS/PrivacyPage.json?url";

      import ProfilesrCyrlRSUrl from "ASSETS_DIR/locales/sr-Cyrl-RS/Profile.json?url";

      import ResetApplicationDialogsrCyrlRSUrl from "ASSETS_DIR/locales/sr-Cyrl-RS/ResetApplicationDialog.json?url";

      import RoomLogoCoversrCyrlRSUrl from "ASSETS_DIR/locales/sr-Cyrl-RS/RoomLogoCover.json?url";

      import SMTPSettingssrCyrlRSUrl from "ASSETS_DIR/locales/sr-Cyrl-RS/SMTPSettings.json?url";

      import SalesDepartmentRequestDialogsrCyrlRSUrl from "ASSETS_DIR/locales/sr-Cyrl-RS/SalesDepartmentRequestDialog.json?url";

      import SendInviteDialogsrCyrlRSUrl from "ASSETS_DIR/locales/sr-Cyrl-RS/SendInviteDialog.json?url";

      import SettingssrCyrlRSUrl from "ASSETS_DIR/locales/sr-Cyrl-RS/Settings.json?url";

      import SharingPanelsrCyrlRSUrl from "ASSETS_DIR/locales/sr-Cyrl-RS/SharingPanel.json?url";

      import SingleSignOnsrCyrlRSUrl from "ASSETS_DIR/locales/sr-Cyrl-RS/SingleSignOn.json?url";

      import SmartBannersrCyrlRSUrl from "ASSETS_DIR/locales/sr-Cyrl-RS/SmartBanner.json?url";

      import SocialAuthWelcomeDialogsrCyrlRSUrl from "ASSETS_DIR/locales/sr-Cyrl-RS/SocialAuthWelcomeDialog.json?url";

      import TranslationssrCyrlRSUrl from "ASSETS_DIR/locales/sr-Cyrl-RS/Translations.json?url";

      import UploadPanelsrCyrlRSUrl from "ASSETS_DIR/locales/sr-Cyrl-RS/UploadPanel.json?url";

      import VersionHistorysrCyrlRSUrl from "ASSETS_DIR/locales/sr-Cyrl-RS/VersionHistory.json?url";

      import WebPluginssrCyrlRSUrl from "ASSETS_DIR/locales/sr-Cyrl-RS/WebPlugins.json?url";

      import WebhookssrCyrlRSUrl from "ASSETS_DIR/locales/sr-Cyrl-RS/Webhooks.json?url";

      import AboutsrLatnRSUrl from "ASSETS_DIR/locales/sr-Latn-RS/About.json?url";

      import ArchiveDialogsrLatnRSUrl from "ASSETS_DIR/locales/sr-Latn-RS/ArchiveDialog.json?url";

      import ArticlesrLatnRSUrl from "ASSETS_DIR/locales/sr-Latn-RS/Article.json?url";

      import BackupCodesDialogsrLatnRSUrl from "ASSETS_DIR/locales/sr-Latn-RS/BackupCodesDialog.json?url";

      import ChangeEmailDialogsrLatnRSUrl from "ASSETS_DIR/locales/sr-Latn-RS/ChangeEmailDialog.json?url";

      import ChangePasswordDialogsrLatnRSUrl from "ASSETS_DIR/locales/sr-Latn-RS/ChangePasswordDialog.json?url";

      import ChangePhoneDialogsrLatnRSUrl from "ASSETS_DIR/locales/sr-Latn-RS/ChangePhoneDialog.json?url";

      import ChangePortalOwnersrLatnRSUrl from "ASSETS_DIR/locales/sr-Latn-RS/ChangePortalOwner.json?url";

      import ChangeUserStatusDialogsrLatnRSUrl from "ASSETS_DIR/locales/sr-Latn-RS/ChangeUserStatusDialog.json?url";

      import ChangeUserTypeDialogsrLatnRSUrl from "ASSETS_DIR/locales/sr-Latn-RS/ChangeUserTypeDialog.json?url";

      import ConnectDialogsrLatnRSUrl from "ASSETS_DIR/locales/sr-Latn-RS/ConnectDialog.json?url";

      import ConvertDialogsrLatnRSUrl from "ASSETS_DIR/locales/sr-Latn-RS/ConvertDialog.json?url";

      import ConvertPasswordDialogsrLatnRSUrl from "ASSETS_DIR/locales/sr-Latn-RS/ConvertPasswordDialog.json?url";

      import CreateEditRoomDialogsrLatnRSUrl from "ASSETS_DIR/locales/sr-Latn-RS/CreateEditRoomDialog.json?url";

      import DataReassignmentDialogsrLatnRSUrl from "ASSETS_DIR/locales/sr-Latn-RS/DataReassignmentDialog.json?url";

      import DeleteDialogsrLatnRSUrl from "ASSETS_DIR/locales/sr-Latn-RS/DeleteDialog.json?url";

      import DeleteProfileEverDialogsrLatnRSUrl from "ASSETS_DIR/locales/sr-Latn-RS/DeleteProfileEverDialog.json?url";

      import DeleteSelfProfileDialogsrLatnRSUrl from "ASSETS_DIR/locales/sr-Latn-RS/DeleteSelfProfileDialog.json?url";

      import DeleteThirdPartyDialogsrLatnRSUrl from "ASSETS_DIR/locales/sr-Latn-RS/DeleteThirdPartyDialog.json?url";

      import DowngradePlanDialogsrLatnRSUrl from "ASSETS_DIR/locales/sr-Latn-RS/DowngradePlanDialog.json?url";

      import EmbeddingPanelsrLatnRSUrl from "ASSETS_DIR/locales/sr-Latn-RS/EmbeddingPanel.json?url";

      import EmptyTrashDialogsrLatnRSUrl from "ASSETS_DIR/locales/sr-Latn-RS/EmptyTrashDialog.json?url";

      import EmptyViewsrLatnRSUrl from "ASSETS_DIR/locales/sr-Latn-RS/EmptyView.json?url";

      import ErrorssrLatnRSUrl from "ASSETS_DIR/locales/sr-Latn-RS/Errors.json?url";

      import FilessrLatnRSUrl from "ASSETS_DIR/locales/sr-Latn-RS/Files.json?url";

      import FilesSettingssrLatnRSUrl from "ASSETS_DIR/locales/sr-Latn-RS/FilesSettings.json?url";

      import FillPDFDialogsrLatnRSUrl from "ASSETS_DIR/locales/sr-Latn-RS/FillPDFDialog.json?url";

      import FormFillingTipsDialogsrLatnRSUrl from "ASSETS_DIR/locales/sr-Latn-RS/FormFillingTipsDialog.json?url";

      import FormGallerysrLatnRSUrl from "ASSETS_DIR/locales/sr-Latn-RS/FormGallery.json?url";

      import HotkeysPanelsrLatnRSUrl from "ASSETS_DIR/locales/sr-Latn-RS/HotkeysPanel.json?url";

      import InfoPanelsrLatnRSUrl from "ASSETS_DIR/locales/sr-Latn-RS/InfoPanel.json?url";

      import InviteDialogsrLatnRSUrl from "ASSETS_DIR/locales/sr-Latn-RS/InviteDialog.json?url";

      import JavascriptSdksrLatnRSUrl from "ASSETS_DIR/locales/sr-Latn-RS/JavascriptSdk.json?url";

      import LdapsrLatnRSUrl from "ASSETS_DIR/locales/sr-Latn-RS/Ldap.json?url";

      import MainBarsrLatnRSUrl from "ASSETS_DIR/locales/sr-Latn-RS/MainBar.json?url";

      import NotificationssrLatnRSUrl from "ASSETS_DIR/locales/sr-Latn-RS/Notifications.json?url";

      import OAuthsrLatnRSUrl from "ASSETS_DIR/locales/sr-Latn-RS/OAuth.json?url";

      import PDFFormDialogsrLatnRSUrl from "ASSETS_DIR/locales/sr-Latn-RS/PDFFormDialog.json?url";

      import PaymentssrLatnRSUrl from "ASSETS_DIR/locales/sr-Latn-RS/Payments.json?url";

      import PaymentsEnterprisesrLatnRSUrl from "ASSETS_DIR/locales/sr-Latn-RS/PaymentsEnterprise.json?url";

      import PeoplesrLatnRSUrl from "ASSETS_DIR/locales/sr-Latn-RS/People.json?url";

      import PeopleTranslationssrLatnRSUrl from "ASSETS_DIR/locales/sr-Latn-RS/PeopleTranslations.json?url";

      import PortalUnavailablesrLatnRSUrl from "ASSETS_DIR/locales/sr-Latn-RS/PortalUnavailable.json?url";

      import PreparationPortalsrLatnRSUrl from "ASSETS_DIR/locales/sr-Latn-RS/PreparationPortal.json?url";

      import PrivacyPagesrLatnRSUrl from "ASSETS_DIR/locales/sr-Latn-RS/PrivacyPage.json?url";

      import ProfilesrLatnRSUrl from "ASSETS_DIR/locales/sr-Latn-RS/Profile.json?url";

      import ResetApplicationDialogsrLatnRSUrl from "ASSETS_DIR/locales/sr-Latn-RS/ResetApplicationDialog.json?url";

      import RoomLogoCoversrLatnRSUrl from "ASSETS_DIR/locales/sr-Latn-RS/RoomLogoCover.json?url";

      import SMTPSettingssrLatnRSUrl from "ASSETS_DIR/locales/sr-Latn-RS/SMTPSettings.json?url";

      import SalesDepartmentRequestDialogsrLatnRSUrl from "ASSETS_DIR/locales/sr-Latn-RS/SalesDepartmentRequestDialog.json?url";

      import SendInviteDialogsrLatnRSUrl from "ASSETS_DIR/locales/sr-Latn-RS/SendInviteDialog.json?url";

      import SettingssrLatnRSUrl from "ASSETS_DIR/locales/sr-Latn-RS/Settings.json?url";

      import SharingPanelsrLatnRSUrl from "ASSETS_DIR/locales/sr-Latn-RS/SharingPanel.json?url";

      import SingleSignOnsrLatnRSUrl from "ASSETS_DIR/locales/sr-Latn-RS/SingleSignOn.json?url";

      import SmartBannersrLatnRSUrl from "ASSETS_DIR/locales/sr-Latn-RS/SmartBanner.json?url";

      import SocialAuthWelcomeDialogsrLatnRSUrl from "ASSETS_DIR/locales/sr-Latn-RS/SocialAuthWelcomeDialog.json?url";

      import TranslationssrLatnRSUrl from "ASSETS_DIR/locales/sr-Latn-RS/Translations.json?url";

      import UploadPanelsrLatnRSUrl from "ASSETS_DIR/locales/sr-Latn-RS/UploadPanel.json?url";

      import VersionHistorysrLatnRSUrl from "ASSETS_DIR/locales/sr-Latn-RS/VersionHistory.json?url";

      import WebPluginssrLatnRSUrl from "ASSETS_DIR/locales/sr-Latn-RS/WebPlugins.json?url";

      import WebhookssrLatnRSUrl from "ASSETS_DIR/locales/sr-Latn-RS/Webhooks.json?url";

      import AbouttrUrl from "ASSETS_DIR/locales/tr/About.json?url";

      import ArchiveDialogtrUrl from "ASSETS_DIR/locales/tr/ArchiveDialog.json?url";

      import ArticletrUrl from "ASSETS_DIR/locales/tr/Article.json?url";

      import BackupCodesDialogtrUrl from "ASSETS_DIR/locales/tr/BackupCodesDialog.json?url";

      import ChangeEmailDialogtrUrl from "ASSETS_DIR/locales/tr/ChangeEmailDialog.json?url";

      import ChangePasswordDialogtrUrl from "ASSETS_DIR/locales/tr/ChangePasswordDialog.json?url";

      import ChangePhoneDialogtrUrl from "ASSETS_DIR/locales/tr/ChangePhoneDialog.json?url";

      import ChangePortalOwnertrUrl from "ASSETS_DIR/locales/tr/ChangePortalOwner.json?url";

      import ChangeUserStatusDialogtrUrl from "ASSETS_DIR/locales/tr/ChangeUserStatusDialog.json?url";

      import ChangeUserTypeDialogtrUrl from "ASSETS_DIR/locales/tr/ChangeUserTypeDialog.json?url";

      import ConnectDialogtrUrl from "ASSETS_DIR/locales/tr/ConnectDialog.json?url";

      import ConvertDialogtrUrl from "ASSETS_DIR/locales/tr/ConvertDialog.json?url";

      import ConvertPasswordDialogtrUrl from "ASSETS_DIR/locales/tr/ConvertPasswordDialog.json?url";

      import CreateEditRoomDialogtrUrl from "ASSETS_DIR/locales/tr/CreateEditRoomDialog.json?url";

      import DataReassignmentDialogtrUrl from "ASSETS_DIR/locales/tr/DataReassignmentDialog.json?url";

      import DeleteDialogtrUrl from "ASSETS_DIR/locales/tr/DeleteDialog.json?url";

      import DeleteProfileEverDialogtrUrl from "ASSETS_DIR/locales/tr/DeleteProfileEverDialog.json?url";

      import DeleteSelfProfileDialogtrUrl from "ASSETS_DIR/locales/tr/DeleteSelfProfileDialog.json?url";

      import DeleteThirdPartyDialogtrUrl from "ASSETS_DIR/locales/tr/DeleteThirdPartyDialog.json?url";

      import DowngradePlanDialogtrUrl from "ASSETS_DIR/locales/tr/DowngradePlanDialog.json?url";

      import EmbeddingPaneltrUrl from "ASSETS_DIR/locales/tr/EmbeddingPanel.json?url";

      import EmptyTrashDialogtrUrl from "ASSETS_DIR/locales/tr/EmptyTrashDialog.json?url";

      import EmptyViewtrUrl from "ASSETS_DIR/locales/tr/EmptyView.json?url";

      import ErrorstrUrl from "ASSETS_DIR/locales/tr/Errors.json?url";

      import FilestrUrl from "ASSETS_DIR/locales/tr/Files.json?url";

      import FilesSettingstrUrl from "ASSETS_DIR/locales/tr/FilesSettings.json?url";

      import FillPDFDialogtrUrl from "ASSETS_DIR/locales/tr/FillPDFDialog.json?url";

      import FormFillingTipsDialogtrUrl from "ASSETS_DIR/locales/tr/FormFillingTipsDialog.json?url";

      import FormGallerytrUrl from "ASSETS_DIR/locales/tr/FormGallery.json?url";

      import HotkeysPaneltrUrl from "ASSETS_DIR/locales/tr/HotkeysPanel.json?url";

      import InfoPaneltrUrl from "ASSETS_DIR/locales/tr/InfoPanel.json?url";

      import InviteDialogtrUrl from "ASSETS_DIR/locales/tr/InviteDialog.json?url";

      import JavascriptSdktrUrl from "ASSETS_DIR/locales/tr/JavascriptSdk.json?url";

      import LdaptrUrl from "ASSETS_DIR/locales/tr/Ldap.json?url";

      import MainBartrUrl from "ASSETS_DIR/locales/tr/MainBar.json?url";

      import NotificationstrUrl from "ASSETS_DIR/locales/tr/Notifications.json?url";

      import OAuthtrUrl from "ASSETS_DIR/locales/tr/OAuth.json?url";

      import PDFFormDialogtrUrl from "ASSETS_DIR/locales/tr/PDFFormDialog.json?url";

      import PaymentstrUrl from "ASSETS_DIR/locales/tr/Payments.json?url";

      import PaymentsEnterprisetrUrl from "ASSETS_DIR/locales/tr/PaymentsEnterprise.json?url";

      import PeopletrUrl from "ASSETS_DIR/locales/tr/People.json?url";

      import PeopleTranslationstrUrl from "ASSETS_DIR/locales/tr/PeopleTranslations.json?url";

      import PortalUnavailabletrUrl from "ASSETS_DIR/locales/tr/PortalUnavailable.json?url";

      import PreparationPortaltrUrl from "ASSETS_DIR/locales/tr/PreparationPortal.json?url";

      import PrivacyPagetrUrl from "ASSETS_DIR/locales/tr/PrivacyPage.json?url";

      import ProfiletrUrl from "ASSETS_DIR/locales/tr/Profile.json?url";

      import ResetApplicationDialogtrUrl from "ASSETS_DIR/locales/tr/ResetApplicationDialog.json?url";

      import RoomLogoCovertrUrl from "ASSETS_DIR/locales/tr/RoomLogoCover.json?url";

      import SMTPSettingstrUrl from "ASSETS_DIR/locales/tr/SMTPSettings.json?url";

      import SalesDepartmentRequestDialogtrUrl from "ASSETS_DIR/locales/tr/SalesDepartmentRequestDialog.json?url";

      import SendInviteDialogtrUrl from "ASSETS_DIR/locales/tr/SendInviteDialog.json?url";

      import SettingstrUrl from "ASSETS_DIR/locales/tr/Settings.json?url";

      import SharingPaneltrUrl from "ASSETS_DIR/locales/tr/SharingPanel.json?url";

      import SingleSignOntrUrl from "ASSETS_DIR/locales/tr/SingleSignOn.json?url";

      import SmartBannertrUrl from "ASSETS_DIR/locales/tr/SmartBanner.json?url";

      import SocialAuthWelcomeDialogtrUrl from "ASSETS_DIR/locales/tr/SocialAuthWelcomeDialog.json?url";

      import TranslationstrUrl from "ASSETS_DIR/locales/tr/Translations.json?url";

      import UploadPaneltrUrl from "ASSETS_DIR/locales/tr/UploadPanel.json?url";

      import VersionHistorytrUrl from "ASSETS_DIR/locales/tr/VersionHistory.json?url";

      import WebPluginstrUrl from "ASSETS_DIR/locales/tr/WebPlugins.json?url";

      import WebhookstrUrl from "ASSETS_DIR/locales/tr/Webhooks.json?url";

      import AboutukUAUrl from "ASSETS_DIR/locales/uk-UA/About.json?url";

      import ArchiveDialogukUAUrl from "ASSETS_DIR/locales/uk-UA/ArchiveDialog.json?url";

      import ArticleukUAUrl from "ASSETS_DIR/locales/uk-UA/Article.json?url";

      import BackupCodesDialogukUAUrl from "ASSETS_DIR/locales/uk-UA/BackupCodesDialog.json?url";

      import ChangeEmailDialogukUAUrl from "ASSETS_DIR/locales/uk-UA/ChangeEmailDialog.json?url";

      import ChangePasswordDialogukUAUrl from "ASSETS_DIR/locales/uk-UA/ChangePasswordDialog.json?url";

      import ChangePhoneDialogukUAUrl from "ASSETS_DIR/locales/uk-UA/ChangePhoneDialog.json?url";

      import ChangePortalOwnerukUAUrl from "ASSETS_DIR/locales/uk-UA/ChangePortalOwner.json?url";

      import ChangeUserStatusDialogukUAUrl from "ASSETS_DIR/locales/uk-UA/ChangeUserStatusDialog.json?url";

      import ChangeUserTypeDialogukUAUrl from "ASSETS_DIR/locales/uk-UA/ChangeUserTypeDialog.json?url";

      import ConnectDialogukUAUrl from "ASSETS_DIR/locales/uk-UA/ConnectDialog.json?url";

      import ConvertDialogukUAUrl from "ASSETS_DIR/locales/uk-UA/ConvertDialog.json?url";

      import ConvertPasswordDialogukUAUrl from "ASSETS_DIR/locales/uk-UA/ConvertPasswordDialog.json?url";

      import CreateEditRoomDialogukUAUrl from "ASSETS_DIR/locales/uk-UA/CreateEditRoomDialog.json?url";

      import DataReassignmentDialogukUAUrl from "ASSETS_DIR/locales/uk-UA/DataReassignmentDialog.json?url";

      import DeleteDialogukUAUrl from "ASSETS_DIR/locales/uk-UA/DeleteDialog.json?url";

      import DeleteProfileEverDialogukUAUrl from "ASSETS_DIR/locales/uk-UA/DeleteProfileEverDialog.json?url";

      import DeleteSelfProfileDialogukUAUrl from "ASSETS_DIR/locales/uk-UA/DeleteSelfProfileDialog.json?url";

      import DeleteThirdPartyDialogukUAUrl from "ASSETS_DIR/locales/uk-UA/DeleteThirdPartyDialog.json?url";

      import DowngradePlanDialogukUAUrl from "ASSETS_DIR/locales/uk-UA/DowngradePlanDialog.json?url";

      import EmbeddingPanelukUAUrl from "ASSETS_DIR/locales/uk-UA/EmbeddingPanel.json?url";

      import EmptyTrashDialogukUAUrl from "ASSETS_DIR/locales/uk-UA/EmptyTrashDialog.json?url";

      import EmptyViewukUAUrl from "ASSETS_DIR/locales/uk-UA/EmptyView.json?url";

      import ErrorsukUAUrl from "ASSETS_DIR/locales/uk-UA/Errors.json?url";

      import FilesukUAUrl from "ASSETS_DIR/locales/uk-UA/Files.json?url";

      import FilesSettingsukUAUrl from "ASSETS_DIR/locales/uk-UA/FilesSettings.json?url";

      import FillPDFDialogukUAUrl from "ASSETS_DIR/locales/uk-UA/FillPDFDialog.json?url";

      import FormFillingTipsDialogukUAUrl from "ASSETS_DIR/locales/uk-UA/FormFillingTipsDialog.json?url";

      import FormGalleryukUAUrl from "ASSETS_DIR/locales/uk-UA/FormGallery.json?url";

      import HotkeysPanelukUAUrl from "ASSETS_DIR/locales/uk-UA/HotkeysPanel.json?url";

      import InfoPanelukUAUrl from "ASSETS_DIR/locales/uk-UA/InfoPanel.json?url";

      import InviteDialogukUAUrl from "ASSETS_DIR/locales/uk-UA/InviteDialog.json?url";

      import JavascriptSdkukUAUrl from "ASSETS_DIR/locales/uk-UA/JavascriptSdk.json?url";

      import LdapukUAUrl from "ASSETS_DIR/locales/uk-UA/Ldap.json?url";

      import MainBarukUAUrl from "ASSETS_DIR/locales/uk-UA/MainBar.json?url";

      import NotificationsukUAUrl from "ASSETS_DIR/locales/uk-UA/Notifications.json?url";

      import OAuthukUAUrl from "ASSETS_DIR/locales/uk-UA/OAuth.json?url";

      import PDFFormDialogukUAUrl from "ASSETS_DIR/locales/uk-UA/PDFFormDialog.json?url";

      import PaymentsukUAUrl from "ASSETS_DIR/locales/uk-UA/Payments.json?url";

      import PaymentsEnterpriseukUAUrl from "ASSETS_DIR/locales/uk-UA/PaymentsEnterprise.json?url";

      import PeopleukUAUrl from "ASSETS_DIR/locales/uk-UA/People.json?url";

      import PeopleTranslationsukUAUrl from "ASSETS_DIR/locales/uk-UA/PeopleTranslations.json?url";

      import PortalUnavailableukUAUrl from "ASSETS_DIR/locales/uk-UA/PortalUnavailable.json?url";

      import PreparationPortalukUAUrl from "ASSETS_DIR/locales/uk-UA/PreparationPortal.json?url";

      import PrivacyPageukUAUrl from "ASSETS_DIR/locales/uk-UA/PrivacyPage.json?url";

      import ProfileukUAUrl from "ASSETS_DIR/locales/uk-UA/Profile.json?url";

      import ResetApplicationDialogukUAUrl from "ASSETS_DIR/locales/uk-UA/ResetApplicationDialog.json?url";

      import RoomLogoCoverukUAUrl from "ASSETS_DIR/locales/uk-UA/RoomLogoCover.json?url";

      import SMTPSettingsukUAUrl from "ASSETS_DIR/locales/uk-UA/SMTPSettings.json?url";

      import SalesDepartmentRequestDialogukUAUrl from "ASSETS_DIR/locales/uk-UA/SalesDepartmentRequestDialog.json?url";

      import SendInviteDialogukUAUrl from "ASSETS_DIR/locales/uk-UA/SendInviteDialog.json?url";

      import SettingsukUAUrl from "ASSETS_DIR/locales/uk-UA/Settings.json?url";

      import SharingPanelukUAUrl from "ASSETS_DIR/locales/uk-UA/SharingPanel.json?url";

      import SingleSignOnukUAUrl from "ASSETS_DIR/locales/uk-UA/SingleSignOn.json?url";

      import SmartBannerukUAUrl from "ASSETS_DIR/locales/uk-UA/SmartBanner.json?url";

      import SocialAuthWelcomeDialogukUAUrl from "ASSETS_DIR/locales/uk-UA/SocialAuthWelcomeDialog.json?url";

      import TranslationsukUAUrl from "ASSETS_DIR/locales/uk-UA/Translations.json?url";

      import UploadPanelukUAUrl from "ASSETS_DIR/locales/uk-UA/UploadPanel.json?url";

      import VersionHistoryukUAUrl from "ASSETS_DIR/locales/uk-UA/VersionHistory.json?url";

      import WebPluginsukUAUrl from "ASSETS_DIR/locales/uk-UA/WebPlugins.json?url";

      import WebhooksukUAUrl from "ASSETS_DIR/locales/uk-UA/Webhooks.json?url";

      import AboutviUrl from "ASSETS_DIR/locales/vi/About.json?url";

      import ArchiveDialogviUrl from "ASSETS_DIR/locales/vi/ArchiveDialog.json?url";

      import ArticleviUrl from "ASSETS_DIR/locales/vi/Article.json?url";

      import BackupCodesDialogviUrl from "ASSETS_DIR/locales/vi/BackupCodesDialog.json?url";

      import ChangeEmailDialogviUrl from "ASSETS_DIR/locales/vi/ChangeEmailDialog.json?url";

      import ChangePasswordDialogviUrl from "ASSETS_DIR/locales/vi/ChangePasswordDialog.json?url";

      import ChangePhoneDialogviUrl from "ASSETS_DIR/locales/vi/ChangePhoneDialog.json?url";

      import ChangePortalOwnerviUrl from "ASSETS_DIR/locales/vi/ChangePortalOwner.json?url";

      import ChangeUserStatusDialogviUrl from "ASSETS_DIR/locales/vi/ChangeUserStatusDialog.json?url";

      import ChangeUserTypeDialogviUrl from "ASSETS_DIR/locales/vi/ChangeUserTypeDialog.json?url";

      import ConnectDialogviUrl from "ASSETS_DIR/locales/vi/ConnectDialog.json?url";

      import ConvertDialogviUrl from "ASSETS_DIR/locales/vi/ConvertDialog.json?url";

      import ConvertPasswordDialogviUrl from "ASSETS_DIR/locales/vi/ConvertPasswordDialog.json?url";

      import CreateEditRoomDialogviUrl from "ASSETS_DIR/locales/vi/CreateEditRoomDialog.json?url";

      import DataReassignmentDialogviUrl from "ASSETS_DIR/locales/vi/DataReassignmentDialog.json?url";

      import DeleteDialogviUrl from "ASSETS_DIR/locales/vi/DeleteDialog.json?url";

      import DeleteProfileEverDialogviUrl from "ASSETS_DIR/locales/vi/DeleteProfileEverDialog.json?url";

      import DeleteSelfProfileDialogviUrl from "ASSETS_DIR/locales/vi/DeleteSelfProfileDialog.json?url";

      import DeleteThirdPartyDialogviUrl from "ASSETS_DIR/locales/vi/DeleteThirdPartyDialog.json?url";

      import DowngradePlanDialogviUrl from "ASSETS_DIR/locales/vi/DowngradePlanDialog.json?url";

      import EmbeddingPanelviUrl from "ASSETS_DIR/locales/vi/EmbeddingPanel.json?url";

      import EmptyTrashDialogviUrl from "ASSETS_DIR/locales/vi/EmptyTrashDialog.json?url";

      import EmptyViewviUrl from "ASSETS_DIR/locales/vi/EmptyView.json?url";

      import ErrorsviUrl from "ASSETS_DIR/locales/vi/Errors.json?url";

      import FilesviUrl from "ASSETS_DIR/locales/vi/Files.json?url";

      import FilesSettingsviUrl from "ASSETS_DIR/locales/vi/FilesSettings.json?url";

      import FillPDFDialogviUrl from "ASSETS_DIR/locales/vi/FillPDFDialog.json?url";

      import FormFillingTipsDialogviUrl from "ASSETS_DIR/locales/vi/FormFillingTipsDialog.json?url";

      import FormGalleryviUrl from "ASSETS_DIR/locales/vi/FormGallery.json?url";

      import HotkeysPanelviUrl from "ASSETS_DIR/locales/vi/HotkeysPanel.json?url";

      import InfoPanelviUrl from "ASSETS_DIR/locales/vi/InfoPanel.json?url";

      import InviteDialogviUrl from "ASSETS_DIR/locales/vi/InviteDialog.json?url";

      import JavascriptSdkviUrl from "ASSETS_DIR/locales/vi/JavascriptSdk.json?url";

      import LdapviUrl from "ASSETS_DIR/locales/vi/Ldap.json?url";

      import MainBarviUrl from "ASSETS_DIR/locales/vi/MainBar.json?url";

      import NotificationsviUrl from "ASSETS_DIR/locales/vi/Notifications.json?url";

      import OAuthviUrl from "ASSETS_DIR/locales/vi/OAuth.json?url";

      import PDFFormDialogviUrl from "ASSETS_DIR/locales/vi/PDFFormDialog.json?url";

      import PaymentsviUrl from "ASSETS_DIR/locales/vi/Payments.json?url";

      import PaymentsEnterpriseviUrl from "ASSETS_DIR/locales/vi/PaymentsEnterprise.json?url";

      import PeopleviUrl from "ASSETS_DIR/locales/vi/People.json?url";

      import PeopleTranslationsviUrl from "ASSETS_DIR/locales/vi/PeopleTranslations.json?url";

      import PortalUnavailableviUrl from "ASSETS_DIR/locales/vi/PortalUnavailable.json?url";

      import PreparationPortalviUrl from "ASSETS_DIR/locales/vi/PreparationPortal.json?url";

      import PrivacyPageviUrl from "ASSETS_DIR/locales/vi/PrivacyPage.json?url";

      import ProfileviUrl from "ASSETS_DIR/locales/vi/Profile.json?url";

      import ResetApplicationDialogviUrl from "ASSETS_DIR/locales/vi/ResetApplicationDialog.json?url";

      import RoomLogoCoverviUrl from "ASSETS_DIR/locales/vi/RoomLogoCover.json?url";

      import SMTPSettingsviUrl from "ASSETS_DIR/locales/vi/SMTPSettings.json?url";

      import SalesDepartmentRequestDialogviUrl from "ASSETS_DIR/locales/vi/SalesDepartmentRequestDialog.json?url";

      import SendInviteDialogviUrl from "ASSETS_DIR/locales/vi/SendInviteDialog.json?url";

      import SettingsviUrl from "ASSETS_DIR/locales/vi/Settings.json?url";

      import SharingPanelviUrl from "ASSETS_DIR/locales/vi/SharingPanel.json?url";

      import SingleSignOnviUrl from "ASSETS_DIR/locales/vi/SingleSignOn.json?url";

      import SmartBannerviUrl from "ASSETS_DIR/locales/vi/SmartBanner.json?url";

      import SocialAuthWelcomeDialogviUrl from "ASSETS_DIR/locales/vi/SocialAuthWelcomeDialog.json?url";

      import TranslationsviUrl from "ASSETS_DIR/locales/vi/Translations.json?url";

      import UploadPanelviUrl from "ASSETS_DIR/locales/vi/UploadPanel.json?url";

      import VersionHistoryviUrl from "ASSETS_DIR/locales/vi/VersionHistory.json?url";

      import WebPluginsviUrl from "ASSETS_DIR/locales/vi/WebPlugins.json?url";

      import WebhooksviUrl from "ASSETS_DIR/locales/vi/Webhooks.json?url";

      import AboutzhCNUrl from "ASSETS_DIR/locales/zh-CN/About.json?url";

      import ArchiveDialogzhCNUrl from "ASSETS_DIR/locales/zh-CN/ArchiveDialog.json?url";

      import ArticlezhCNUrl from "ASSETS_DIR/locales/zh-CN/Article.json?url";

      import BackupCodesDialogzhCNUrl from "ASSETS_DIR/locales/zh-CN/BackupCodesDialog.json?url";

      import ChangeEmailDialogzhCNUrl from "ASSETS_DIR/locales/zh-CN/ChangeEmailDialog.json?url";

      import ChangePasswordDialogzhCNUrl from "ASSETS_DIR/locales/zh-CN/ChangePasswordDialog.json?url";

      import ChangePhoneDialogzhCNUrl from "ASSETS_DIR/locales/zh-CN/ChangePhoneDialog.json?url";

      import ChangePortalOwnerzhCNUrl from "ASSETS_DIR/locales/zh-CN/ChangePortalOwner.json?url";

      import ChangeUserStatusDialogzhCNUrl from "ASSETS_DIR/locales/zh-CN/ChangeUserStatusDialog.json?url";

      import ChangeUserTypeDialogzhCNUrl from "ASSETS_DIR/locales/zh-CN/ChangeUserTypeDialog.json?url";

      import ConnectDialogzhCNUrl from "ASSETS_DIR/locales/zh-CN/ConnectDialog.json?url";

      import ConvertDialogzhCNUrl from "ASSETS_DIR/locales/zh-CN/ConvertDialog.json?url";

      import ConvertPasswordDialogzhCNUrl from "ASSETS_DIR/locales/zh-CN/ConvertPasswordDialog.json?url";

      import CreateEditRoomDialogzhCNUrl from "ASSETS_DIR/locales/zh-CN/CreateEditRoomDialog.json?url";

      import DataReassignmentDialogzhCNUrl from "ASSETS_DIR/locales/zh-CN/DataReassignmentDialog.json?url";

      import DeleteDialogzhCNUrl from "ASSETS_DIR/locales/zh-CN/DeleteDialog.json?url";

      import DeleteProfileEverDialogzhCNUrl from "ASSETS_DIR/locales/zh-CN/DeleteProfileEverDialog.json?url";

      import DeleteSelfProfileDialogzhCNUrl from "ASSETS_DIR/locales/zh-CN/DeleteSelfProfileDialog.json?url";

      import DeleteThirdPartyDialogzhCNUrl from "ASSETS_DIR/locales/zh-CN/DeleteThirdPartyDialog.json?url";

      import DowngradePlanDialogzhCNUrl from "ASSETS_DIR/locales/zh-CN/DowngradePlanDialog.json?url";

      import EmbeddingPanelzhCNUrl from "ASSETS_DIR/locales/zh-CN/EmbeddingPanel.json?url";

      import EmptyTrashDialogzhCNUrl from "ASSETS_DIR/locales/zh-CN/EmptyTrashDialog.json?url";

      import EmptyViewzhCNUrl from "ASSETS_DIR/locales/zh-CN/EmptyView.json?url";

      import ErrorszhCNUrl from "ASSETS_DIR/locales/zh-CN/Errors.json?url";

      import FileszhCNUrl from "ASSETS_DIR/locales/zh-CN/Files.json?url";

      import FilesSettingszhCNUrl from "ASSETS_DIR/locales/zh-CN/FilesSettings.json?url";

      import FillPDFDialogzhCNUrl from "ASSETS_DIR/locales/zh-CN/FillPDFDialog.json?url";

      import FormFillingTipsDialogzhCNUrl from "ASSETS_DIR/locales/zh-CN/FormFillingTipsDialog.json?url";

      import FormGalleryzhCNUrl from "ASSETS_DIR/locales/zh-CN/FormGallery.json?url";

      import HotkeysPanelzhCNUrl from "ASSETS_DIR/locales/zh-CN/HotkeysPanel.json?url";

      import InfoPanelzhCNUrl from "ASSETS_DIR/locales/zh-CN/InfoPanel.json?url";

      import InviteDialogzhCNUrl from "ASSETS_DIR/locales/zh-CN/InviteDialog.json?url";

      import JavascriptSdkzhCNUrl from "ASSETS_DIR/locales/zh-CN/JavascriptSdk.json?url";

      import LdapzhCNUrl from "ASSETS_DIR/locales/zh-CN/Ldap.json?url";

      import MainBarzhCNUrl from "ASSETS_DIR/locales/zh-CN/MainBar.json?url";

      import NotificationszhCNUrl from "ASSETS_DIR/locales/zh-CN/Notifications.json?url";

      import OAuthzhCNUrl from "ASSETS_DIR/locales/zh-CN/OAuth.json?url";

      import PDFFormDialogzhCNUrl from "ASSETS_DIR/locales/zh-CN/PDFFormDialog.json?url";

      import PaymentszhCNUrl from "ASSETS_DIR/locales/zh-CN/Payments.json?url";

      import PaymentsEnterprisezhCNUrl from "ASSETS_DIR/locales/zh-CN/PaymentsEnterprise.json?url";

      import PeoplezhCNUrl from "ASSETS_DIR/locales/zh-CN/People.json?url";

      import PeopleTranslationszhCNUrl from "ASSETS_DIR/locales/zh-CN/PeopleTranslations.json?url";

      import PortalUnavailablezhCNUrl from "ASSETS_DIR/locales/zh-CN/PortalUnavailable.json?url";

      import PreparationPortalzhCNUrl from "ASSETS_DIR/locales/zh-CN/PreparationPortal.json?url";

      import PrivacyPagezhCNUrl from "ASSETS_DIR/locales/zh-CN/PrivacyPage.json?url";

      import ProfilezhCNUrl from "ASSETS_DIR/locales/zh-CN/Profile.json?url";

      import ResetApplicationDialogzhCNUrl from "ASSETS_DIR/locales/zh-CN/ResetApplicationDialog.json?url";

      import RoomLogoCoverzhCNUrl from "ASSETS_DIR/locales/zh-CN/RoomLogoCover.json?url";

      import SMTPSettingszhCNUrl from "ASSETS_DIR/locales/zh-CN/SMTPSettings.json?url";

      import SalesDepartmentRequestDialogzhCNUrl from "ASSETS_DIR/locales/zh-CN/SalesDepartmentRequestDialog.json?url";

      import SendInviteDialogzhCNUrl from "ASSETS_DIR/locales/zh-CN/SendInviteDialog.json?url";

      import SettingszhCNUrl from "ASSETS_DIR/locales/zh-CN/Settings.json?url";

      import SharingPanelzhCNUrl from "ASSETS_DIR/locales/zh-CN/SharingPanel.json?url";

      import SingleSignOnzhCNUrl from "ASSETS_DIR/locales/zh-CN/SingleSignOn.json?url";

      import SmartBannerzhCNUrl from "ASSETS_DIR/locales/zh-CN/SmartBanner.json?url";

      import SocialAuthWelcomeDialogzhCNUrl from "ASSETS_DIR/locales/zh-CN/SocialAuthWelcomeDialog.json?url";

      import TranslationszhCNUrl from "ASSETS_DIR/locales/zh-CN/Translations.json?url";

      import UploadPanelzhCNUrl from "ASSETS_DIR/locales/zh-CN/UploadPanel.json?url";

      import VersionHistoryzhCNUrl from "ASSETS_DIR/locales/zh-CN/VersionHistory.json?url";

      import WebPluginszhCNUrl from "ASSETS_DIR/locales/zh-CN/WebPlugins.json?url";

      import WebhookszhCNUrl from "ASSETS_DIR/locales/zh-CN/Webhooks.json?url";

      import CommonarSAUrl from "PUBLIC_DIR/locales/ar-SA/Common.json?url";

      import CommonazUrl from "PUBLIC_DIR/locales/az/Common.json?url";

      import CommonbgUrl from "PUBLIC_DIR/locales/bg/Common.json?url";

      import CommoncsUrl from "PUBLIC_DIR/locales/cs/Common.json?url";

      import CommondeUrl from "PUBLIC_DIR/locales/de/Common.json?url";

      import CommonelGRUrl from "PUBLIC_DIR/locales/el-GR/Common.json?url";

      import CommonenUrl from "PUBLIC_DIR/locales/en/Common.json?url";

      import CommonesUrl from "PUBLIC_DIR/locales/es/Common.json?url";

      import CommonfiUrl from "PUBLIC_DIR/locales/fi/Common.json?url";

      import CommonfrUrl from "PUBLIC_DIR/locales/fr/Common.json?url";

      import CommonhyAMUrl from "PUBLIC_DIR/locales/hy-AM/Common.json?url";

      import CommonitUrl from "PUBLIC_DIR/locales/it/Common.json?url";

      import CommonjaJPUrl from "PUBLIC_DIR/locales/ja-JP/Common.json?url";

      import CommonkoKRUrl from "PUBLIC_DIR/locales/ko-KR/Common.json?url";

      import CommonloLAUrl from "PUBLIC_DIR/locales/lo-LA/Common.json?url";

      import CommonlvUrl from "PUBLIC_DIR/locales/lv/Common.json?url";

      import CommonnlUrl from "PUBLIC_DIR/locales/nl/Common.json?url";

      import CommonplUrl from "PUBLIC_DIR/locales/pl/Common.json?url";

      import CommonptUrl from "PUBLIC_DIR/locales/pt/Common.json?url";

      import CommonptBRUrl from "PUBLIC_DIR/locales/pt-BR/Common.json?url";

      import CommonroUrl from "PUBLIC_DIR/locales/ro/Common.json?url";

      import CommonruUrl from "PUBLIC_DIR/locales/ru/Common.json?url";

      import CommonsiUrl from "PUBLIC_DIR/locales/si/Common.json?url";

      import CommonskUrl from "PUBLIC_DIR/locales/sk/Common.json?url";

      import CommonslUrl from "PUBLIC_DIR/locales/sl/Common.json?url";

      import CommonsrCyrlRSUrl from "PUBLIC_DIR/locales/sr-Cyrl-RS/Common.json?url";

      import CommonsrLatnRSUrl from "PUBLIC_DIR/locales/sr-Latn-RS/Common.json?url";

      import CommontrUrl from "PUBLIC_DIR/locales/tr/Common.json?url";

      import CommonukUAUrl from "PUBLIC_DIR/locales/uk-UA/Common.json?url";

      import CommonviUrl from "PUBLIC_DIR/locales/vi/Common.json?url";

      import CommonzhCNUrl from "PUBLIC_DIR/locales/zh-CN/Common.json?url";

 const arSA = new Map([
["About", AboutarSAUrl],
["ArchiveDialog", ArchiveDialogarSAUrl],
["Article", ArticlearSAUrl],
["BackupCodesDialog", BackupCodesDialogarSAUrl],
["ChangeEmailDialog", ChangeEmailDialogarSAUrl],
["ChangePasswordDialog", ChangePasswordDialogarSAUrl],
["ChangePhoneDialog", ChangePhoneDialogarSAUrl],
["ChangePortalOwner", ChangePortalOwnerarSAUrl],
["ChangeUserStatusDialog", ChangeUserStatusDialogarSAUrl],
["ChangeUserTypeDialog", ChangeUserTypeDialogarSAUrl],
["ConnectDialog", ConnectDialogarSAUrl],
["ConvertDialog", ConvertDialogarSAUrl],
["ConvertPasswordDialog", ConvertPasswordDialogarSAUrl],
["CreateEditRoomDialog", CreateEditRoomDialogarSAUrl],
["DataReassignmentDialog", DataReassignmentDialogarSAUrl],
["DeleteDialog", DeleteDialogarSAUrl],
["DeleteProfileEverDialog", DeleteProfileEverDialogarSAUrl],
["DeleteSelfProfileDialog", DeleteSelfProfileDialogarSAUrl],
["DeleteThirdPartyDialog", DeleteThirdPartyDialogarSAUrl],
["DowngradePlanDialog", DowngradePlanDialogarSAUrl],
["EmbeddingPanel", EmbeddingPanelarSAUrl],
["EmptyTrashDialog", EmptyTrashDialogarSAUrl],
["EmptyView", EmptyViewarSAUrl],
["Errors", ErrorsarSAUrl],
["Files", FilesarSAUrl],
["FilesSettings", FilesSettingsarSAUrl],
["FillPDFDialog", FillPDFDialogarSAUrl],
["FormFillingTipsDialog", FormFillingTipsDialogarSAUrl],
["FormGallery", FormGalleryarSAUrl],
["HotkeysPanel", HotkeysPanelarSAUrl],
["InfoPanel", InfoPanelarSAUrl],
["InviteDialog", InviteDialogarSAUrl],
["JavascriptSdk", JavascriptSdkarSAUrl],
["Ldap", LdaparSAUrl],
["MainBar", MainBararSAUrl],
["Notifications", NotificationsarSAUrl],
["OAuth", OAutharSAUrl],
["PDFFormDialog", PDFFormDialogarSAUrl],
["Payments", PaymentsarSAUrl],
["PaymentsEnterprise", PaymentsEnterprisearSAUrl],
["People", PeoplearSAUrl],
["PeopleTranslations", PeopleTranslationsarSAUrl],
["PortalUnavailable", PortalUnavailablearSAUrl],
["PreparationPortal", PreparationPortalarSAUrl],
["PrivacyPage", PrivacyPagearSAUrl],
["Profile", ProfilearSAUrl],
["ResetApplicationDialog", ResetApplicationDialogarSAUrl],
["RoomLogoCover", RoomLogoCoverarSAUrl],
["SMTPSettings", SMTPSettingsarSAUrl],
["SalesDepartmentRequestDialog", SalesDepartmentRequestDialogarSAUrl],
["SendInviteDialog", SendInviteDialogarSAUrl],
["Settings", SettingsarSAUrl],
["SharingPanel", SharingPanelarSAUrl],
["SingleSignOn", SingleSignOnarSAUrl],
["SmartBanner", SmartBannerarSAUrl],
["SocialAuthWelcomeDialog", SocialAuthWelcomeDialogarSAUrl],
["Translations", TranslationsarSAUrl],
["UploadPanel", UploadPanelarSAUrl],
["VersionHistory", VersionHistoryarSAUrl],
["WebPlugins", WebPluginsarSAUrl],
["Webhooks", WebhooksarSAUrl],
["Common", CommonarSAUrl]
]);
 const az = new Map([
["About", AboutazUrl],
["ArchiveDialog", ArchiveDialogazUrl],
["Article", ArticleazUrl],
["BackupCodesDialog", BackupCodesDialogazUrl],
["ChangeEmailDialog", ChangeEmailDialogazUrl],
["ChangePasswordDialog", ChangePasswordDialogazUrl],
["ChangePhoneDialog", ChangePhoneDialogazUrl],
["ChangePortalOwner", ChangePortalOwnerazUrl],
["ChangeUserStatusDialog", ChangeUserStatusDialogazUrl],
["ChangeUserTypeDialog", ChangeUserTypeDialogazUrl],
["ConnectDialog", ConnectDialogazUrl],
["ConvertDialog", ConvertDialogazUrl],
["ConvertPasswordDialog", ConvertPasswordDialogazUrl],
["CreateEditRoomDialog", CreateEditRoomDialogazUrl],
["DataReassignmentDialog", DataReassignmentDialogazUrl],
["DeleteDialog", DeleteDialogazUrl],
["DeleteProfileEverDialog", DeleteProfileEverDialogazUrl],
["DeleteSelfProfileDialog", DeleteSelfProfileDialogazUrl],
["DeleteThirdPartyDialog", DeleteThirdPartyDialogazUrl],
["DowngradePlanDialog", DowngradePlanDialogazUrl],
["EmbeddingPanel", EmbeddingPanelazUrl],
["EmptyTrashDialog", EmptyTrashDialogazUrl],
["EmptyView", EmptyViewazUrl],
["Errors", ErrorsazUrl],
["Files", FilesazUrl],
["FilesSettings", FilesSettingsazUrl],
["FillPDFDialog", FillPDFDialogazUrl],
["FormFillingTipsDialog", FormFillingTipsDialogazUrl],
["FormGallery", FormGalleryazUrl],
["HotkeysPanel", HotkeysPanelazUrl],
["InfoPanel", InfoPanelazUrl],
["InviteDialog", InviteDialogazUrl],
["JavascriptSdk", JavascriptSdkazUrl],
["Ldap", LdapazUrl],
["MainBar", MainBarazUrl],
["Notifications", NotificationsazUrl],
["OAuth", OAuthazUrl],
["PDFFormDialog", PDFFormDialogazUrl],
["Payments", PaymentsazUrl],
["PaymentsEnterprise", PaymentsEnterpriseazUrl],
["People", PeopleazUrl],
["PeopleTranslations", PeopleTranslationsazUrl],
["PortalUnavailable", PortalUnavailableazUrl],
["PreparationPortal", PreparationPortalazUrl],
["PrivacyPage", PrivacyPageazUrl],
["Profile", ProfileazUrl],
["ResetApplicationDialog", ResetApplicationDialogazUrl],
["RoomLogoCover", RoomLogoCoverazUrl],
["SMTPSettings", SMTPSettingsazUrl],
["SalesDepartmentRequestDialog", SalesDepartmentRequestDialogazUrl],
["SendInviteDialog", SendInviteDialogazUrl],
["Settings", SettingsazUrl],
["SharingPanel", SharingPanelazUrl],
["SingleSignOn", SingleSignOnazUrl],
["SmartBanner", SmartBannerazUrl],
["SocialAuthWelcomeDialog", SocialAuthWelcomeDialogazUrl],
["Translations", TranslationsazUrl],
["UploadPanel", UploadPanelazUrl],
["VersionHistory", VersionHistoryazUrl],
["WebPlugins", WebPluginsazUrl],
["Webhooks", WebhooksazUrl],
["Common", CommonazUrl]
]);
 const bg = new Map([
["About", AboutbgUrl],
["ArchiveDialog", ArchiveDialogbgUrl],
["Article", ArticlebgUrl],
["BackupCodesDialog", BackupCodesDialogbgUrl],
["ChangeEmailDialog", ChangeEmailDialogbgUrl],
["ChangePasswordDialog", ChangePasswordDialogbgUrl],
["ChangePhoneDialog", ChangePhoneDialogbgUrl],
["ChangePortalOwner", ChangePortalOwnerbgUrl],
["ChangeUserStatusDialog", ChangeUserStatusDialogbgUrl],
["ChangeUserTypeDialog", ChangeUserTypeDialogbgUrl],
["ConnectDialog", ConnectDialogbgUrl],
["ConvertDialog", ConvertDialogbgUrl],
["ConvertPasswordDialog", ConvertPasswordDialogbgUrl],
["CreateEditRoomDialog", CreateEditRoomDialogbgUrl],
["DataReassignmentDialog", DataReassignmentDialogbgUrl],
["DeleteDialog", DeleteDialogbgUrl],
["DeleteProfileEverDialog", DeleteProfileEverDialogbgUrl],
["DeleteSelfProfileDialog", DeleteSelfProfileDialogbgUrl],
["DeleteThirdPartyDialog", DeleteThirdPartyDialogbgUrl],
["DowngradePlanDialog", DowngradePlanDialogbgUrl],
["EmbeddingPanel", EmbeddingPanelbgUrl],
["EmptyTrashDialog", EmptyTrashDialogbgUrl],
["EmptyView", EmptyViewbgUrl],
["Errors", ErrorsbgUrl],
["Files", FilesbgUrl],
["FilesSettings", FilesSettingsbgUrl],
["FillPDFDialog", FillPDFDialogbgUrl],
["FormFillingTipsDialog", FormFillingTipsDialogbgUrl],
["FormGallery", FormGallerybgUrl],
["HotkeysPanel", HotkeysPanelbgUrl],
["InfoPanel", InfoPanelbgUrl],
["InviteDialog", InviteDialogbgUrl],
["JavascriptSdk", JavascriptSdkbgUrl],
["Ldap", LdapbgUrl],
["MainBar", MainBarbgUrl],
["Notifications", NotificationsbgUrl],
["OAuth", OAuthbgUrl],
["PDFFormDialog", PDFFormDialogbgUrl],
["Payments", PaymentsbgUrl],
["PaymentsEnterprise", PaymentsEnterprisebgUrl],
["People", PeoplebgUrl],
["PeopleTranslations", PeopleTranslationsbgUrl],
["PortalUnavailable", PortalUnavailablebgUrl],
["PreparationPortal", PreparationPortalbgUrl],
["PrivacyPage", PrivacyPagebgUrl],
["Profile", ProfilebgUrl],
["ResetApplicationDialog", ResetApplicationDialogbgUrl],
["RoomLogoCover", RoomLogoCoverbgUrl],
["SMTPSettings", SMTPSettingsbgUrl],
["SalesDepartmentRequestDialog", SalesDepartmentRequestDialogbgUrl],
["SendInviteDialog", SendInviteDialogbgUrl],
["Settings", SettingsbgUrl],
["SharingPanel", SharingPanelbgUrl],
["SingleSignOn", SingleSignOnbgUrl],
["SmartBanner", SmartBannerbgUrl],
["SocialAuthWelcomeDialog", SocialAuthWelcomeDialogbgUrl],
["Translations", TranslationsbgUrl],
["UploadPanel", UploadPanelbgUrl],
["VersionHistory", VersionHistorybgUrl],
["WebPlugins", WebPluginsbgUrl],
["Webhooks", WebhooksbgUrl],
["Common", CommonbgUrl]
]);
 const cs = new Map([
["About", AboutcsUrl],
["ArchiveDialog", ArchiveDialogcsUrl],
["Article", ArticlecsUrl],
["BackupCodesDialog", BackupCodesDialogcsUrl],
["ChangeEmailDialog", ChangeEmailDialogcsUrl],
["ChangePasswordDialog", ChangePasswordDialogcsUrl],
["ChangePhoneDialog", ChangePhoneDialogcsUrl],
["ChangePortalOwner", ChangePortalOwnercsUrl],
["ChangeUserStatusDialog", ChangeUserStatusDialogcsUrl],
["ChangeUserTypeDialog", ChangeUserTypeDialogcsUrl],
["ConnectDialog", ConnectDialogcsUrl],
["ConvertDialog", ConvertDialogcsUrl],
["ConvertPasswordDialog", ConvertPasswordDialogcsUrl],
["CreateEditRoomDialog", CreateEditRoomDialogcsUrl],
["DataReassignmentDialog", DataReassignmentDialogcsUrl],
["DeleteDialog", DeleteDialogcsUrl],
["DeleteProfileEverDialog", DeleteProfileEverDialogcsUrl],
["DeleteSelfProfileDialog", DeleteSelfProfileDialogcsUrl],
["DeleteThirdPartyDialog", DeleteThirdPartyDialogcsUrl],
["DowngradePlanDialog", DowngradePlanDialogcsUrl],
["EmbeddingPanel", EmbeddingPanelcsUrl],
["EmptyTrashDialog", EmptyTrashDialogcsUrl],
["EmptyView", EmptyViewcsUrl],
["Errors", ErrorscsUrl],
["Files", FilescsUrl],
["FilesSettings", FilesSettingscsUrl],
["FillPDFDialog", FillPDFDialogcsUrl],
["FormFillingTipsDialog", FormFillingTipsDialogcsUrl],
["FormGallery", FormGallerycsUrl],
["HotkeysPanel", HotkeysPanelcsUrl],
["InfoPanel", InfoPanelcsUrl],
["InviteDialog", InviteDialogcsUrl],
["JavascriptSdk", JavascriptSdkcsUrl],
["Ldap", LdapcsUrl],
["MainBar", MainBarcsUrl],
["Notifications", NotificationscsUrl],
["OAuth", OAuthcsUrl],
["PDFFormDialog", PDFFormDialogcsUrl],
["Payments", PaymentscsUrl],
["PaymentsEnterprise", PaymentsEnterprisecsUrl],
["People", PeoplecsUrl],
["PeopleTranslations", PeopleTranslationscsUrl],
["PortalUnavailable", PortalUnavailablecsUrl],
["PreparationPortal", PreparationPortalcsUrl],
["PrivacyPage", PrivacyPagecsUrl],
["Profile", ProfilecsUrl],
["ResetApplicationDialog", ResetApplicationDialogcsUrl],
["RoomLogoCover", RoomLogoCovercsUrl],
["SMTPSettings", SMTPSettingscsUrl],
["SalesDepartmentRequestDialog", SalesDepartmentRequestDialogcsUrl],
["SendInviteDialog", SendInviteDialogcsUrl],
["Settings", SettingscsUrl],
["SharingPanel", SharingPanelcsUrl],
["SingleSignOn", SingleSignOncsUrl],
["SmartBanner", SmartBannercsUrl],
["SocialAuthWelcomeDialog", SocialAuthWelcomeDialogcsUrl],
["Translations", TranslationscsUrl],
["UploadPanel", UploadPanelcsUrl],
["VersionHistory", VersionHistorycsUrl],
["WebPlugins", WebPluginscsUrl],
["Webhooks", WebhookscsUrl],
["Common", CommoncsUrl]
]);
 const de = new Map([
["About", AboutdeUrl],
["ArchiveDialog", ArchiveDialogdeUrl],
["Article", ArticledeUrl],
["BackupCodesDialog", BackupCodesDialogdeUrl],
["ChangeEmailDialog", ChangeEmailDialogdeUrl],
["ChangePasswordDialog", ChangePasswordDialogdeUrl],
["ChangePhoneDialog", ChangePhoneDialogdeUrl],
["ChangePortalOwner", ChangePortalOwnerdeUrl],
["ChangeUserStatusDialog", ChangeUserStatusDialogdeUrl],
["ChangeUserTypeDialog", ChangeUserTypeDialogdeUrl],
["ConnectDialog", ConnectDialogdeUrl],
["ConvertDialog", ConvertDialogdeUrl],
["ConvertPasswordDialog", ConvertPasswordDialogdeUrl],
["CreateEditRoomDialog", CreateEditRoomDialogdeUrl],
["DataReassignmentDialog", DataReassignmentDialogdeUrl],
["DeleteDialog", DeleteDialogdeUrl],
["DeleteProfileEverDialog", DeleteProfileEverDialogdeUrl],
["DeleteSelfProfileDialog", DeleteSelfProfileDialogdeUrl],
["DeleteThirdPartyDialog", DeleteThirdPartyDialogdeUrl],
["DowngradePlanDialog", DowngradePlanDialogdeUrl],
["EmbeddingPanel", EmbeddingPaneldeUrl],
["EmptyTrashDialog", EmptyTrashDialogdeUrl],
["EmptyView", EmptyViewdeUrl],
["Errors", ErrorsdeUrl],
["Files", FilesdeUrl],
["FilesSettings", FilesSettingsdeUrl],
["FillPDFDialog", FillPDFDialogdeUrl],
["FormFillingTipsDialog", FormFillingTipsDialogdeUrl],
["FormGallery", FormGallerydeUrl],
["HotkeysPanel", HotkeysPaneldeUrl],
["InfoPanel", InfoPaneldeUrl],
["InviteDialog", InviteDialogdeUrl],
["JavascriptSdk", JavascriptSdkdeUrl],
["Ldap", LdapdeUrl],
["MainBar", MainBardeUrl],
["Notifications", NotificationsdeUrl],
["OAuth", OAuthdeUrl],
["PDFFormDialog", PDFFormDialogdeUrl],
["Payments", PaymentsdeUrl],
["PaymentsEnterprise", PaymentsEnterprisedeUrl],
["People", PeopledeUrl],
["PeopleTranslations", PeopleTranslationsdeUrl],
["PortalUnavailable", PortalUnavailabledeUrl],
["PreparationPortal", PreparationPortaldeUrl],
["PrivacyPage", PrivacyPagedeUrl],
["Profile", ProfiledeUrl],
["ResetApplicationDialog", ResetApplicationDialogdeUrl],
["RoomLogoCover", RoomLogoCoverdeUrl],
["SMTPSettings", SMTPSettingsdeUrl],
["SalesDepartmentRequestDialog", SalesDepartmentRequestDialogdeUrl],
["SendInviteDialog", SendInviteDialogdeUrl],
["Settings", SettingsdeUrl],
["SharingPanel", SharingPaneldeUrl],
["SingleSignOn", SingleSignOndeUrl],
["SmartBanner", SmartBannerdeUrl],
["SocialAuthWelcomeDialog", SocialAuthWelcomeDialogdeUrl],
["Translations", TranslationsdeUrl],
["UploadPanel", UploadPaneldeUrl],
["VersionHistory", VersionHistorydeUrl],
["WebPlugins", WebPluginsdeUrl],
["Webhooks", WebhooksdeUrl],
["Common", CommondeUrl]
]);
 const elGR = new Map([
["About", AboutelGRUrl],
["ArchiveDialog", ArchiveDialogelGRUrl],
["Article", ArticleelGRUrl],
["BackupCodesDialog", BackupCodesDialogelGRUrl],
["ChangeEmailDialog", ChangeEmailDialogelGRUrl],
["ChangePasswordDialog", ChangePasswordDialogelGRUrl],
["ChangePhoneDialog", ChangePhoneDialogelGRUrl],
["ChangePortalOwner", ChangePortalOwnerelGRUrl],
["ChangeUserStatusDialog", ChangeUserStatusDialogelGRUrl],
["ChangeUserTypeDialog", ChangeUserTypeDialogelGRUrl],
["ConnectDialog", ConnectDialogelGRUrl],
["ConvertDialog", ConvertDialogelGRUrl],
["ConvertPasswordDialog", ConvertPasswordDialogelGRUrl],
["CreateEditRoomDialog", CreateEditRoomDialogelGRUrl],
["DataReassignmentDialog", DataReassignmentDialogelGRUrl],
["DeleteDialog", DeleteDialogelGRUrl],
["DeleteProfileEverDialog", DeleteProfileEverDialogelGRUrl],
["DeleteSelfProfileDialog", DeleteSelfProfileDialogelGRUrl],
["DeleteThirdPartyDialog", DeleteThirdPartyDialogelGRUrl],
["DowngradePlanDialog", DowngradePlanDialogelGRUrl],
["EmbeddingPanel", EmbeddingPanelelGRUrl],
["EmptyTrashDialog", EmptyTrashDialogelGRUrl],
["EmptyView", EmptyViewelGRUrl],
["Errors", ErrorselGRUrl],
["Files", FileselGRUrl],
["FilesSettings", FilesSettingselGRUrl],
["FillPDFDialog", FillPDFDialogelGRUrl],
["FormFillingTipsDialog", FormFillingTipsDialogelGRUrl],
["FormGallery", FormGalleryelGRUrl],
["HotkeysPanel", HotkeysPanelelGRUrl],
["InfoPanel", InfoPanelelGRUrl],
["InviteDialog", InviteDialogelGRUrl],
["JavascriptSdk", JavascriptSdkelGRUrl],
["Ldap", LdapelGRUrl],
["MainBar", MainBarelGRUrl],
["Notifications", NotificationselGRUrl],
["OAuth", OAuthelGRUrl],
["PDFFormDialog", PDFFormDialogelGRUrl],
["Payments", PaymentselGRUrl],
["PaymentsEnterprise", PaymentsEnterpriseelGRUrl],
["People", PeopleelGRUrl],
["PeopleTranslations", PeopleTranslationselGRUrl],
["PortalUnavailable", PortalUnavailableelGRUrl],
["PreparationPortal", PreparationPortalelGRUrl],
["PrivacyPage", PrivacyPageelGRUrl],
["Profile", ProfileelGRUrl],
["ResetApplicationDialog", ResetApplicationDialogelGRUrl],
["RoomLogoCover", RoomLogoCoverelGRUrl],
["SMTPSettings", SMTPSettingselGRUrl],
["SalesDepartmentRequestDialog", SalesDepartmentRequestDialogelGRUrl],
["SendInviteDialog", SendInviteDialogelGRUrl],
["Settings", SettingselGRUrl],
["SharingPanel", SharingPanelelGRUrl],
["SingleSignOn", SingleSignOnelGRUrl],
["SmartBanner", SmartBannerelGRUrl],
["SocialAuthWelcomeDialog", SocialAuthWelcomeDialogelGRUrl],
["Translations", TranslationselGRUrl],
["UploadPanel", UploadPanelelGRUrl],
["VersionHistory", VersionHistoryelGRUrl],
["WebPlugins", WebPluginselGRUrl],
["Webhooks", WebhookselGRUrl],
["Common", CommonelGRUrl]
]);
 const en = new Map([
["About", AboutenUrl],
["ArchiveDialog", ArchiveDialogenUrl],
["Article", ArticleenUrl],
["BackupCodesDialog", BackupCodesDialogenUrl],
["ChangeEmailDialog", ChangeEmailDialogenUrl],
["ChangePasswordDialog", ChangePasswordDialogenUrl],
["ChangePhoneDialog", ChangePhoneDialogenUrl],
["ChangePortalOwner", ChangePortalOwnerenUrl],
["ChangeUserStatusDialog", ChangeUserStatusDialogenUrl],
["ChangeUserTypeDialog", ChangeUserTypeDialogenUrl],
["ConnectDialog", ConnectDialogenUrl],
["ConvertDialog", ConvertDialogenUrl],
["ConvertPasswordDialog", ConvertPasswordDialogenUrl],
["CreateEditRoomDialog", CreateEditRoomDialogenUrl],
["DataReassignmentDialog", DataReassignmentDialogenUrl],
["DeleteDialog", DeleteDialogenUrl],
["DeleteProfileEverDialog", DeleteProfileEverDialogenUrl],
["DeleteSelfProfileDialog", DeleteSelfProfileDialogenUrl],
["DeleteThirdPartyDialog", DeleteThirdPartyDialogenUrl],
["DowngradePlanDialog", DowngradePlanDialogenUrl],
["EmbeddingPanel", EmbeddingPanelenUrl],
["EmptyTrashDialog", EmptyTrashDialogenUrl],
["EmptyView", EmptyViewenUrl],
["Errors", ErrorsenUrl],
["Files", FilesenUrl],
["FilesSettings", FilesSettingsenUrl],
["FillPDFDialog", FillPDFDialogenUrl],
["FormFillingTipsDialog", FormFillingTipsDialogenUrl],
["FormGallery", FormGalleryenUrl],
["HotkeysPanel", HotkeysPanelenUrl],
["InfoPanel", InfoPanelenUrl],
["InviteDialog", InviteDialogenUrl],
["JavascriptSdk", JavascriptSdkenUrl],
["Ldap", LdapenUrl],
["MainBar", MainBarenUrl],
["Notifications", NotificationsenUrl],
["OAuth", OAuthenUrl],
["PDFFormDialog", PDFFormDialogenUrl],
["Payments", PaymentsenUrl],
["PaymentsEnterprise", PaymentsEnterpriseenUrl],
["People", PeopleenUrl],
["PeopleTranslations", PeopleTranslationsenUrl],
["PortalUnavailable", PortalUnavailableenUrl],
["PreparationPortal", PreparationPortalenUrl],
["PrivacyPage", PrivacyPageenUrl],
["Profile", ProfileenUrl],
["ResetApplicationDialog", ResetApplicationDialogenUrl],
["RoomLogoCover", RoomLogoCoverenUrl],
["SMTPSettings", SMTPSettingsenUrl],
["SalesDepartmentRequestDialog", SalesDepartmentRequestDialogenUrl],
["SendInviteDialog", SendInviteDialogenUrl],
["Settings", SettingsenUrl],
["SharingPanel", SharingPanelenUrl],
["SingleSignOn", SingleSignOnenUrl],
["SmartBanner", SmartBannerenUrl],
["SocialAuthWelcomeDialog", SocialAuthWelcomeDialogenUrl],
["Translations", TranslationsenUrl],
["UploadPanel", UploadPanelenUrl],
["VersionHistory", VersionHistoryenUrl],
["WebPlugins", WebPluginsenUrl],
["Webhooks", WebhooksenUrl],
["Common", CommonenUrl]
]);
 const es = new Map([
["About", AboutesUrl],
["ArchiveDialog", ArchiveDialogesUrl],
["Article", ArticleesUrl],
["BackupCodesDialog", BackupCodesDialogesUrl],
["ChangeEmailDialog", ChangeEmailDialogesUrl],
["ChangePasswordDialog", ChangePasswordDialogesUrl],
["ChangePhoneDialog", ChangePhoneDialogesUrl],
["ChangePortalOwner", ChangePortalOwneresUrl],
["ChangeUserStatusDialog", ChangeUserStatusDialogesUrl],
["ChangeUserTypeDialog", ChangeUserTypeDialogesUrl],
["ConnectDialog", ConnectDialogesUrl],
["ConvertDialog", ConvertDialogesUrl],
["ConvertPasswordDialog", ConvertPasswordDialogesUrl],
["CreateEditRoomDialog", CreateEditRoomDialogesUrl],
["DataReassignmentDialog", DataReassignmentDialogesUrl],
["DeleteDialog", DeleteDialogesUrl],
["DeleteProfileEverDialog", DeleteProfileEverDialogesUrl],
["DeleteSelfProfileDialog", DeleteSelfProfileDialogesUrl],
["DeleteThirdPartyDialog", DeleteThirdPartyDialogesUrl],
["DowngradePlanDialog", DowngradePlanDialogesUrl],
["EmbeddingPanel", EmbeddingPanelesUrl],
["EmptyTrashDialog", EmptyTrashDialogesUrl],
["EmptyView", EmptyViewesUrl],
["Errors", ErrorsesUrl],
["Files", FilesesUrl],
["FilesSettings", FilesSettingsesUrl],
["FillPDFDialog", FillPDFDialogesUrl],
["FormFillingTipsDialog", FormFillingTipsDialogesUrl],
["FormGallery", FormGalleryesUrl],
["HotkeysPanel", HotkeysPanelesUrl],
["InfoPanel", InfoPanelesUrl],
["InviteDialog", InviteDialogesUrl],
["JavascriptSdk", JavascriptSdkesUrl],
["Ldap", LdapesUrl],
["MainBar", MainBaresUrl],
["Notifications", NotificationsesUrl],
["OAuth", OAuthesUrl],
["PDFFormDialog", PDFFormDialogesUrl],
["Payments", PaymentsesUrl],
["PaymentsEnterprise", PaymentsEnterpriseesUrl],
["People", PeopleesUrl],
["PeopleTranslations", PeopleTranslationsesUrl],
["PortalUnavailable", PortalUnavailableesUrl],
["PreparationPortal", PreparationPortalesUrl],
["PrivacyPage", PrivacyPageesUrl],
["Profile", ProfileesUrl],
["ResetApplicationDialog", ResetApplicationDialogesUrl],
["RoomLogoCover", RoomLogoCoveresUrl],
["SMTPSettings", SMTPSettingsesUrl],
["SalesDepartmentRequestDialog", SalesDepartmentRequestDialogesUrl],
["SendInviteDialog", SendInviteDialogesUrl],
["Settings", SettingsesUrl],
["SharingPanel", SharingPanelesUrl],
["SingleSignOn", SingleSignOnesUrl],
["SmartBanner", SmartBanneresUrl],
["SocialAuthWelcomeDialog", SocialAuthWelcomeDialogesUrl],
["Translations", TranslationsesUrl],
["UploadPanel", UploadPanelesUrl],
["VersionHistory", VersionHistoryesUrl],
["WebPlugins", WebPluginsesUrl],
["Webhooks", WebhooksesUrl],
["Common", CommonesUrl]
]);
 const fi = new Map([
["About", AboutfiUrl],
["ArchiveDialog", ArchiveDialogfiUrl],
["Article", ArticlefiUrl],
["BackupCodesDialog", BackupCodesDialogfiUrl],
["ChangeEmailDialog", ChangeEmailDialogfiUrl],
["ChangePasswordDialog", ChangePasswordDialogfiUrl],
["ChangePhoneDialog", ChangePhoneDialogfiUrl],
["ChangePortalOwner", ChangePortalOwnerfiUrl],
["ChangeUserStatusDialog", ChangeUserStatusDialogfiUrl],
["ChangeUserTypeDialog", ChangeUserTypeDialogfiUrl],
["ConnectDialog", ConnectDialogfiUrl],
["ConvertDialog", ConvertDialogfiUrl],
["ConvertPasswordDialog", ConvertPasswordDialogfiUrl],
["CreateEditRoomDialog", CreateEditRoomDialogfiUrl],
["DataReassignmentDialog", DataReassignmentDialogfiUrl],
["DeleteDialog", DeleteDialogfiUrl],
["DeleteProfileEverDialog", DeleteProfileEverDialogfiUrl],
["DeleteSelfProfileDialog", DeleteSelfProfileDialogfiUrl],
["DeleteThirdPartyDialog", DeleteThirdPartyDialogfiUrl],
["DowngradePlanDialog", DowngradePlanDialogfiUrl],
["EmbeddingPanel", EmbeddingPanelfiUrl],
["EmptyTrashDialog", EmptyTrashDialogfiUrl],
["EmptyView", EmptyViewfiUrl],
["Errors", ErrorsfiUrl],
["Files", FilesfiUrl],
["FilesSettings", FilesSettingsfiUrl],
["FillPDFDialog", FillPDFDialogfiUrl],
["FormFillingTipsDialog", FormFillingTipsDialogfiUrl],
["FormGallery", FormGalleryfiUrl],
["HotkeysPanel", HotkeysPanelfiUrl],
["InfoPanel", InfoPanelfiUrl],
["InviteDialog", InviteDialogfiUrl],
["JavascriptSdk", JavascriptSdkfiUrl],
["Ldap", LdapfiUrl],
["MainBar", MainBarfiUrl],
["Notifications", NotificationsfiUrl],
["OAuth", OAuthfiUrl],
["PDFFormDialog", PDFFormDialogfiUrl],
["Payments", PaymentsfiUrl],
["PaymentsEnterprise", PaymentsEnterprisefiUrl],
["People", PeoplefiUrl],
["PeopleTranslations", PeopleTranslationsfiUrl],
["PortalUnavailable", PortalUnavailablefiUrl],
["PreparationPortal", PreparationPortalfiUrl],
["PrivacyPage", PrivacyPagefiUrl],
["Profile", ProfilefiUrl],
["ResetApplicationDialog", ResetApplicationDialogfiUrl],
["RoomLogoCover", RoomLogoCoverfiUrl],
["SMTPSettings", SMTPSettingsfiUrl],
["SalesDepartmentRequestDialog", SalesDepartmentRequestDialogfiUrl],
["SendInviteDialog", SendInviteDialogfiUrl],
["Settings", SettingsfiUrl],
["SharingPanel", SharingPanelfiUrl],
["SingleSignOn", SingleSignOnfiUrl],
["SmartBanner", SmartBannerfiUrl],
["SocialAuthWelcomeDialog", SocialAuthWelcomeDialogfiUrl],
["Translations", TranslationsfiUrl],
["UploadPanel", UploadPanelfiUrl],
["VersionHistory", VersionHistoryfiUrl],
["WebPlugins", WebPluginsfiUrl],
["Webhooks", WebhooksfiUrl],
["Common", CommonfiUrl]
]);
 const fr = new Map([
["About", AboutfrUrl],
["ArchiveDialog", ArchiveDialogfrUrl],
["Article", ArticlefrUrl],
["BackupCodesDialog", BackupCodesDialogfrUrl],
["ChangeEmailDialog", ChangeEmailDialogfrUrl],
["ChangePasswordDialog", ChangePasswordDialogfrUrl],
["ChangePhoneDialog", ChangePhoneDialogfrUrl],
["ChangePortalOwner", ChangePortalOwnerfrUrl],
["ChangeUserStatusDialog", ChangeUserStatusDialogfrUrl],
["ChangeUserTypeDialog", ChangeUserTypeDialogfrUrl],
["ConnectDialog", ConnectDialogfrUrl],
["ConvertDialog", ConvertDialogfrUrl],
["ConvertPasswordDialog", ConvertPasswordDialogfrUrl],
["CreateEditRoomDialog", CreateEditRoomDialogfrUrl],
["DataReassignmentDialog", DataReassignmentDialogfrUrl],
["DeleteDialog", DeleteDialogfrUrl],
["DeleteProfileEverDialog", DeleteProfileEverDialogfrUrl],
["DeleteSelfProfileDialog", DeleteSelfProfileDialogfrUrl],
["DeleteThirdPartyDialog", DeleteThirdPartyDialogfrUrl],
["DowngradePlanDialog", DowngradePlanDialogfrUrl],
["EmbeddingPanel", EmbeddingPanelfrUrl],
["EmptyTrashDialog", EmptyTrashDialogfrUrl],
["EmptyView", EmptyViewfrUrl],
["Errors", ErrorsfrUrl],
["Files", FilesfrUrl],
["FilesSettings", FilesSettingsfrUrl],
["FillPDFDialog", FillPDFDialogfrUrl],
["FormFillingTipsDialog", FormFillingTipsDialogfrUrl],
["FormGallery", FormGalleryfrUrl],
["HotkeysPanel", HotkeysPanelfrUrl],
["InfoPanel", InfoPanelfrUrl],
["InviteDialog", InviteDialogfrUrl],
["JavascriptSdk", JavascriptSdkfrUrl],
["Ldap", LdapfrUrl],
["MainBar", MainBarfrUrl],
["Notifications", NotificationsfrUrl],
["OAuth", OAuthfrUrl],
["PDFFormDialog", PDFFormDialogfrUrl],
["Payments", PaymentsfrUrl],
["PaymentsEnterprise", PaymentsEnterprisefrUrl],
["People", PeoplefrUrl],
["PeopleTranslations", PeopleTranslationsfrUrl],
["PortalUnavailable", PortalUnavailablefrUrl],
["PreparationPortal", PreparationPortalfrUrl],
["PrivacyPage", PrivacyPagefrUrl],
["Profile", ProfilefrUrl],
["ResetApplicationDialog", ResetApplicationDialogfrUrl],
["RoomLogoCover", RoomLogoCoverfrUrl],
["SMTPSettings", SMTPSettingsfrUrl],
["SalesDepartmentRequestDialog", SalesDepartmentRequestDialogfrUrl],
["SendInviteDialog", SendInviteDialogfrUrl],
["Settings", SettingsfrUrl],
["SharingPanel", SharingPanelfrUrl],
["SingleSignOn", SingleSignOnfrUrl],
["SmartBanner", SmartBannerfrUrl],
["SocialAuthWelcomeDialog", SocialAuthWelcomeDialogfrUrl],
["Translations", TranslationsfrUrl],
["UploadPanel", UploadPanelfrUrl],
["VersionHistory", VersionHistoryfrUrl],
["WebPlugins", WebPluginsfrUrl],
["Webhooks", WebhooksfrUrl],
["Common", CommonfrUrl]
]);
 const hyAM = new Map([
["About", AbouthyAMUrl],
["ArchiveDialog", ArchiveDialoghyAMUrl],
["Article", ArticlehyAMUrl],
["BackupCodesDialog", BackupCodesDialoghyAMUrl],
["ChangeEmailDialog", ChangeEmailDialoghyAMUrl],
["ChangePasswordDialog", ChangePasswordDialoghyAMUrl],
["ChangePhoneDialog", ChangePhoneDialoghyAMUrl],
["ChangePortalOwner", ChangePortalOwnerhyAMUrl],
["ChangeUserStatusDialog", ChangeUserStatusDialoghyAMUrl],
["ChangeUserTypeDialog", ChangeUserTypeDialoghyAMUrl],
["ConnectDialog", ConnectDialoghyAMUrl],
["ConvertDialog", ConvertDialoghyAMUrl],
["ConvertPasswordDialog", ConvertPasswordDialoghyAMUrl],
["CreateEditRoomDialog", CreateEditRoomDialoghyAMUrl],
["DataReassignmentDialog", DataReassignmentDialoghyAMUrl],
["DeleteDialog", DeleteDialoghyAMUrl],
["DeleteProfileEverDialog", DeleteProfileEverDialoghyAMUrl],
["DeleteSelfProfileDialog", DeleteSelfProfileDialoghyAMUrl],
["DeleteThirdPartyDialog", DeleteThirdPartyDialoghyAMUrl],
["DowngradePlanDialog", DowngradePlanDialoghyAMUrl],
["EmbeddingPanel", EmbeddingPanelhyAMUrl],
["EmptyTrashDialog", EmptyTrashDialoghyAMUrl],
["EmptyView", EmptyViewhyAMUrl],
["Errors", ErrorshyAMUrl],
["Files", FileshyAMUrl],
["FilesSettings", FilesSettingshyAMUrl],
["FillPDFDialog", FillPDFDialoghyAMUrl],
["FormFillingTipsDialog", FormFillingTipsDialoghyAMUrl],
["FormGallery", FormGalleryhyAMUrl],
["HotkeysPanel", HotkeysPanelhyAMUrl],
["InfoPanel", InfoPanelhyAMUrl],
["InviteDialog", InviteDialoghyAMUrl],
["JavascriptSdk", JavascriptSdkhyAMUrl],
["Ldap", LdaphyAMUrl],
["MainBar", MainBarhyAMUrl],
["Notifications", NotificationshyAMUrl],
["OAuth", OAuthhyAMUrl],
["PDFFormDialog", PDFFormDialoghyAMUrl],
["Payments", PaymentshyAMUrl],
["PaymentsEnterprise", PaymentsEnterprisehyAMUrl],
["People", PeoplehyAMUrl],
["PeopleTranslations", PeopleTranslationshyAMUrl],
["PortalUnavailable", PortalUnavailablehyAMUrl],
["PreparationPortal", PreparationPortalhyAMUrl],
["PrivacyPage", PrivacyPagehyAMUrl],
["Profile", ProfilehyAMUrl],
["ResetApplicationDialog", ResetApplicationDialoghyAMUrl],
["RoomLogoCover", RoomLogoCoverhyAMUrl],
["SMTPSettings", SMTPSettingshyAMUrl],
["SalesDepartmentRequestDialog", SalesDepartmentRequestDialoghyAMUrl],
["SendInviteDialog", SendInviteDialoghyAMUrl],
["Settings", SettingshyAMUrl],
["SharingPanel", SharingPanelhyAMUrl],
["SingleSignOn", SingleSignOnhyAMUrl],
["SmartBanner", SmartBannerhyAMUrl],
["SocialAuthWelcomeDialog", SocialAuthWelcomeDialoghyAMUrl],
["Translations", TranslationshyAMUrl],
["UploadPanel", UploadPanelhyAMUrl],
["VersionHistory", VersionHistoryhyAMUrl],
["WebPlugins", WebPluginshyAMUrl],
["Webhooks", WebhookshyAMUrl],
["Common", CommonhyAMUrl]
]);
 const it = new Map([
["About", AboutitUrl],
["ArchiveDialog", ArchiveDialogitUrl],
["Article", ArticleitUrl],
["BackupCodesDialog", BackupCodesDialogitUrl],
["ChangeEmailDialog", ChangeEmailDialogitUrl],
["ChangePasswordDialog", ChangePasswordDialogitUrl],
["ChangePhoneDialog", ChangePhoneDialogitUrl],
["ChangePortalOwner", ChangePortalOwneritUrl],
["ChangeUserStatusDialog", ChangeUserStatusDialogitUrl],
["ChangeUserTypeDialog", ChangeUserTypeDialogitUrl],
["ConnectDialog", ConnectDialogitUrl],
["ConvertDialog", ConvertDialogitUrl],
["ConvertPasswordDialog", ConvertPasswordDialogitUrl],
["CreateEditRoomDialog", CreateEditRoomDialogitUrl],
["DataReassignmentDialog", DataReassignmentDialogitUrl],
["DeleteDialog", DeleteDialogitUrl],
["DeleteProfileEverDialog", DeleteProfileEverDialogitUrl],
["DeleteSelfProfileDialog", DeleteSelfProfileDialogitUrl],
["DeleteThirdPartyDialog", DeleteThirdPartyDialogitUrl],
["DowngradePlanDialog", DowngradePlanDialogitUrl],
["EmbeddingPanel", EmbeddingPanelitUrl],
["EmptyTrashDialog", EmptyTrashDialogitUrl],
["EmptyView", EmptyViewitUrl],
["Errors", ErrorsitUrl],
["Files", FilesitUrl],
["FilesSettings", FilesSettingsitUrl],
["FillPDFDialog", FillPDFDialogitUrl],
["FormFillingTipsDialog", FormFillingTipsDialogitUrl],
["FormGallery", FormGalleryitUrl],
["HotkeysPanel", HotkeysPanelitUrl],
["InfoPanel", InfoPanelitUrl],
["InviteDialog", InviteDialogitUrl],
["JavascriptSdk", JavascriptSdkitUrl],
["Ldap", LdapitUrl],
["MainBar", MainBaritUrl],
["Notifications", NotificationsitUrl],
["OAuth", OAuthitUrl],
["PDFFormDialog", PDFFormDialogitUrl],
["Payments", PaymentsitUrl],
["PaymentsEnterprise", PaymentsEnterpriseitUrl],
["People", PeopleitUrl],
["PeopleTranslations", PeopleTranslationsitUrl],
["PortalUnavailable", PortalUnavailableitUrl],
["PreparationPortal", PreparationPortalitUrl],
["PrivacyPage", PrivacyPageitUrl],
["Profile", ProfileitUrl],
["ResetApplicationDialog", ResetApplicationDialogitUrl],
["RoomLogoCover", RoomLogoCoveritUrl],
["SMTPSettings", SMTPSettingsitUrl],
["SalesDepartmentRequestDialog", SalesDepartmentRequestDialogitUrl],
["SendInviteDialog", SendInviteDialogitUrl],
["Settings", SettingsitUrl],
["SharingPanel", SharingPanelitUrl],
["SingleSignOn", SingleSignOnitUrl],
["SmartBanner", SmartBanneritUrl],
["SocialAuthWelcomeDialog", SocialAuthWelcomeDialogitUrl],
["Translations", TranslationsitUrl],
["UploadPanel", UploadPanelitUrl],
["VersionHistory", VersionHistoryitUrl],
["WebPlugins", WebPluginsitUrl],
["Webhooks", WebhooksitUrl],
["Common", CommonitUrl]
]);
 const jaJP = new Map([
["About", AboutjaJPUrl],
["ArchiveDialog", ArchiveDialogjaJPUrl],
["Article", ArticlejaJPUrl],
["BackupCodesDialog", BackupCodesDialogjaJPUrl],
["ChangeEmailDialog", ChangeEmailDialogjaJPUrl],
["ChangePasswordDialog", ChangePasswordDialogjaJPUrl],
["ChangePhoneDialog", ChangePhoneDialogjaJPUrl],
["ChangePortalOwner", ChangePortalOwnerjaJPUrl],
["ChangeUserStatusDialog", ChangeUserStatusDialogjaJPUrl],
["ChangeUserTypeDialog", ChangeUserTypeDialogjaJPUrl],
["ConnectDialog", ConnectDialogjaJPUrl],
["ConvertDialog", ConvertDialogjaJPUrl],
["ConvertPasswordDialog", ConvertPasswordDialogjaJPUrl],
["CreateEditRoomDialog", CreateEditRoomDialogjaJPUrl],
["DataReassignmentDialog", DataReassignmentDialogjaJPUrl],
["DeleteDialog", DeleteDialogjaJPUrl],
["DeleteProfileEverDialog", DeleteProfileEverDialogjaJPUrl],
["DeleteSelfProfileDialog", DeleteSelfProfileDialogjaJPUrl],
["DeleteThirdPartyDialog", DeleteThirdPartyDialogjaJPUrl],
["DowngradePlanDialog", DowngradePlanDialogjaJPUrl],
["EmbeddingPanel", EmbeddingPaneljaJPUrl],
["EmptyTrashDialog", EmptyTrashDialogjaJPUrl],
["EmptyView", EmptyViewjaJPUrl],
["Errors", ErrorsjaJPUrl],
["Files", FilesjaJPUrl],
["FilesSettings", FilesSettingsjaJPUrl],
["FillPDFDialog", FillPDFDialogjaJPUrl],
["FormFillingTipsDialog", FormFillingTipsDialogjaJPUrl],
["FormGallery", FormGalleryjaJPUrl],
["HotkeysPanel", HotkeysPaneljaJPUrl],
["InfoPanel", InfoPaneljaJPUrl],
["InviteDialog", InviteDialogjaJPUrl],
["JavascriptSdk", JavascriptSdkjaJPUrl],
["Ldap", LdapjaJPUrl],
["MainBar", MainBarjaJPUrl],
["Notifications", NotificationsjaJPUrl],
["OAuth", OAuthjaJPUrl],
["PDFFormDialog", PDFFormDialogjaJPUrl],
["Payments", PaymentsjaJPUrl],
["PaymentsEnterprise", PaymentsEnterprisejaJPUrl],
["People", PeoplejaJPUrl],
["PeopleTranslations", PeopleTranslationsjaJPUrl],
["PortalUnavailable", PortalUnavailablejaJPUrl],
["PreparationPortal", PreparationPortaljaJPUrl],
["PrivacyPage", PrivacyPagejaJPUrl],
["Profile", ProfilejaJPUrl],
["ResetApplicationDialog", ResetApplicationDialogjaJPUrl],
["RoomLogoCover", RoomLogoCoverjaJPUrl],
["SMTPSettings", SMTPSettingsjaJPUrl],
["SalesDepartmentRequestDialog", SalesDepartmentRequestDialogjaJPUrl],
["SendInviteDialog", SendInviteDialogjaJPUrl],
["Settings", SettingsjaJPUrl],
["SharingPanel", SharingPaneljaJPUrl],
["SingleSignOn", SingleSignOnjaJPUrl],
["SmartBanner", SmartBannerjaJPUrl],
["SocialAuthWelcomeDialog", SocialAuthWelcomeDialogjaJPUrl],
["Translations", TranslationsjaJPUrl],
["UploadPanel", UploadPaneljaJPUrl],
["VersionHistory", VersionHistoryjaJPUrl],
["WebPlugins", WebPluginsjaJPUrl],
["Webhooks", WebhooksjaJPUrl],
["Common", CommonjaJPUrl]
]);
 const koKR = new Map([
["About", AboutkoKRUrl],
["ArchiveDialog", ArchiveDialogkoKRUrl],
["Article", ArticlekoKRUrl],
["BackupCodesDialog", BackupCodesDialogkoKRUrl],
["ChangeEmailDialog", ChangeEmailDialogkoKRUrl],
["ChangePasswordDialog", ChangePasswordDialogkoKRUrl],
["ChangePhoneDialog", ChangePhoneDialogkoKRUrl],
["ChangePortalOwner", ChangePortalOwnerkoKRUrl],
["ChangeUserStatusDialog", ChangeUserStatusDialogkoKRUrl],
["ChangeUserTypeDialog", ChangeUserTypeDialogkoKRUrl],
["ConnectDialog", ConnectDialogkoKRUrl],
["ConvertDialog", ConvertDialogkoKRUrl],
["ConvertPasswordDialog", ConvertPasswordDialogkoKRUrl],
["CreateEditRoomDialog", CreateEditRoomDialogkoKRUrl],
["DataReassignmentDialog", DataReassignmentDialogkoKRUrl],
["DeleteDialog", DeleteDialogkoKRUrl],
["DeleteProfileEverDialog", DeleteProfileEverDialogkoKRUrl],
["DeleteSelfProfileDialog", DeleteSelfProfileDialogkoKRUrl],
["DeleteThirdPartyDialog", DeleteThirdPartyDialogkoKRUrl],
["DowngradePlanDialog", DowngradePlanDialogkoKRUrl],
["EmbeddingPanel", EmbeddingPanelkoKRUrl],
["EmptyTrashDialog", EmptyTrashDialogkoKRUrl],
["EmptyView", EmptyViewkoKRUrl],
["Errors", ErrorskoKRUrl],
["Files", FileskoKRUrl],
["FilesSettings", FilesSettingskoKRUrl],
["FillPDFDialog", FillPDFDialogkoKRUrl],
["FormFillingTipsDialog", FormFillingTipsDialogkoKRUrl],
["FormGallery", FormGallerykoKRUrl],
["HotkeysPanel", HotkeysPanelkoKRUrl],
["InfoPanel", InfoPanelkoKRUrl],
["InviteDialog", InviteDialogkoKRUrl],
["JavascriptSdk", JavascriptSdkkoKRUrl],
["Ldap", LdapkoKRUrl],
["MainBar", MainBarkoKRUrl],
["Notifications", NotificationskoKRUrl],
["OAuth", OAuthkoKRUrl],
["PDFFormDialog", PDFFormDialogkoKRUrl],
["Payments", PaymentskoKRUrl],
["PaymentsEnterprise", PaymentsEnterprisekoKRUrl],
["People", PeoplekoKRUrl],
["PeopleTranslations", PeopleTranslationskoKRUrl],
["PortalUnavailable", PortalUnavailablekoKRUrl],
["PreparationPortal", PreparationPortalkoKRUrl],
["PrivacyPage", PrivacyPagekoKRUrl],
["Profile", ProfilekoKRUrl],
["ResetApplicationDialog", ResetApplicationDialogkoKRUrl],
["RoomLogoCover", RoomLogoCoverkoKRUrl],
["SMTPSettings", SMTPSettingskoKRUrl],
["SalesDepartmentRequestDialog", SalesDepartmentRequestDialogkoKRUrl],
["SendInviteDialog", SendInviteDialogkoKRUrl],
["Settings", SettingskoKRUrl],
["SharingPanel", SharingPanelkoKRUrl],
["SingleSignOn", SingleSignOnkoKRUrl],
["SmartBanner", SmartBannerkoKRUrl],
["SocialAuthWelcomeDialog", SocialAuthWelcomeDialogkoKRUrl],
["Translations", TranslationskoKRUrl],
["UploadPanel", UploadPanelkoKRUrl],
["VersionHistory", VersionHistorykoKRUrl],
["WebPlugins", WebPluginskoKRUrl],
["Webhooks", WebhookskoKRUrl],
["Common", CommonkoKRUrl]
]);
 const loLA = new Map([
["About", AboutloLAUrl],
["ArchiveDialog", ArchiveDialogloLAUrl],
["Article", ArticleloLAUrl],
["BackupCodesDialog", BackupCodesDialogloLAUrl],
["ChangeEmailDialog", ChangeEmailDialogloLAUrl],
["ChangePasswordDialog", ChangePasswordDialogloLAUrl],
["ChangePhoneDialog", ChangePhoneDialogloLAUrl],
["ChangePortalOwner", ChangePortalOwnerloLAUrl],
["ChangeUserStatusDialog", ChangeUserStatusDialogloLAUrl],
["ChangeUserTypeDialog", ChangeUserTypeDialogloLAUrl],
["ConnectDialog", ConnectDialogloLAUrl],
["ConvertDialog", ConvertDialogloLAUrl],
["ConvertPasswordDialog", ConvertPasswordDialogloLAUrl],
["CreateEditRoomDialog", CreateEditRoomDialogloLAUrl],
["DataReassignmentDialog", DataReassignmentDialogloLAUrl],
["DeleteDialog", DeleteDialogloLAUrl],
["DeleteProfileEverDialog", DeleteProfileEverDialogloLAUrl],
["DeleteSelfProfileDialog", DeleteSelfProfileDialogloLAUrl],
["DeleteThirdPartyDialog", DeleteThirdPartyDialogloLAUrl],
["DowngradePlanDialog", DowngradePlanDialogloLAUrl],
["EmbeddingPanel", EmbeddingPanelloLAUrl],
["EmptyTrashDialog", EmptyTrashDialogloLAUrl],
["EmptyView", EmptyViewloLAUrl],
["Errors", ErrorsloLAUrl],
["Files", FilesloLAUrl],
["FilesSettings", FilesSettingsloLAUrl],
["FillPDFDialog", FillPDFDialogloLAUrl],
["FormFillingTipsDialog", FormFillingTipsDialogloLAUrl],
["FormGallery", FormGalleryloLAUrl],
["HotkeysPanel", HotkeysPanelloLAUrl],
["InfoPanel", InfoPanelloLAUrl],
["InviteDialog", InviteDialogloLAUrl],
["JavascriptSdk", JavascriptSdkloLAUrl],
["Ldap", LdaploLAUrl],
["MainBar", MainBarloLAUrl],
["Notifications", NotificationsloLAUrl],
["OAuth", OAuthloLAUrl],
["PDFFormDialog", PDFFormDialogloLAUrl],
["Payments", PaymentsloLAUrl],
["PaymentsEnterprise", PaymentsEnterpriseloLAUrl],
["People", PeopleloLAUrl],
["PeopleTranslations", PeopleTranslationsloLAUrl],
["PortalUnavailable", PortalUnavailableloLAUrl],
["PreparationPortal", PreparationPortalloLAUrl],
["PrivacyPage", PrivacyPageloLAUrl],
["Profile", ProfileloLAUrl],
["ResetApplicationDialog", ResetApplicationDialogloLAUrl],
["RoomLogoCover", RoomLogoCoverloLAUrl],
["SMTPSettings", SMTPSettingsloLAUrl],
["SalesDepartmentRequestDialog", SalesDepartmentRequestDialogloLAUrl],
["SendInviteDialog", SendInviteDialogloLAUrl],
["Settings", SettingsloLAUrl],
["SharingPanel", SharingPanelloLAUrl],
["SingleSignOn", SingleSignOnloLAUrl],
["SmartBanner", SmartBannerloLAUrl],
["SocialAuthWelcomeDialog", SocialAuthWelcomeDialogloLAUrl],
["Translations", TranslationsloLAUrl],
["UploadPanel", UploadPanelloLAUrl],
["VersionHistory", VersionHistoryloLAUrl],
["WebPlugins", WebPluginsloLAUrl],
["Webhooks", WebhooksloLAUrl],
["Common", CommonloLAUrl]
]);
 const lv = new Map([
["About", AboutlvUrl],
["ArchiveDialog", ArchiveDialoglvUrl],
["Article", ArticlelvUrl],
["BackupCodesDialog", BackupCodesDialoglvUrl],
["ChangeEmailDialog", ChangeEmailDialoglvUrl],
["ChangePasswordDialog", ChangePasswordDialoglvUrl],
["ChangePhoneDialog", ChangePhoneDialoglvUrl],
["ChangePortalOwner", ChangePortalOwnerlvUrl],
["ChangeUserStatusDialog", ChangeUserStatusDialoglvUrl],
["ChangeUserTypeDialog", ChangeUserTypeDialoglvUrl],
["ConnectDialog", ConnectDialoglvUrl],
["ConvertDialog", ConvertDialoglvUrl],
["ConvertPasswordDialog", ConvertPasswordDialoglvUrl],
["CreateEditRoomDialog", CreateEditRoomDialoglvUrl],
["DataReassignmentDialog", DataReassignmentDialoglvUrl],
["DeleteDialog", DeleteDialoglvUrl],
["DeleteProfileEverDialog", DeleteProfileEverDialoglvUrl],
["DeleteSelfProfileDialog", DeleteSelfProfileDialoglvUrl],
["DeleteThirdPartyDialog", DeleteThirdPartyDialoglvUrl],
["DowngradePlanDialog", DowngradePlanDialoglvUrl],
["EmbeddingPanel", EmbeddingPanellvUrl],
["EmptyTrashDialog", EmptyTrashDialoglvUrl],
["EmptyView", EmptyViewlvUrl],
["Errors", ErrorslvUrl],
["Files", FileslvUrl],
["FilesSettings", FilesSettingslvUrl],
["FillPDFDialog", FillPDFDialoglvUrl],
["FormFillingTipsDialog", FormFillingTipsDialoglvUrl],
["FormGallery", FormGallerylvUrl],
["HotkeysPanel", HotkeysPanellvUrl],
["InfoPanel", InfoPanellvUrl],
["InviteDialog", InviteDialoglvUrl],
["JavascriptSdk", JavascriptSdklvUrl],
["Ldap", LdaplvUrl],
["MainBar", MainBarlvUrl],
["Notifications", NotificationslvUrl],
["OAuth", OAuthlvUrl],
["PDFFormDialog", PDFFormDialoglvUrl],
["Payments", PaymentslvUrl],
["PaymentsEnterprise", PaymentsEnterpriselvUrl],
["People", PeoplelvUrl],
["PeopleTranslations", PeopleTranslationslvUrl],
["PortalUnavailable", PortalUnavailablelvUrl],
["PreparationPortal", PreparationPortallvUrl],
["PrivacyPage", PrivacyPagelvUrl],
["Profile", ProfilelvUrl],
["ResetApplicationDialog", ResetApplicationDialoglvUrl],
["RoomLogoCover", RoomLogoCoverlvUrl],
["SMTPSettings", SMTPSettingslvUrl],
["SalesDepartmentRequestDialog", SalesDepartmentRequestDialoglvUrl],
["SendInviteDialog", SendInviteDialoglvUrl],
["Settings", SettingslvUrl],
["SharingPanel", SharingPanellvUrl],
["SingleSignOn", SingleSignOnlvUrl],
["SmartBanner", SmartBannerlvUrl],
["SocialAuthWelcomeDialog", SocialAuthWelcomeDialoglvUrl],
["Translations", TranslationslvUrl],
["UploadPanel", UploadPanellvUrl],
["VersionHistory", VersionHistorylvUrl],
["WebPlugins", WebPluginslvUrl],
["Webhooks", WebhookslvUrl],
["Common", CommonlvUrl]
]);
 const nl = new Map([
["About", AboutnlUrl],
["ArchiveDialog", ArchiveDialognlUrl],
["Article", ArticlenlUrl],
["BackupCodesDialog", BackupCodesDialognlUrl],
["ChangeEmailDialog", ChangeEmailDialognlUrl],
["ChangePasswordDialog", ChangePasswordDialognlUrl],
["ChangePhoneDialog", ChangePhoneDialognlUrl],
["ChangePortalOwner", ChangePortalOwnernlUrl],
["ChangeUserStatusDialog", ChangeUserStatusDialognlUrl],
["ChangeUserTypeDialog", ChangeUserTypeDialognlUrl],
["ConnectDialog", ConnectDialognlUrl],
["ConvertDialog", ConvertDialognlUrl],
["ConvertPasswordDialog", ConvertPasswordDialognlUrl],
["CreateEditRoomDialog", CreateEditRoomDialognlUrl],
["DataReassignmentDialog", DataReassignmentDialognlUrl],
["DeleteDialog", DeleteDialognlUrl],
["DeleteProfileEverDialog", DeleteProfileEverDialognlUrl],
["DeleteSelfProfileDialog", DeleteSelfProfileDialognlUrl],
["DeleteThirdPartyDialog", DeleteThirdPartyDialognlUrl],
["DowngradePlanDialog", DowngradePlanDialognlUrl],
["EmbeddingPanel", EmbeddingPanelnlUrl],
["EmptyTrashDialog", EmptyTrashDialognlUrl],
["EmptyView", EmptyViewnlUrl],
["Errors", ErrorsnlUrl],
["Files", FilesnlUrl],
["FilesSettings", FilesSettingsnlUrl],
["FillPDFDialog", FillPDFDialognlUrl],
["FormFillingTipsDialog", FormFillingTipsDialognlUrl],
["FormGallery", FormGallerynlUrl],
["HotkeysPanel", HotkeysPanelnlUrl],
["InfoPanel", InfoPanelnlUrl],
["InviteDialog", InviteDialognlUrl],
["JavascriptSdk", JavascriptSdknlUrl],
["Ldap", LdapnlUrl],
["MainBar", MainBarnlUrl],
["Notifications", NotificationsnlUrl],
["OAuth", OAuthnlUrl],
["PDFFormDialog", PDFFormDialognlUrl],
["Payments", PaymentsnlUrl],
["PaymentsEnterprise", PaymentsEnterprisenlUrl],
["People", PeoplenlUrl],
["PeopleTranslations", PeopleTranslationsnlUrl],
["PortalUnavailable", PortalUnavailablenlUrl],
["PreparationPortal", PreparationPortalnlUrl],
["PrivacyPage", PrivacyPagenlUrl],
["Profile", ProfilenlUrl],
["ResetApplicationDialog", ResetApplicationDialognlUrl],
["RoomLogoCover", RoomLogoCovernlUrl],
["SMTPSettings", SMTPSettingsnlUrl],
["SalesDepartmentRequestDialog", SalesDepartmentRequestDialognlUrl],
["SendInviteDialog", SendInviteDialognlUrl],
["Settings", SettingsnlUrl],
["SharingPanel", SharingPanelnlUrl],
["SingleSignOn", SingleSignOnnlUrl],
["SmartBanner", SmartBannernlUrl],
["SocialAuthWelcomeDialog", SocialAuthWelcomeDialognlUrl],
["Translations", TranslationsnlUrl],
["UploadPanel", UploadPanelnlUrl],
["VersionHistory", VersionHistorynlUrl],
["WebPlugins", WebPluginsnlUrl],
["Webhooks", WebhooksnlUrl],
["Common", CommonnlUrl]
]);
 const pl = new Map([
["About", AboutplUrl],
["ArchiveDialog", ArchiveDialogplUrl],
["Article", ArticleplUrl],
["BackupCodesDialog", BackupCodesDialogplUrl],
["ChangeEmailDialog", ChangeEmailDialogplUrl],
["ChangePasswordDialog", ChangePasswordDialogplUrl],
["ChangePhoneDialog", ChangePhoneDialogplUrl],
["ChangePortalOwner", ChangePortalOwnerplUrl],
["ChangeUserStatusDialog", ChangeUserStatusDialogplUrl],
["ChangeUserTypeDialog", ChangeUserTypeDialogplUrl],
["ConnectDialog", ConnectDialogplUrl],
["ConvertDialog", ConvertDialogplUrl],
["ConvertPasswordDialog", ConvertPasswordDialogplUrl],
["CreateEditRoomDialog", CreateEditRoomDialogplUrl],
["DataReassignmentDialog", DataReassignmentDialogplUrl],
["DeleteDialog", DeleteDialogplUrl],
["DeleteProfileEverDialog", DeleteProfileEverDialogplUrl],
["DeleteSelfProfileDialog", DeleteSelfProfileDialogplUrl],
["DeleteThirdPartyDialog", DeleteThirdPartyDialogplUrl],
["DowngradePlanDialog", DowngradePlanDialogplUrl],
["EmbeddingPanel", EmbeddingPanelplUrl],
["EmptyTrashDialog", EmptyTrashDialogplUrl],
["EmptyView", EmptyViewplUrl],
["Errors", ErrorsplUrl],
["Files", FilesplUrl],
["FilesSettings", FilesSettingsplUrl],
["FillPDFDialog", FillPDFDialogplUrl],
["FormFillingTipsDialog", FormFillingTipsDialogplUrl],
["FormGallery", FormGalleryplUrl],
["HotkeysPanel", HotkeysPanelplUrl],
["InfoPanel", InfoPanelplUrl],
["InviteDialog", InviteDialogplUrl],
["JavascriptSdk", JavascriptSdkplUrl],
["Ldap", LdapplUrl],
["MainBar", MainBarplUrl],
["Notifications", NotificationsplUrl],
["OAuth", OAuthplUrl],
["PDFFormDialog", PDFFormDialogplUrl],
["Payments", PaymentsplUrl],
["PaymentsEnterprise", PaymentsEnterpriseplUrl],
["People", PeopleplUrl],
["PeopleTranslations", PeopleTranslationsplUrl],
["PortalUnavailable", PortalUnavailableplUrl],
["PreparationPortal", PreparationPortalplUrl],
["PrivacyPage", PrivacyPageplUrl],
["Profile", ProfileplUrl],
["ResetApplicationDialog", ResetApplicationDialogplUrl],
["RoomLogoCover", RoomLogoCoverplUrl],
["SMTPSettings", SMTPSettingsplUrl],
["SalesDepartmentRequestDialog", SalesDepartmentRequestDialogplUrl],
["SendInviteDialog", SendInviteDialogplUrl],
["Settings", SettingsplUrl],
["SharingPanel", SharingPanelplUrl],
["SingleSignOn", SingleSignOnplUrl],
["SmartBanner", SmartBannerplUrl],
["SocialAuthWelcomeDialog", SocialAuthWelcomeDialogplUrl],
["Translations", TranslationsplUrl],
["UploadPanel", UploadPanelplUrl],
["VersionHistory", VersionHistoryplUrl],
["WebPlugins", WebPluginsplUrl],
["Webhooks", WebhooksplUrl],
["Common", CommonplUrl]
]);
 const pt = new Map([
["About", AboutptUrl],
["ArchiveDialog", ArchiveDialogptUrl],
["Article", ArticleptUrl],
["BackupCodesDialog", BackupCodesDialogptUrl],
["ChangeEmailDialog", ChangeEmailDialogptUrl],
["ChangePasswordDialog", ChangePasswordDialogptUrl],
["ChangePhoneDialog", ChangePhoneDialogptUrl],
["ChangePortalOwner", ChangePortalOwnerptUrl],
["ChangeUserStatusDialog", ChangeUserStatusDialogptUrl],
["ChangeUserTypeDialog", ChangeUserTypeDialogptUrl],
["ConnectDialog", ConnectDialogptUrl],
["ConvertDialog", ConvertDialogptUrl],
["ConvertPasswordDialog", ConvertPasswordDialogptUrl],
["CreateEditRoomDialog", CreateEditRoomDialogptUrl],
["DataReassignmentDialog", DataReassignmentDialogptUrl],
["DeleteDialog", DeleteDialogptUrl],
["DeleteProfileEverDialog", DeleteProfileEverDialogptUrl],
["DeleteSelfProfileDialog", DeleteSelfProfileDialogptUrl],
["DeleteThirdPartyDialog", DeleteThirdPartyDialogptUrl],
["DowngradePlanDialog", DowngradePlanDialogptUrl],
["EmbeddingPanel", EmbeddingPanelptUrl],
["EmptyTrashDialog", EmptyTrashDialogptUrl],
["EmptyView", EmptyViewptUrl],
["Errors", ErrorsptUrl],
["Files", FilesptUrl],
["FilesSettings", FilesSettingsptUrl],
["FillPDFDialog", FillPDFDialogptUrl],
["FormFillingTipsDialog", FormFillingTipsDialogptUrl],
["FormGallery", FormGalleryptUrl],
["HotkeysPanel", HotkeysPanelptUrl],
["InfoPanel", InfoPanelptUrl],
["InviteDialog", InviteDialogptUrl],
["JavascriptSdk", JavascriptSdkptUrl],
["Ldap", LdapptUrl],
["MainBar", MainBarptUrl],
["Notifications", NotificationsptUrl],
["OAuth", OAuthptUrl],
["PDFFormDialog", PDFFormDialogptUrl],
["Payments", PaymentsptUrl],
["PaymentsEnterprise", PaymentsEnterpriseptUrl],
["People", PeopleptUrl],
["PeopleTranslations", PeopleTranslationsptUrl],
["PortalUnavailable", PortalUnavailableptUrl],
["PreparationPortal", PreparationPortalptUrl],
["PrivacyPage", PrivacyPageptUrl],
["Profile", ProfileptUrl],
["ResetApplicationDialog", ResetApplicationDialogptUrl],
["RoomLogoCover", RoomLogoCoverptUrl],
["SMTPSettings", SMTPSettingsptUrl],
["SalesDepartmentRequestDialog", SalesDepartmentRequestDialogptUrl],
["SendInviteDialog", SendInviteDialogptUrl],
["Settings", SettingsptUrl],
["SharingPanel", SharingPanelptUrl],
["SingleSignOn", SingleSignOnptUrl],
["SmartBanner", SmartBannerptUrl],
["SocialAuthWelcomeDialog", SocialAuthWelcomeDialogptUrl],
["Translations", TranslationsptUrl],
["UploadPanel", UploadPanelptUrl],
["VersionHistory", VersionHistoryptUrl],
["WebPlugins", WebPluginsptUrl],
["Webhooks", WebhooksptUrl],
["Common", CommonptUrl]
]);
 const ptBR = new Map([
["About", AboutptBRUrl],
["ArchiveDialog", ArchiveDialogptBRUrl],
["Article", ArticleptBRUrl],
["BackupCodesDialog", BackupCodesDialogptBRUrl],
["ChangeEmailDialog", ChangeEmailDialogptBRUrl],
["ChangePasswordDialog", ChangePasswordDialogptBRUrl],
["ChangePhoneDialog", ChangePhoneDialogptBRUrl],
["ChangePortalOwner", ChangePortalOwnerptBRUrl],
["ChangeUserStatusDialog", ChangeUserStatusDialogptBRUrl],
["ChangeUserTypeDialog", ChangeUserTypeDialogptBRUrl],
["ConnectDialog", ConnectDialogptBRUrl],
["ConvertDialog", ConvertDialogptBRUrl],
["ConvertPasswordDialog", ConvertPasswordDialogptBRUrl],
["CreateEditRoomDialog", CreateEditRoomDialogptBRUrl],
["DataReassignmentDialog", DataReassignmentDialogptBRUrl],
["DeleteDialog", DeleteDialogptBRUrl],
["DeleteProfileEverDialog", DeleteProfileEverDialogptBRUrl],
["DeleteSelfProfileDialog", DeleteSelfProfileDialogptBRUrl],
["DeleteThirdPartyDialog", DeleteThirdPartyDialogptBRUrl],
["DowngradePlanDialog", DowngradePlanDialogptBRUrl],
["EmbeddingPanel", EmbeddingPanelptBRUrl],
["EmptyTrashDialog", EmptyTrashDialogptBRUrl],
["EmptyView", EmptyViewptBRUrl],
["Errors", ErrorsptBRUrl],
["Files", FilesptBRUrl],
["FilesSettings", FilesSettingsptBRUrl],
["FillPDFDialog", FillPDFDialogptBRUrl],
["FormFillingTipsDialog", FormFillingTipsDialogptBRUrl],
["FormGallery", FormGalleryptBRUrl],
["HotkeysPanel", HotkeysPanelptBRUrl],
["InfoPanel", InfoPanelptBRUrl],
["InviteDialog", InviteDialogptBRUrl],
["JavascriptSdk", JavascriptSdkptBRUrl],
["Ldap", LdapptBRUrl],
["MainBar", MainBarptBRUrl],
["Notifications", NotificationsptBRUrl],
["OAuth", OAuthptBRUrl],
["PDFFormDialog", PDFFormDialogptBRUrl],
["Payments", PaymentsptBRUrl],
["PaymentsEnterprise", PaymentsEnterpriseptBRUrl],
["People", PeopleptBRUrl],
["PeopleTranslations", PeopleTranslationsptBRUrl],
["PortalUnavailable", PortalUnavailableptBRUrl],
["PreparationPortal", PreparationPortalptBRUrl],
["PrivacyPage", PrivacyPageptBRUrl],
["Profile", ProfileptBRUrl],
["ResetApplicationDialog", ResetApplicationDialogptBRUrl],
["RoomLogoCover", RoomLogoCoverptBRUrl],
["SMTPSettings", SMTPSettingsptBRUrl],
["SalesDepartmentRequestDialog", SalesDepartmentRequestDialogptBRUrl],
["SendInviteDialog", SendInviteDialogptBRUrl],
["Settings", SettingsptBRUrl],
["SharingPanel", SharingPanelptBRUrl],
["SingleSignOn", SingleSignOnptBRUrl],
["SmartBanner", SmartBannerptBRUrl],
["SocialAuthWelcomeDialog", SocialAuthWelcomeDialogptBRUrl],
["Translations", TranslationsptBRUrl],
["UploadPanel", UploadPanelptBRUrl],
["VersionHistory", VersionHistoryptBRUrl],
["WebPlugins", WebPluginsptBRUrl],
["Webhooks", WebhooksptBRUrl],
["Common", CommonptBRUrl]
]);
 const ro = new Map([
["About", AboutroUrl],
["ArchiveDialog", ArchiveDialogroUrl],
["Article", ArticleroUrl],
["BackupCodesDialog", BackupCodesDialogroUrl],
["ChangeEmailDialog", ChangeEmailDialogroUrl],
["ChangePasswordDialog", ChangePasswordDialogroUrl],
["ChangePhoneDialog", ChangePhoneDialogroUrl],
["ChangePortalOwner", ChangePortalOwnerroUrl],
["ChangeUserStatusDialog", ChangeUserStatusDialogroUrl],
["ChangeUserTypeDialog", ChangeUserTypeDialogroUrl],
["ConnectDialog", ConnectDialogroUrl],
["ConvertDialog", ConvertDialogroUrl],
["ConvertPasswordDialog", ConvertPasswordDialogroUrl],
["CreateEditRoomDialog", CreateEditRoomDialogroUrl],
["DataReassignmentDialog", DataReassignmentDialogroUrl],
["DeleteDialog", DeleteDialogroUrl],
["DeleteProfileEverDialog", DeleteProfileEverDialogroUrl],
["DeleteSelfProfileDialog", DeleteSelfProfileDialogroUrl],
["DeleteThirdPartyDialog", DeleteThirdPartyDialogroUrl],
["DowngradePlanDialog", DowngradePlanDialogroUrl],
["EmbeddingPanel", EmbeddingPanelroUrl],
["EmptyTrashDialog", EmptyTrashDialogroUrl],
["EmptyView", EmptyViewroUrl],
["Errors", ErrorsroUrl],
["Files", FilesroUrl],
["FilesSettings", FilesSettingsroUrl],
["FillPDFDialog", FillPDFDialogroUrl],
["FormFillingTipsDialog", FormFillingTipsDialogroUrl],
["FormGallery", FormGalleryroUrl],
["HotkeysPanel", HotkeysPanelroUrl],
["InfoPanel", InfoPanelroUrl],
["InviteDialog", InviteDialogroUrl],
["JavascriptSdk", JavascriptSdkroUrl],
["Ldap", LdaproUrl],
["MainBar", MainBarroUrl],
["Notifications", NotificationsroUrl],
["OAuth", OAuthroUrl],
["PDFFormDialog", PDFFormDialogroUrl],
["Payments", PaymentsroUrl],
["PaymentsEnterprise", PaymentsEnterpriseroUrl],
["People", PeopleroUrl],
["PeopleTranslations", PeopleTranslationsroUrl],
["PortalUnavailable", PortalUnavailableroUrl],
["PreparationPortal", PreparationPortalroUrl],
["PrivacyPage", PrivacyPageroUrl],
["Profile", ProfileroUrl],
["ResetApplicationDialog", ResetApplicationDialogroUrl],
["RoomLogoCover", RoomLogoCoverroUrl],
["SMTPSettings", SMTPSettingsroUrl],
["SalesDepartmentRequestDialog", SalesDepartmentRequestDialogroUrl],
["SendInviteDialog", SendInviteDialogroUrl],
["Settings", SettingsroUrl],
["SharingPanel", SharingPanelroUrl],
["SingleSignOn", SingleSignOnroUrl],
["SmartBanner", SmartBannerroUrl],
["SocialAuthWelcomeDialog", SocialAuthWelcomeDialogroUrl],
["Translations", TranslationsroUrl],
["UploadPanel", UploadPanelroUrl],
["VersionHistory", VersionHistoryroUrl],
["WebPlugins", WebPluginsroUrl],
["Webhooks", WebhooksroUrl],
["Common", CommonroUrl]
]);
 const ru = new Map([
["About", AboutruUrl],
["ArchiveDialog", ArchiveDialogruUrl],
["Article", ArticleruUrl],
["BackupCodesDialog", BackupCodesDialogruUrl],
["ChangeEmailDialog", ChangeEmailDialogruUrl],
["ChangePasswordDialog", ChangePasswordDialogruUrl],
["ChangePhoneDialog", ChangePhoneDialogruUrl],
["ChangePortalOwner", ChangePortalOwnerruUrl],
["ChangeUserStatusDialog", ChangeUserStatusDialogruUrl],
["ChangeUserTypeDialog", ChangeUserTypeDialogruUrl],
["ConnectDialog", ConnectDialogruUrl],
["ConvertDialog", ConvertDialogruUrl],
["ConvertPasswordDialog", ConvertPasswordDialogruUrl],
["CreateEditRoomDialog", CreateEditRoomDialogruUrl],
["DataReassignmentDialog", DataReassignmentDialogruUrl],
["DeleteDialog", DeleteDialogruUrl],
["DeleteProfileEverDialog", DeleteProfileEverDialogruUrl],
["DeleteSelfProfileDialog", DeleteSelfProfileDialogruUrl],
["DeleteThirdPartyDialog", DeleteThirdPartyDialogruUrl],
["DowngradePlanDialog", DowngradePlanDialogruUrl],
["EmbeddingPanel", EmbeddingPanelruUrl],
["EmptyTrashDialog", EmptyTrashDialogruUrl],
["EmptyView", EmptyViewruUrl],
["Errors", ErrorsruUrl],
["Files", FilesruUrl],
["FilesSettings", FilesSettingsruUrl],
["FillPDFDialog", FillPDFDialogruUrl],
["FormFillingTipsDialog", FormFillingTipsDialogruUrl],
["FormGallery", FormGalleryruUrl],
["HotkeysPanel", HotkeysPanelruUrl],
["InfoPanel", InfoPanelruUrl],
["InviteDialog", InviteDialogruUrl],
["JavascriptSdk", JavascriptSdkruUrl],
["Ldap", LdapruUrl],
["MainBar", MainBarruUrl],
["Notifications", NotificationsruUrl],
["OAuth", OAuthruUrl],
["PDFFormDialog", PDFFormDialogruUrl],
["Payments", PaymentsruUrl],
["PaymentsEnterprise", PaymentsEnterpriseruUrl],
["People", PeopleruUrl],
["PeopleTranslations", PeopleTranslationsruUrl],
["PortalUnavailable", PortalUnavailableruUrl],
["PreparationPortal", PreparationPortalruUrl],
["PrivacyPage", PrivacyPageruUrl],
["Profile", ProfileruUrl],
["ResetApplicationDialog", ResetApplicationDialogruUrl],
["RoomLogoCover", RoomLogoCoverruUrl],
["SMTPSettings", SMTPSettingsruUrl],
["SalesDepartmentRequestDialog", SalesDepartmentRequestDialogruUrl],
["SendInviteDialog", SendInviteDialogruUrl],
["Settings", SettingsruUrl],
["SharingPanel", SharingPanelruUrl],
["SingleSignOn", SingleSignOnruUrl],
["SmartBanner", SmartBannerruUrl],
["SocialAuthWelcomeDialog", SocialAuthWelcomeDialogruUrl],
["Translations", TranslationsruUrl],
["UploadPanel", UploadPanelruUrl],
["VersionHistory", VersionHistoryruUrl],
["WebPlugins", WebPluginsruUrl],
["Webhooks", WebhooksruUrl],
["Common", CommonruUrl]
]);
 const si = new Map([
["About", AboutsiUrl],
["ArchiveDialog", ArchiveDialogsiUrl],
["Article", ArticlesiUrl],
["BackupCodesDialog", BackupCodesDialogsiUrl],
["ChangeEmailDialog", ChangeEmailDialogsiUrl],
["ChangePasswordDialog", ChangePasswordDialogsiUrl],
["ChangePhoneDialog", ChangePhoneDialogsiUrl],
["ChangePortalOwner", ChangePortalOwnersiUrl],
["ChangeUserStatusDialog", ChangeUserStatusDialogsiUrl],
["ChangeUserTypeDialog", ChangeUserTypeDialogsiUrl],
["ConnectDialog", ConnectDialogsiUrl],
["ConvertDialog", ConvertDialogsiUrl],
["ConvertPasswordDialog", ConvertPasswordDialogsiUrl],
["CreateEditRoomDialog", CreateEditRoomDialogsiUrl],
["DataReassignmentDialog", DataReassignmentDialogsiUrl],
["DeleteDialog", DeleteDialogsiUrl],
["DeleteProfileEverDialog", DeleteProfileEverDialogsiUrl],
["DeleteSelfProfileDialog", DeleteSelfProfileDialogsiUrl],
["DeleteThirdPartyDialog", DeleteThirdPartyDialogsiUrl],
["DowngradePlanDialog", DowngradePlanDialogsiUrl],
["EmbeddingPanel", EmbeddingPanelsiUrl],
["EmptyTrashDialog", EmptyTrashDialogsiUrl],
["EmptyView", EmptyViewsiUrl],
["Errors", ErrorssiUrl],
["Files", FilessiUrl],
["FilesSettings", FilesSettingssiUrl],
["FillPDFDialog", FillPDFDialogsiUrl],
["FormFillingTipsDialog", FormFillingTipsDialogsiUrl],
["FormGallery", FormGallerysiUrl],
["HotkeysPanel", HotkeysPanelsiUrl],
["InfoPanel", InfoPanelsiUrl],
["InviteDialog", InviteDialogsiUrl],
["JavascriptSdk", JavascriptSdksiUrl],
["Ldap", LdapsiUrl],
["MainBar", MainBarsiUrl],
["Notifications", NotificationssiUrl],
["OAuth", OAuthsiUrl],
["PDFFormDialog", PDFFormDialogsiUrl],
["Payments", PaymentssiUrl],
["PaymentsEnterprise", PaymentsEnterprisesiUrl],
["People", PeoplesiUrl],
["PeopleTranslations", PeopleTranslationssiUrl],
["PortalUnavailable", PortalUnavailablesiUrl],
["PreparationPortal", PreparationPortalsiUrl],
["PrivacyPage", PrivacyPagesiUrl],
["Profile", ProfilesiUrl],
["ResetApplicationDialog", ResetApplicationDialogsiUrl],
["RoomLogoCover", RoomLogoCoversiUrl],
["SMTPSettings", SMTPSettingssiUrl],
["SalesDepartmentRequestDialog", SalesDepartmentRequestDialogsiUrl],
["SendInviteDialog", SendInviteDialogsiUrl],
["Settings", SettingssiUrl],
["SharingPanel", SharingPanelsiUrl],
["SingleSignOn", SingleSignOnsiUrl],
["SmartBanner", SmartBannersiUrl],
["SocialAuthWelcomeDialog", SocialAuthWelcomeDialogsiUrl],
["Translations", TranslationssiUrl],
["UploadPanel", UploadPanelsiUrl],
["VersionHistory", VersionHistorysiUrl],
["WebPlugins", WebPluginssiUrl],
["Webhooks", WebhookssiUrl],
["Common", CommonsiUrl]
]);
 const sk = new Map([
["About", AboutskUrl],
["ArchiveDialog", ArchiveDialogskUrl],
["Article", ArticleskUrl],
["BackupCodesDialog", BackupCodesDialogskUrl],
["ChangeEmailDialog", ChangeEmailDialogskUrl],
["ChangePasswordDialog", ChangePasswordDialogskUrl],
["ChangePhoneDialog", ChangePhoneDialogskUrl],
["ChangePortalOwner", ChangePortalOwnerskUrl],
["ChangeUserStatusDialog", ChangeUserStatusDialogskUrl],
["ChangeUserTypeDialog", ChangeUserTypeDialogskUrl],
["ConnectDialog", ConnectDialogskUrl],
["ConvertDialog", ConvertDialogskUrl],
["ConvertPasswordDialog", ConvertPasswordDialogskUrl],
["CreateEditRoomDialog", CreateEditRoomDialogskUrl],
["DataReassignmentDialog", DataReassignmentDialogskUrl],
["DeleteDialog", DeleteDialogskUrl],
["DeleteProfileEverDialog", DeleteProfileEverDialogskUrl],
["DeleteSelfProfileDialog", DeleteSelfProfileDialogskUrl],
["DeleteThirdPartyDialog", DeleteThirdPartyDialogskUrl],
["DowngradePlanDialog", DowngradePlanDialogskUrl],
["EmbeddingPanel", EmbeddingPanelskUrl],
["EmptyTrashDialog", EmptyTrashDialogskUrl],
["EmptyView", EmptyViewskUrl],
["Errors", ErrorsskUrl],
["Files", FilesskUrl],
["FilesSettings", FilesSettingsskUrl],
["FillPDFDialog", FillPDFDialogskUrl],
["FormFillingTipsDialog", FormFillingTipsDialogskUrl],
["FormGallery", FormGalleryskUrl],
["HotkeysPanel", HotkeysPanelskUrl],
["InfoPanel", InfoPanelskUrl],
["InviteDialog", InviteDialogskUrl],
["JavascriptSdk", JavascriptSdkskUrl],
["Ldap", LdapskUrl],
["MainBar", MainBarskUrl],
["Notifications", NotificationsskUrl],
["OAuth", OAuthskUrl],
["PDFFormDialog", PDFFormDialogskUrl],
["Payments", PaymentsskUrl],
["PaymentsEnterprise", PaymentsEnterpriseskUrl],
["People", PeopleskUrl],
["PeopleTranslations", PeopleTranslationsskUrl],
["PortalUnavailable", PortalUnavailableskUrl],
["PreparationPortal", PreparationPortalskUrl],
["PrivacyPage", PrivacyPageskUrl],
["Profile", ProfileskUrl],
["ResetApplicationDialog", ResetApplicationDialogskUrl],
["RoomLogoCover", RoomLogoCoverskUrl],
["SMTPSettings", SMTPSettingsskUrl],
["SalesDepartmentRequestDialog", SalesDepartmentRequestDialogskUrl],
["SendInviteDialog", SendInviteDialogskUrl],
["Settings", SettingsskUrl],
["SharingPanel", SharingPanelskUrl],
["SingleSignOn", SingleSignOnskUrl],
["SmartBanner", SmartBannerskUrl],
["SocialAuthWelcomeDialog", SocialAuthWelcomeDialogskUrl],
["Translations", TranslationsskUrl],
["UploadPanel", UploadPanelskUrl],
["VersionHistory", VersionHistoryskUrl],
["WebPlugins", WebPluginsskUrl],
["Webhooks", WebhooksskUrl],
["Common", CommonskUrl]
]);
 const sl = new Map([
["About", AboutslUrl],
["ArchiveDialog", ArchiveDialogslUrl],
["Article", ArticleslUrl],
["BackupCodesDialog", BackupCodesDialogslUrl],
["ChangeEmailDialog", ChangeEmailDialogslUrl],
["ChangePasswordDialog", ChangePasswordDialogslUrl],
["ChangePhoneDialog", ChangePhoneDialogslUrl],
["ChangePortalOwner", ChangePortalOwnerslUrl],
["ChangeUserStatusDialog", ChangeUserStatusDialogslUrl],
["ChangeUserTypeDialog", ChangeUserTypeDialogslUrl],
["ConnectDialog", ConnectDialogslUrl],
["ConvertDialog", ConvertDialogslUrl],
["ConvertPasswordDialog", ConvertPasswordDialogslUrl],
["CreateEditRoomDialog", CreateEditRoomDialogslUrl],
["DataReassignmentDialog", DataReassignmentDialogslUrl],
["DeleteDialog", DeleteDialogslUrl],
["DeleteProfileEverDialog", DeleteProfileEverDialogslUrl],
["DeleteSelfProfileDialog", DeleteSelfProfileDialogslUrl],
["DeleteThirdPartyDialog", DeleteThirdPartyDialogslUrl],
["DowngradePlanDialog", DowngradePlanDialogslUrl],
["EmbeddingPanel", EmbeddingPanelslUrl],
["EmptyTrashDialog", EmptyTrashDialogslUrl],
["EmptyView", EmptyViewslUrl],
["Errors", ErrorsslUrl],
["Files", FilesslUrl],
["FilesSettings", FilesSettingsslUrl],
["FillPDFDialog", FillPDFDialogslUrl],
["FormFillingTipsDialog", FormFillingTipsDialogslUrl],
["FormGallery", FormGalleryslUrl],
["HotkeysPanel", HotkeysPanelslUrl],
["InfoPanel", InfoPanelslUrl],
["InviteDialog", InviteDialogslUrl],
["JavascriptSdk", JavascriptSdkslUrl],
["Ldap", LdapslUrl],
["MainBar", MainBarslUrl],
["Notifications", NotificationsslUrl],
["OAuth", OAuthslUrl],
["PDFFormDialog", PDFFormDialogslUrl],
["Payments", PaymentsslUrl],
["PaymentsEnterprise", PaymentsEnterpriseslUrl],
["People", PeopleslUrl],
["PeopleTranslations", PeopleTranslationsslUrl],
["PortalUnavailable", PortalUnavailableslUrl],
["PreparationPortal", PreparationPortalslUrl],
["PrivacyPage", PrivacyPageslUrl],
["Profile", ProfileslUrl],
["ResetApplicationDialog", ResetApplicationDialogslUrl],
["RoomLogoCover", RoomLogoCoverslUrl],
["SMTPSettings", SMTPSettingsslUrl],
["SalesDepartmentRequestDialog", SalesDepartmentRequestDialogslUrl],
["SendInviteDialog", SendInviteDialogslUrl],
["Settings", SettingsslUrl],
["SharingPanel", SharingPanelslUrl],
["SingleSignOn", SingleSignOnslUrl],
["SmartBanner", SmartBannerslUrl],
["SocialAuthWelcomeDialog", SocialAuthWelcomeDialogslUrl],
["Translations", TranslationsslUrl],
["UploadPanel", UploadPanelslUrl],
["VersionHistory", VersionHistoryslUrl],
["WebPlugins", WebPluginsslUrl],
["Webhooks", WebhooksslUrl],
["Common", CommonslUrl]
]);
 const srCyrlRS = new Map([
["About", AboutsrCyrlRSUrl],
["ArchiveDialog", ArchiveDialogsrCyrlRSUrl],
["Article", ArticlesrCyrlRSUrl],
["BackupCodesDialog", BackupCodesDialogsrCyrlRSUrl],
["ChangeEmailDialog", ChangeEmailDialogsrCyrlRSUrl],
["ChangePasswordDialog", ChangePasswordDialogsrCyrlRSUrl],
["ChangePhoneDialog", ChangePhoneDialogsrCyrlRSUrl],
["ChangePortalOwner", ChangePortalOwnersrCyrlRSUrl],
["ChangeUserStatusDialog", ChangeUserStatusDialogsrCyrlRSUrl],
["ChangeUserTypeDialog", ChangeUserTypeDialogsrCyrlRSUrl],
["ConnectDialog", ConnectDialogsrCyrlRSUrl],
["ConvertDialog", ConvertDialogsrCyrlRSUrl],
["ConvertPasswordDialog", ConvertPasswordDialogsrCyrlRSUrl],
["CreateEditRoomDialog", CreateEditRoomDialogsrCyrlRSUrl],
["DataReassignmentDialog", DataReassignmentDialogsrCyrlRSUrl],
["DeleteDialog", DeleteDialogsrCyrlRSUrl],
["DeleteProfileEverDialog", DeleteProfileEverDialogsrCyrlRSUrl],
["DeleteSelfProfileDialog", DeleteSelfProfileDialogsrCyrlRSUrl],
["DeleteThirdPartyDialog", DeleteThirdPartyDialogsrCyrlRSUrl],
["DowngradePlanDialog", DowngradePlanDialogsrCyrlRSUrl],
["EmbeddingPanel", EmbeddingPanelsrCyrlRSUrl],
["EmptyTrashDialog", EmptyTrashDialogsrCyrlRSUrl],
["EmptyView", EmptyViewsrCyrlRSUrl],
["Errors", ErrorssrCyrlRSUrl],
["Files", FilessrCyrlRSUrl],
["FilesSettings", FilesSettingssrCyrlRSUrl],
["FillPDFDialog", FillPDFDialogsrCyrlRSUrl],
["FormFillingTipsDialog", FormFillingTipsDialogsrCyrlRSUrl],
["FormGallery", FormGallerysrCyrlRSUrl],
["HotkeysPanel", HotkeysPanelsrCyrlRSUrl],
["InfoPanel", InfoPanelsrCyrlRSUrl],
["InviteDialog", InviteDialogsrCyrlRSUrl],
["JavascriptSdk", JavascriptSdksrCyrlRSUrl],
["Ldap", LdapsrCyrlRSUrl],
["MainBar", MainBarsrCyrlRSUrl],
["Notifications", NotificationssrCyrlRSUrl],
["OAuth", OAuthsrCyrlRSUrl],
["PDFFormDialog", PDFFormDialogsrCyrlRSUrl],
["Payments", PaymentssrCyrlRSUrl],
["PaymentsEnterprise", PaymentsEnterprisesrCyrlRSUrl],
["People", PeoplesrCyrlRSUrl],
["PeopleTranslations", PeopleTranslationssrCyrlRSUrl],
["PortalUnavailable", PortalUnavailablesrCyrlRSUrl],
["PreparationPortal", PreparationPortalsrCyrlRSUrl],
["PrivacyPage", PrivacyPagesrCyrlRSUrl],
["Profile", ProfilesrCyrlRSUrl],
["ResetApplicationDialog", ResetApplicationDialogsrCyrlRSUrl],
["RoomLogoCover", RoomLogoCoversrCyrlRSUrl],
["SMTPSettings", SMTPSettingssrCyrlRSUrl],
["SalesDepartmentRequestDialog", SalesDepartmentRequestDialogsrCyrlRSUrl],
["SendInviteDialog", SendInviteDialogsrCyrlRSUrl],
["Settings", SettingssrCyrlRSUrl],
["SharingPanel", SharingPanelsrCyrlRSUrl],
["SingleSignOn", SingleSignOnsrCyrlRSUrl],
["SmartBanner", SmartBannersrCyrlRSUrl],
["SocialAuthWelcomeDialog", SocialAuthWelcomeDialogsrCyrlRSUrl],
["Translations", TranslationssrCyrlRSUrl],
["UploadPanel", UploadPanelsrCyrlRSUrl],
["VersionHistory", VersionHistorysrCyrlRSUrl],
["WebPlugins", WebPluginssrCyrlRSUrl],
["Webhooks", WebhookssrCyrlRSUrl],
["Common", CommonsrCyrlRSUrl]
]);
 const srLatnRS = new Map([
["About", AboutsrLatnRSUrl],
["ArchiveDialog", ArchiveDialogsrLatnRSUrl],
["Article", ArticlesrLatnRSUrl],
["BackupCodesDialog", BackupCodesDialogsrLatnRSUrl],
["ChangeEmailDialog", ChangeEmailDialogsrLatnRSUrl],
["ChangePasswordDialog", ChangePasswordDialogsrLatnRSUrl],
["ChangePhoneDialog", ChangePhoneDialogsrLatnRSUrl],
["ChangePortalOwner", ChangePortalOwnersrLatnRSUrl],
["ChangeUserStatusDialog", ChangeUserStatusDialogsrLatnRSUrl],
["ChangeUserTypeDialog", ChangeUserTypeDialogsrLatnRSUrl],
["ConnectDialog", ConnectDialogsrLatnRSUrl],
["ConvertDialog", ConvertDialogsrLatnRSUrl],
["ConvertPasswordDialog", ConvertPasswordDialogsrLatnRSUrl],
["CreateEditRoomDialog", CreateEditRoomDialogsrLatnRSUrl],
["DataReassignmentDialog", DataReassignmentDialogsrLatnRSUrl],
["DeleteDialog", DeleteDialogsrLatnRSUrl],
["DeleteProfileEverDialog", DeleteProfileEverDialogsrLatnRSUrl],
["DeleteSelfProfileDialog", DeleteSelfProfileDialogsrLatnRSUrl],
["DeleteThirdPartyDialog", DeleteThirdPartyDialogsrLatnRSUrl],
["DowngradePlanDialog", DowngradePlanDialogsrLatnRSUrl],
["EmbeddingPanel", EmbeddingPanelsrLatnRSUrl],
["EmptyTrashDialog", EmptyTrashDialogsrLatnRSUrl],
["EmptyView", EmptyViewsrLatnRSUrl],
["Errors", ErrorssrLatnRSUrl],
["Files", FilessrLatnRSUrl],
["FilesSettings", FilesSettingssrLatnRSUrl],
["FillPDFDialog", FillPDFDialogsrLatnRSUrl],
["FormFillingTipsDialog", FormFillingTipsDialogsrLatnRSUrl],
["FormGallery", FormGallerysrLatnRSUrl],
["HotkeysPanel", HotkeysPanelsrLatnRSUrl],
["InfoPanel", InfoPanelsrLatnRSUrl],
["InviteDialog", InviteDialogsrLatnRSUrl],
["JavascriptSdk", JavascriptSdksrLatnRSUrl],
["Ldap", LdapsrLatnRSUrl],
["MainBar", MainBarsrLatnRSUrl],
["Notifications", NotificationssrLatnRSUrl],
["OAuth", OAuthsrLatnRSUrl],
["PDFFormDialog", PDFFormDialogsrLatnRSUrl],
["Payments", PaymentssrLatnRSUrl],
["PaymentsEnterprise", PaymentsEnterprisesrLatnRSUrl],
["People", PeoplesrLatnRSUrl],
["PeopleTranslations", PeopleTranslationssrLatnRSUrl],
["PortalUnavailable", PortalUnavailablesrLatnRSUrl],
["PreparationPortal", PreparationPortalsrLatnRSUrl],
["PrivacyPage", PrivacyPagesrLatnRSUrl],
["Profile", ProfilesrLatnRSUrl],
["ResetApplicationDialog", ResetApplicationDialogsrLatnRSUrl],
["RoomLogoCover", RoomLogoCoversrLatnRSUrl],
["SMTPSettings", SMTPSettingssrLatnRSUrl],
["SalesDepartmentRequestDialog", SalesDepartmentRequestDialogsrLatnRSUrl],
["SendInviteDialog", SendInviteDialogsrLatnRSUrl],
["Settings", SettingssrLatnRSUrl],
["SharingPanel", SharingPanelsrLatnRSUrl],
["SingleSignOn", SingleSignOnsrLatnRSUrl],
["SmartBanner", SmartBannersrLatnRSUrl],
["SocialAuthWelcomeDialog", SocialAuthWelcomeDialogsrLatnRSUrl],
["Translations", TranslationssrLatnRSUrl],
["UploadPanel", UploadPanelsrLatnRSUrl],
["VersionHistory", VersionHistorysrLatnRSUrl],
["WebPlugins", WebPluginssrLatnRSUrl],
["Webhooks", WebhookssrLatnRSUrl],
["Common", CommonsrLatnRSUrl]
]);
 const tr = new Map([
["About", AbouttrUrl],
["ArchiveDialog", ArchiveDialogtrUrl],
["Article", ArticletrUrl],
["BackupCodesDialog", BackupCodesDialogtrUrl],
["ChangeEmailDialog", ChangeEmailDialogtrUrl],
["ChangePasswordDialog", ChangePasswordDialogtrUrl],
["ChangePhoneDialog", ChangePhoneDialogtrUrl],
["ChangePortalOwner", ChangePortalOwnertrUrl],
["ChangeUserStatusDialog", ChangeUserStatusDialogtrUrl],
["ChangeUserTypeDialog", ChangeUserTypeDialogtrUrl],
["ConnectDialog", ConnectDialogtrUrl],
["ConvertDialog", ConvertDialogtrUrl],
["ConvertPasswordDialog", ConvertPasswordDialogtrUrl],
["CreateEditRoomDialog", CreateEditRoomDialogtrUrl],
["DataReassignmentDialog", DataReassignmentDialogtrUrl],
["DeleteDialog", DeleteDialogtrUrl],
["DeleteProfileEverDialog", DeleteProfileEverDialogtrUrl],
["DeleteSelfProfileDialog", DeleteSelfProfileDialogtrUrl],
["DeleteThirdPartyDialog", DeleteThirdPartyDialogtrUrl],
["DowngradePlanDialog", DowngradePlanDialogtrUrl],
["EmbeddingPanel", EmbeddingPaneltrUrl],
["EmptyTrashDialog", EmptyTrashDialogtrUrl],
["EmptyView", EmptyViewtrUrl],
["Errors", ErrorstrUrl],
["Files", FilestrUrl],
["FilesSettings", FilesSettingstrUrl],
["FillPDFDialog", FillPDFDialogtrUrl],
["FormFillingTipsDialog", FormFillingTipsDialogtrUrl],
["FormGallery", FormGallerytrUrl],
["HotkeysPanel", HotkeysPaneltrUrl],
["InfoPanel", InfoPaneltrUrl],
["InviteDialog", InviteDialogtrUrl],
["JavascriptSdk", JavascriptSdktrUrl],
["Ldap", LdaptrUrl],
["MainBar", MainBartrUrl],
["Notifications", NotificationstrUrl],
["OAuth", OAuthtrUrl],
["PDFFormDialog", PDFFormDialogtrUrl],
["Payments", PaymentstrUrl],
["PaymentsEnterprise", PaymentsEnterprisetrUrl],
["People", PeopletrUrl],
["PeopleTranslations", PeopleTranslationstrUrl],
["PortalUnavailable", PortalUnavailabletrUrl],
["PreparationPortal", PreparationPortaltrUrl],
["PrivacyPage", PrivacyPagetrUrl],
["Profile", ProfiletrUrl],
["ResetApplicationDialog", ResetApplicationDialogtrUrl],
["RoomLogoCover", RoomLogoCovertrUrl],
["SMTPSettings", SMTPSettingstrUrl],
["SalesDepartmentRequestDialog", SalesDepartmentRequestDialogtrUrl],
["SendInviteDialog", SendInviteDialogtrUrl],
["Settings", SettingstrUrl],
["SharingPanel", SharingPaneltrUrl],
["SingleSignOn", SingleSignOntrUrl],
["SmartBanner", SmartBannertrUrl],
["SocialAuthWelcomeDialog", SocialAuthWelcomeDialogtrUrl],
["Translations", TranslationstrUrl],
["UploadPanel", UploadPaneltrUrl],
["VersionHistory", VersionHistorytrUrl],
["WebPlugins", WebPluginstrUrl],
["Webhooks", WebhookstrUrl],
["Common", CommontrUrl]
]);
 const ukUA = new Map([
["About", AboutukUAUrl],
["ArchiveDialog", ArchiveDialogukUAUrl],
["Article", ArticleukUAUrl],
["BackupCodesDialog", BackupCodesDialogukUAUrl],
["ChangeEmailDialog", ChangeEmailDialogukUAUrl],
["ChangePasswordDialog", ChangePasswordDialogukUAUrl],
["ChangePhoneDialog", ChangePhoneDialogukUAUrl],
["ChangePortalOwner", ChangePortalOwnerukUAUrl],
["ChangeUserStatusDialog", ChangeUserStatusDialogukUAUrl],
["ChangeUserTypeDialog", ChangeUserTypeDialogukUAUrl],
["ConnectDialog", ConnectDialogukUAUrl],
["ConvertDialog", ConvertDialogukUAUrl],
["ConvertPasswordDialog", ConvertPasswordDialogukUAUrl],
["CreateEditRoomDialog", CreateEditRoomDialogukUAUrl],
["DataReassignmentDialog", DataReassignmentDialogukUAUrl],
["DeleteDialog", DeleteDialogukUAUrl],
["DeleteProfileEverDialog", DeleteProfileEverDialogukUAUrl],
["DeleteSelfProfileDialog", DeleteSelfProfileDialogukUAUrl],
["DeleteThirdPartyDialog", DeleteThirdPartyDialogukUAUrl],
["DowngradePlanDialog", DowngradePlanDialogukUAUrl],
["EmbeddingPanel", EmbeddingPanelukUAUrl],
["EmptyTrashDialog", EmptyTrashDialogukUAUrl],
["EmptyView", EmptyViewukUAUrl],
["Errors", ErrorsukUAUrl],
["Files", FilesukUAUrl],
["FilesSettings", FilesSettingsukUAUrl],
["FillPDFDialog", FillPDFDialogukUAUrl],
["FormFillingTipsDialog", FormFillingTipsDialogukUAUrl],
["FormGallery", FormGalleryukUAUrl],
["HotkeysPanel", HotkeysPanelukUAUrl],
["InfoPanel", InfoPanelukUAUrl],
["InviteDialog", InviteDialogukUAUrl],
["JavascriptSdk", JavascriptSdkukUAUrl],
["Ldap", LdapukUAUrl],
["MainBar", MainBarukUAUrl],
["Notifications", NotificationsukUAUrl],
["OAuth", OAuthukUAUrl],
["PDFFormDialog", PDFFormDialogukUAUrl],
["Payments", PaymentsukUAUrl],
["PaymentsEnterprise", PaymentsEnterpriseukUAUrl],
["People", PeopleukUAUrl],
["PeopleTranslations", PeopleTranslationsukUAUrl],
["PortalUnavailable", PortalUnavailableukUAUrl],
["PreparationPortal", PreparationPortalukUAUrl],
["PrivacyPage", PrivacyPageukUAUrl],
["Profile", ProfileukUAUrl],
["ResetApplicationDialog", ResetApplicationDialogukUAUrl],
["RoomLogoCover", RoomLogoCoverukUAUrl],
["SMTPSettings", SMTPSettingsukUAUrl],
["SalesDepartmentRequestDialog", SalesDepartmentRequestDialogukUAUrl],
["SendInviteDialog", SendInviteDialogukUAUrl],
["Settings", SettingsukUAUrl],
["SharingPanel", SharingPanelukUAUrl],
["SingleSignOn", SingleSignOnukUAUrl],
["SmartBanner", SmartBannerukUAUrl],
["SocialAuthWelcomeDialog", SocialAuthWelcomeDialogukUAUrl],
["Translations", TranslationsukUAUrl],
["UploadPanel", UploadPanelukUAUrl],
["VersionHistory", VersionHistoryukUAUrl],
["WebPlugins", WebPluginsukUAUrl],
["Webhooks", WebhooksukUAUrl],
["Common", CommonukUAUrl]
]);
 const vi = new Map([
["About", AboutviUrl],
["ArchiveDialog", ArchiveDialogviUrl],
["Article", ArticleviUrl],
["BackupCodesDialog", BackupCodesDialogviUrl],
["ChangeEmailDialog", ChangeEmailDialogviUrl],
["ChangePasswordDialog", ChangePasswordDialogviUrl],
["ChangePhoneDialog", ChangePhoneDialogviUrl],
["ChangePortalOwner", ChangePortalOwnerviUrl],
["ChangeUserStatusDialog", ChangeUserStatusDialogviUrl],
["ChangeUserTypeDialog", ChangeUserTypeDialogviUrl],
["ConnectDialog", ConnectDialogviUrl],
["ConvertDialog", ConvertDialogviUrl],
["ConvertPasswordDialog", ConvertPasswordDialogviUrl],
["CreateEditRoomDialog", CreateEditRoomDialogviUrl],
["DataReassignmentDialog", DataReassignmentDialogviUrl],
["DeleteDialog", DeleteDialogviUrl],
["DeleteProfileEverDialog", DeleteProfileEverDialogviUrl],
["DeleteSelfProfileDialog", DeleteSelfProfileDialogviUrl],
["DeleteThirdPartyDialog", DeleteThirdPartyDialogviUrl],
["DowngradePlanDialog", DowngradePlanDialogviUrl],
["EmbeddingPanel", EmbeddingPanelviUrl],
["EmptyTrashDialog", EmptyTrashDialogviUrl],
["EmptyView", EmptyViewviUrl],
["Errors", ErrorsviUrl],
["Files", FilesviUrl],
["FilesSettings", FilesSettingsviUrl],
["FillPDFDialog", FillPDFDialogviUrl],
["FormFillingTipsDialog", FormFillingTipsDialogviUrl],
["FormGallery", FormGalleryviUrl],
["HotkeysPanel", HotkeysPanelviUrl],
["InfoPanel", InfoPanelviUrl],
["InviteDialog", InviteDialogviUrl],
["JavascriptSdk", JavascriptSdkviUrl],
["Ldap", LdapviUrl],
["MainBar", MainBarviUrl],
["Notifications", NotificationsviUrl],
["OAuth", OAuthviUrl],
["PDFFormDialog", PDFFormDialogviUrl],
["Payments", PaymentsviUrl],
["PaymentsEnterprise", PaymentsEnterpriseviUrl],
["People", PeopleviUrl],
["PeopleTranslations", PeopleTranslationsviUrl],
["PortalUnavailable", PortalUnavailableviUrl],
["PreparationPortal", PreparationPortalviUrl],
["PrivacyPage", PrivacyPageviUrl],
["Profile", ProfileviUrl],
["ResetApplicationDialog", ResetApplicationDialogviUrl],
["RoomLogoCover", RoomLogoCoverviUrl],
["SMTPSettings", SMTPSettingsviUrl],
["SalesDepartmentRequestDialog", SalesDepartmentRequestDialogviUrl],
["SendInviteDialog", SendInviteDialogviUrl],
["Settings", SettingsviUrl],
["SharingPanel", SharingPanelviUrl],
["SingleSignOn", SingleSignOnviUrl],
["SmartBanner", SmartBannerviUrl],
["SocialAuthWelcomeDialog", SocialAuthWelcomeDialogviUrl],
["Translations", TranslationsviUrl],
["UploadPanel", UploadPanelviUrl],
["VersionHistory", VersionHistoryviUrl],
["WebPlugins", WebPluginsviUrl],
["Webhooks", WebhooksviUrl],
["Common", CommonviUrl]
]);
 const zhCN = new Map([
["About", AboutzhCNUrl],
["ArchiveDialog", ArchiveDialogzhCNUrl],
["Article", ArticlezhCNUrl],
["BackupCodesDialog", BackupCodesDialogzhCNUrl],
["ChangeEmailDialog", ChangeEmailDialogzhCNUrl],
["ChangePasswordDialog", ChangePasswordDialogzhCNUrl],
["ChangePhoneDialog", ChangePhoneDialogzhCNUrl],
["ChangePortalOwner", ChangePortalOwnerzhCNUrl],
["ChangeUserStatusDialog", ChangeUserStatusDialogzhCNUrl],
["ChangeUserTypeDialog", ChangeUserTypeDialogzhCNUrl],
["ConnectDialog", ConnectDialogzhCNUrl],
["ConvertDialog", ConvertDialogzhCNUrl],
["ConvertPasswordDialog", ConvertPasswordDialogzhCNUrl],
["CreateEditRoomDialog", CreateEditRoomDialogzhCNUrl],
["DataReassignmentDialog", DataReassignmentDialogzhCNUrl],
["DeleteDialog", DeleteDialogzhCNUrl],
["DeleteProfileEverDialog", DeleteProfileEverDialogzhCNUrl],
["DeleteSelfProfileDialog", DeleteSelfProfileDialogzhCNUrl],
["DeleteThirdPartyDialog", DeleteThirdPartyDialogzhCNUrl],
["DowngradePlanDialog", DowngradePlanDialogzhCNUrl],
["EmbeddingPanel", EmbeddingPanelzhCNUrl],
["EmptyTrashDialog", EmptyTrashDialogzhCNUrl],
["EmptyView", EmptyViewzhCNUrl],
["Errors", ErrorszhCNUrl],
["Files", FileszhCNUrl],
["FilesSettings", FilesSettingszhCNUrl],
["FillPDFDialog", FillPDFDialogzhCNUrl],
["FormFillingTipsDialog", FormFillingTipsDialogzhCNUrl],
["FormGallery", FormGalleryzhCNUrl],
["HotkeysPanel", HotkeysPanelzhCNUrl],
["InfoPanel", InfoPanelzhCNUrl],
["InviteDialog", InviteDialogzhCNUrl],
["JavascriptSdk", JavascriptSdkzhCNUrl],
["Ldap", LdapzhCNUrl],
["MainBar", MainBarzhCNUrl],
["Notifications", NotificationszhCNUrl],
["OAuth", OAuthzhCNUrl],
["PDFFormDialog", PDFFormDialogzhCNUrl],
["Payments", PaymentszhCNUrl],
["PaymentsEnterprise", PaymentsEnterprisezhCNUrl],
["People", PeoplezhCNUrl],
["PeopleTranslations", PeopleTranslationszhCNUrl],
["PortalUnavailable", PortalUnavailablezhCNUrl],
["PreparationPortal", PreparationPortalzhCNUrl],
["PrivacyPage", PrivacyPagezhCNUrl],
["Profile", ProfilezhCNUrl],
["ResetApplicationDialog", ResetApplicationDialogzhCNUrl],
["RoomLogoCover", RoomLogoCoverzhCNUrl],
["SMTPSettings", SMTPSettingszhCNUrl],
["SalesDepartmentRequestDialog", SalesDepartmentRequestDialogzhCNUrl],
["SendInviteDialog", SendInviteDialogzhCNUrl],
["Settings", SettingszhCNUrl],
["SharingPanel", SharingPanelzhCNUrl],
["SingleSignOn", SingleSignOnzhCNUrl],
["SmartBanner", SmartBannerzhCNUrl],
["SocialAuthWelcomeDialog", SocialAuthWelcomeDialogzhCNUrl],
["Translations", TranslationszhCNUrl],
["UploadPanel", UploadPanelzhCNUrl],
["VersionHistory", VersionHistoryzhCNUrl],
["WebPlugins", WebPluginszhCNUrl],
["Webhooks", WebhookszhCNUrl],
["Common", CommonzhCNUrl]
]);
 export const translations = new Map([
["ar-SA", arSA],
["az", az],
["bg", bg],
["cs", cs],
["de", de],
["el-GR", elGR],
["en", en],
["es", es],
["fi", fi],
["fr", fr],
["hy-AM", hyAM],
["it", it],
["ja-JP", jaJP],
["ko-KR", koKR],
["lo-LA", loLA],
["lv", lv],
["nl", nl],
["pl", pl],
["pt", pt],
["pt-BR", ptBR],
["ro", ro],
["ru", ru],
["si", si],
["sk", sk],
["sl", sl],
["sr-Cyrl-RS", srCyrlRS],
["sr-Latn-RS", srLatnRS],
["tr", tr],
["uk-UA", ukUA],
["vi", vi],
["zh-CN", zhCN],
]);